import { ISOs as IsoCountryCode } from 'utils/form/constants';
import { RBIPlatform as Platform } from 'utils/environment/types';
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
}









/** A First Data or Adyen account (payment method) will have either credit or prepaid but not both */
export interface IAccount {
  readonly __typename?: 'Account',
  /** Id of First Data or Adyen account */
  readonly accountIdentifier: Maybe<Scalars['String']>,
  /** First Data account ID */
  readonly fdAccountId: Maybe<Scalars['String']>,
  /** Used for making cc direct payments with chase (TH) */
  readonly chaseProfileId: Maybe<Scalars['String']>,
  readonly credit: Maybe<ICreditCard>,
  readonly prepaid: Maybe<IGiftCard>,
}

export interface IAccountListResponse {
  readonly __typename?: 'AccountListResponse',
  readonly count: Scalars['Int'],
  readonly accounts: Maybe<ReadonlyArray<Maybe<IAccount>>>,
  readonly defaultAccount: Maybe<IAccount>,
  readonly paymentProcessor: Maybe<PaymentProcessor>,
}

/** Add a First Data account (payment method) for the current user */
export interface IAddAccountInput {
  /** billingAddress associated to card */
  readonly billingAddress?: Maybe<IBillingAddressInput>,
  /** Access token which was used to request nonce */
  readonly fdAccessToken: Scalars['String'],
  /** Nonce provided by FD linking to the new payment method */
  readonly fdNonce: Scalars['String'],
  /** First 6 digits of credit card */
  readonly ccBin: Scalars['String'],
  /** Name On Card */
  readonly fullName?: Maybe<Scalars['String']>,
  /** cc token from tokenex required for chase direct pay enrollment */
  readonly ccToken?: Maybe<Scalars['String']>,
  /** chase id from TH endpoint to add to DynamoDB */
  readonly chaseProfileId?: Maybe<Scalars['String']>,
  /** cc security code */
  readonly cvv?: Maybe<Scalars['String']>,
  /** Session ID as set by the FE. This should be derived from mParticle. */
  readonly sessionId?: Maybe<Scalars['String']>,
  /** Make this new account the user's default account */
  readonly makeDefault?: Maybe<Scalars['Boolean']>,
}

/** Add Adyen (payment method) for the current user */
export interface IAddAdyenAccountInput {
  /** Encrypted Payment Payload */
  readonly encryptedPayload: IAdyenEncryptedInfo,
}

/** Add payment method for the current user */
export interface IAddCreditAccountInput {
  readonly adyenInput?: Maybe<IAddAdyenAccountInput>,
  /** billingAddress associated to card */
  readonly billingAddress: IBillingAddressInput,
  readonly firstDataInput?: Maybe<IAddAccountInput>,
  /** Name on credit card */
  readonly fullName: Scalars['String'],
  /** (TH only) Make this new account the user's default account */
  readonly makeDefault?: Maybe<Scalars['Boolean']>,
}

/** Add a gift account (payment method) for the current user */
export interface IAddGiftAccountInput {
  /** Amount to fund to gift card account in cents */
  readonly fundValue: Scalars['Int'],
  /** 
 * Vaulted first data Account ID (credit) used to fund gift card.
   * Either this or applePayDetails is required.
 */
  readonly fdAccountId?: Maybe<Scalars['String']>,
  /** Details from Apple Pay for funding. */
  readonly applePayDetails?: Maybe<IApplePay>,
  /** Details from Goole Pay for funding. */
  readonly googlePayDetails?: Maybe<IGooglePay>,
  /** 
 * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
 */
  readonly kountSessionId?: Maybe<Scalars['String']>,
  /** 
 * Session ID as set by the FE.
   * 
   * Note that the "sessionId" field is deprecated and will be ignored.
 */
  readonly sessionId?: Maybe<Scalars['String']>,
}

export interface IAdyenEncryptedInfo {
  /** Encrypted credit card number */
  readonly encryptedCN: Scalars['String'],
  /** Encrypted credit card expiry month */
  readonly encryptedEM: Scalars['String'],
  /** Encrypted credit card expiry year */
  readonly encryptedEY: Scalars['String'],
  /** Encrypted credit card security code */
  readonly encryptedSC: Scalars['String'],
}

export interface IAdyenPayment {
  /** 
 * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or
   * encrypted payload is required.
 */
  readonly accountIdentifier?: Maybe<Scalars['String']>,
  /** Encrypted Payment Payload. If accountIdentifier is not passed this will be used. */
  readonly encryptedPayload?: Maybe<IAdyenEncryptedInfo>,
  /** Denotes the payment type */
  readonly paymentType?: Maybe<AdyenPaymentType>,
  /** When true, payment details will be saved as a recurring payment method in Adyen */
  readonly savePaymentMethod?: Maybe<Scalars['Boolean']>,
}

export enum AdyenPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  TOKENIZED_CREDIT_CARD = 'TOKENIZED_CREDIT_CARD'
}

export interface IApiMetadata {
  readonly __typename?: 'ApiMetadata',
  /** Pong! Simple health check. */
  readonly ping: Scalars['String'],
}

/** Details from Apple Pay used for Apple Pay funding. */
export interface IApplePay {
  /** Signature as passed through from Apple Pay */
  readonly signature: Scalars['String'],
  /** Application data as passed through from Apple Pay */
  readonly applicationData: Scalars['String'],
  /** part of the billing address from apple pay */
  readonly country: CountryCode,
  readonly data: Scalars['String'],
  readonly decryptAlias: Scalars['String'],
  readonly ephemeralPublicKey: Scalars['String'],
  readonly formatted: Scalars['String'],
  readonly primary: Scalars['Boolean'],
  readonly publicKeyHash: Scalars['String'],
  readonly transactionId: Scalars['String'],
  /** type of the billing address set in apple pay e.g. work, home, etc */
  readonly type: Scalars['String'],
  readonly version: Scalars['String'],
  readonly billingAddress: IBillingAddressInput,
  /** bundle all apple pay details into an encrypted token. */
  readonly paymentData?: Maybe<Scalars['String']>,
  /** Data of the payment method used for Apple Pay. */
  readonly PaymentMethodData?: Maybe<IPaymentMethodData>,
}

export interface IAppliedOffer {
  readonly id?: Maybe<Scalars['ID']>,
  readonly cartId?: Maybe<Scalars['ID']>,
  readonly swap?: Maybe<ISwapInput>,
  readonly type?: Maybe<OfferType>,
}

export interface IAppliedReward {
  readonly cartId: Scalars['ID'],
  readonly rewardId: Scalars['ID'],
  readonly timesApplied: Scalars['Int'],
}

/** A Prepaid balance response (payment method) */
export interface IBalance {
  readonly __typename?: 'Balance',
  /** gift card last 4 digits */
  readonly alias: Scalars['String'],
  /** dollar amount gift card begins with */
  readonly beginBalance: Scalars['Int'],
  readonly currencyCode: Scalars['String'],
  /** current gift card balance in cents */
  readonly currentBalance: Scalars['Int'],
  readonly expiryMonth: Scalars['String'],
  readonly expiryYear: Scalars['String'],
  readonly fdCorrelationId: Maybe<Scalars['String']>,
}

export interface IBillingAddress {
  readonly __typename?: 'BillingAddress',
  /** City */
  readonly locality: Scalars['String'],
  /** Zip Code */
  readonly postalCode: Scalars['String'],
  /** State */
  readonly region: Scalars['String'],
  /** Street Address */
  readonly streetAddress: Scalars['String'],
  /** Apt or Unit Number */
  readonly unitNumber: Maybe<Scalars['String']>,
}

export interface IBillingAddressInput {
  /** City */
  readonly locality?: Maybe<Scalars['String']>,
  /** Zip Code */
  readonly postalCode: Scalars['String'],
  /** State */
  readonly region?: Maybe<Scalars['String']>,
  /** Street Address */
  readonly streetAddress?: Maybe<Scalars['String']>,
  /** Apt or Unit Number */
  readonly unitNumber?: Maybe<Scalars['String']>,
  /** Country */
  readonly country?: Maybe<Scalars['String']>,
}

export enum Brand {
  BK = 'BK',
  PLK = 'PLK',
  TH = 'TH'
}

export interface ICart {
  readonly __typename?: 'Cart',
  readonly brand: Brand,
  readonly cartEntries: Maybe<ReadonlyArray<ICartEntries>>,
  /** 
 * Cart entries for reordering.
   * This is usually the same as cartEntries except for when there are swaps.
 */
  readonly reorderCartEntries: Maybe<ReadonlyArray<ICartEntries>>,
  readonly cartVersion: Maybe<Scalars['Int']>,
  readonly customerLocale: Maybe<Scalars['String']>,
  readonly customerName: Scalars['String'],
  readonly deviceOS: Maybe<Scalars['String']>,
  readonly discounts: Maybe<ReadonlyArray<Maybe<IDiscount>>>,
  readonly fees: Maybe<ReadonlyArray<Maybe<IFees>>>,
  /** All evaluated offers in the cart, or all the offers supplied against the cart. */
  readonly offersFeedback: Maybe<ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>>,
  readonly payment: Maybe<IPayment>,
  readonly platform: Maybe<Platform>,
  readonly posVendor: PosVendor,
  /** ISO Timestamp from POS in local timezone e.g 2019-07-08T23:02:17.203Z */
  readonly processedAt: Maybe<Scalars['String']>,
  readonly appliedOffers: Maybe<ReadonlyArray<Maybe<ICartAppliedOffer>>>,
  readonly requestedAmountCents: Scalars['Int'],
  readonly rewardsApplied: Maybe<ReadonlyArray<Maybe<ICartAppliedReward>>>,
  readonly serviceMode: ServiceMode,
  readonly storeAddress: IStoreAddress,
  readonly storeDetails: Maybe<IStoreDetails>,
  readonly storeId: Scalars['String'],
  readonly storePosId: Maybe<Scalars['String']>,
  readonly swaps: Maybe<ReadonlyArray<Maybe<ISwap>>>,
  readonly subTotalCents: Maybe<Scalars['Int']>,
  readonly taxCents: Maybe<Scalars['Int']>,
  readonly ticketNumber: Maybe<Scalars['String']>,
  readonly totalCents: Maybe<Scalars['Int']>,
  readonly unavailableCartEntries: Maybe<ReadonlyArray<Maybe<IUnavailableCartEntry>>>,
  readonly userDetails: Maybe<IUserDetails>,
  readonly userId: Maybe<Scalars['String']>,
  readonly wasLoyaltyEarned: Maybe<Scalars['Boolean']>,
  readonly vatNumber: Maybe<Scalars['String']>,
}

export interface ICartAppliedOffer {
  readonly __typename?: 'CartAppliedOffer',
  readonly id: Scalars['ID'],
  readonly cartId: Maybe<Scalars['ID']>,
  readonly swap: Maybe<ISwap>,
  readonly type: OfferType,
}

/** AppliedReward is duplicated here to avoid breaking changes as above definition serves as an input. */
export interface ICartAppliedReward {
  readonly __typename?: 'CartAppliedReward',
  readonly cartId: Scalars['ID'],
  readonly rewardId: Scalars['ID'],
  readonly timesApplied: Scalars['Int'],
}

export interface ICartEntries {
  readonly __typename?: 'CartEntries',
  readonly children: Maybe<ReadonlyArray<Maybe<ICartEntries>>>,
  readonly image: Maybe<Scalars['String']>,
  readonly lineId: Scalars['String'],
  readonly name: Maybe<Scalars['String']>,
  readonly offerVendorConfigs: Maybe<IVendorConfigs>,
  readonly pickerSelections: Maybe<Scalars['String']>,
  readonly plu: Maybe<IPlu>,
  readonly price: Maybe<Scalars['Int']>,
  readonly quantity: Scalars['Int'],
  readonly redeemable: Maybe<Scalars['Boolean']>,
  readonly isExtra: Maybe<Scalars['Boolean']>,
  readonly sanityId: Scalars['String'],
  readonly type: CartEntryType,
  readonly url: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
}

export interface ICartEntryInput {
  readonly children?: Maybe<ReadonlyArray<ICartEntryInput>>,
  readonly image?: Maybe<Scalars['String']>,
  readonly lineId: Scalars['String'],
  readonly name?: Maybe<Scalars['String']>,
  readonly pickerSelections?: Maybe<Scalars['String']>,
  readonly price?: Maybe<Scalars['Int']>,
  readonly quantity: Scalars['Int'],
  readonly sanityId: Scalars['String'],
  readonly type: CartEntryType,
  readonly isExtra?: Maybe<Scalars['Boolean']>,
  readonly url?: Maybe<Scalars['String']>,
  readonly offerVendorConfigs?: Maybe<IVendorConfigsInput>,
  readonly plu?: Maybe<IPluInput>,
  readonly vendorConfigs?: Maybe<IVendorConfigsInput>,
}

export enum CartEntryType {
  COMBO = 'Combo',
  COMBOSLOT = 'ComboSlot',
  ITEM = 'Item',
  ITEMOPTION = 'ItemOption',
  ITEMOPTIONMODIFIER = 'ItemOptionModifier',
  OFFERCOMBO = 'OfferCombo',
  OFFERDISCOUNT = 'OfferDiscount',
  OFFERITEM = 'OfferItem'
}

export enum CartOfferState {
  ACTIVE = 'ACTIVE',
  CONSUMED = 'CONSUMED',
  INACTIVE = 'INACTIVE'
}

export enum CartPaymentCardType {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERS_CLUB = 'DINERS_CLUB',
  DISCOVER = 'DISCOVER',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
  GIFT_CARD = 'GIFT_CARD'
}

export enum CartPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT_ANONYMOUS = 'CREDIT_ANONYMOUS',
  GOOGLE_PAY = 'GOOGLE_PAY',
  VAULTED_ACCOUNT = 'VAULTED_ACCOUNT'
}

export interface ICatering {
  readonly __typename?: 'Catering',
  readonly declineReason: Maybe<CateringDeclineReasons>,
  readonly notes: Maybe<Scalars['String']>,
  readonly pickupTime: Scalars['String'],
}

export enum CateringDecision {
  ACCEPT = 'Accept',
  DECLINE = 'Decline'
}

export enum CateringDeclineReasons {
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVENTORY = 'INVENTORY',
  STAFFING = 'STAFFING',
  TIMING = 'TIMING'
}

export interface ICateringInfoInput {
  /** 
 * Pickup Time - in ISO format.
   * Only ISO-formatted datetime values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
 */
  readonly pickupTime: Scalars['String'],
}

export interface ICognitoCredentials {
  readonly __typename?: 'CognitoCredentials',
  readonly sessionId: Scalars['String'],
  readonly challengeCode: Scalars['String'],
  /** Data corresponding to user requesting credentials */
  readonly user: IUser,
}

export interface ICommitDeliveryInput {
  readonly instructions?: Maybe<Scalars['String']>,
  /** boolean flag to mark notification setting */
  readonly pushNotification?: Maybe<Scalars['Boolean']>,
  readonly tipCents?: Maybe<Scalars['Int']>,
  /** 
 * drop off location for delivery (user's address)
   * this can be marked as required when launch darkly
   * flag is no longer in use
   * 
   * @deprecated(reason: "needs to be named dropoff")
 */
  readonly dropOff?: Maybe<IDeliveryWaypointInput>,
  readonly dropoff?: Maybe<IDeliveryWaypointInput>,
}

export interface ICommitKioskOrderInput {
  /** The payment method eg. (VISA/MASTERCARD/DISCOVER/AMEX/CASH) */
  readonly creditType?: Maybe<CartPaymentCardType>,
  /** Customer full name */
  readonly fullName: Scalars['String'],
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'],
  /** Store ID where the order was placed */
  readonly storeId: Scalars['ID'],
  /** 
 * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
 */
  readonly sessionId?: Maybe<Scalars['String']>,
}

export interface ICommitOrderInput {
  /** 
 * Billing address Comes in the following format
   * billingStreetAddress, billingApt, billingCity, billingState, billingZip
   * @deprecated(reason: "Use payment object")
 */
  readonly billingAddress?: Maybe<IBillingAddressInput>,
  /** 
 * First 6 digits of credit card.
   * Required for anonymous payment.
   * @deprecated(reason: "Use payment object")
   * @constraint(pattern: "^[0-9]{6}$")
 */
  readonly ccBin?: Maybe<Scalars['String']>,
  /** 
 * Credit card 2 digit expiry month
   * @deprecated(reason: "Use payment object")
 */
  readonly ccExpiryMonth?: Maybe<Scalars['String']>,
  /** 
 * Credit card 2 digit expiry year
   * @deprecated(reason: "Use payment object")
 */
  readonly ccExpiryYear?: Maybe<Scalars['String']>,
  /** 
 * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @deprecated(reason: "Use payment object")
   * @constraint(pattern: "^[0-9]{4}$")
 */
  readonly ccLast4?: Maybe<Scalars['String']>,
  /** 
 * chase id from TH endpoint to trigger direct payment
   * @deprecated(reason: "Use payment object")
 */
  readonly chaseProfileId?: Maybe<Scalars['String']>,
  /** 
 * The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX)
   * @deprecated(reason: "Use payment object")
 */
  readonly creditType?: Maybe<CartPaymentCardType>,
  /** Store email address */
  readonly storeEmail?: Maybe<Scalars['String']>,
  /** 
 * Valid access token for accessing First Data API
   * @deprecated(reason: "Use firstDataInput on payment object")
 */
  readonly fdAccessToken?: Maybe<Scalars['String']>,
  /** 
 * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce.
   * @deprecated(reason: "Use firstDataInput on payment object")
 */
  readonly fdNonce?: Maybe<Scalars['String']>,
  /** 
 * The First Data payment method ID which must be associated to the user
   * making the request.
   * @deprecated(reason: "Use firstDataInput on payment object")
 */
  readonly fdAccountId?: Maybe<Scalars['String']>,
  /** Takes in a time in seconds to delay the order commit */
  readonly fireOrderIn?: Maybe<Scalars['Int']>,
  /** 
 * Customer full name
   * @deprecated(reason: "Use payment object")
 */
  readonly fullName?: Maybe<Scalars['String']>,
  /** Contains information to submit payment for this order */
  readonly payment?: Maybe<IPaymentInput>,
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'],
  /** 
 * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   * @deprecated(reason: "Use payment object")
 */
  readonly kountSessionId?: Maybe<Scalars['String']>,
  /** 
 * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   * 
   * @deprecated(reason: "Use kountSessionId on payment object")
 */
  readonly sessionId?: Maybe<Scalars['String']>,
  /** 
 * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
 */
  readonly redeemedOn?: Maybe<Scalars['String']>,
  /** 
 * Details from Apple Pay for payment.
   * @deprecated(reason: "Use payment object")
 */
  readonly applePayDetails?: Maybe<IApplePay>,
  /** 
 * Details from Google Pay for payment.
   * @deprecated(reason: "Use payment object")
 */
  readonly googlePayDetails?: Maybe<IGooglePay>,
}

export interface ICommunicationPreference {
  readonly __typename?: 'CommunicationPreference',
  /** Database id of the preference (i.e. language) */
  readonly id: Maybe<Scalars['String']>,
  /** Value the preference is set to */
  readonly value: Maybe<Scalars['String']>,
}

export interface ICommunicationPreferenceInput {
  readonly asBoolean?: Maybe<Scalars['Boolean']>,
  readonly asNumber?: Maybe<Scalars['Boolean']>,
  readonly id?: Maybe<Scalars['String']>,
  readonly value?: Maybe<Scalars['String']>,
}

export interface IConfirmCateringOrderInput {
  /** Catering JWT containing catering order info */
  readonly cateringJwt: Scalars['String'],
  /** Accept or Decline Order */
  readonly decision: CateringDecision,
  /** Decline Reason */
  readonly declineReason?: Maybe<CateringDeclineReasons>,
}

/** 
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * 
 * A connection as defined by the GraphQL Cursor Connections Specifications
 * 
 * Provides totalCount if there is an efficient way to determine the total
 * pre-paginated results.
 * 
 * Provides an array of nodes for consumers that do not need each node's cursor.
 */
export interface IConnection {
  readonly edges: ReadonlyArray<IEdge>,
  readonly nodes: ReadonlyArray<INode>,
  readonly pageInfo: IPageInfo,
  readonly totalCount: Maybe<Scalars['Int']>,
}

/** 
 * Coordinates is used by restaurants search to filter
 * by a radius and the current user's coordinates
 */
export interface ICoordinates {
  readonly userLat?: Maybe<Scalars['Float']>,
  readonly userLng?: Maybe<Scalars['Float']>,
  readonly searchRadius?: Maybe<Scalars['Float']>,
}

export enum CountryCode {
  CA = 'CA',
  CH = 'CH',
  GB = 'GB',
  US = 'US',
  ZA = 'ZA'
}

export interface ICoupon {
  readonly __typename?: 'Coupon',
  /** The coupon identity. */
  readonly couponId: Scalars['ID'],
  /** The ISO-formatted timestamp of when the coupon was created. */
  readonly createdAt: Scalars['String'],
  /** 
 * The ISO-formatted timestamp of when the coupon expires.
   * If the value is null, then the coupon never expires.
 */
  readonly expiresOn: Maybe<Scalars['String']>,
  /** The partition key, which is equal to userId. */
  readonly pk: Scalars['String'],
  /** 
 * The ISO-formatted timestamp of when the coupon was redeemed.
   * If the value is null, then the coupon has not yet been redeemed.
 */
  readonly redeemedOn: Maybe<Scalars['String']>,
  /** 
 * The current revision number of the coupon row.
   * This value is incremented every time the row is updated.
   * If this value is zero, then the row has never been revised.
 */
  readonly revision: Scalars['Int'],
  /** The sort key, which contains the version. */
  readonly sk: Scalars['String'],
  /** 
 * The ISO-formatted timestamp of when the coupon row was updated.
   * If this value matches the createdAt value, the row has never been updated.
 */
  readonly updatedAt: Scalars['String'],
  /** The identity of the user. */
  readonly userId: Scalars['ID'],
  /** An alternate sort value, allowing for ordering coupons by expiration. */
  readonly userSortKey: Scalars['String'],
}

export interface ICouponEvaluationFeedback {
  readonly __typename?: 'CouponEvaluationFeedback',
  /** The message code for the message. */
  readonly code: Scalars['String'],
  /** The result of evaluating one rule in a Coupon Rule Set. */
  readonly condition: Scalars['Boolean'],
  /** The ISO datetime when the offer expires, if applicable. */
  readonly expiresOn: Maybe<Scalars['String']>,
  /** The message string for the message. */
  readonly message: Scalars['String'],
  /** The number of seconds the coupon can be redeemed for, if applicable. */
  readonly redeemableForSeconds: Maybe<Scalars['Int']>,
  /** The number of seconds before the coupon can be redeemed, if applicable. */
  readonly redeemableInSeconds: Maybe<Scalars['Int']>,
  /** The ordinal index number of the rule set entry associated with this feedback, if provided. */
  readonly ruleSetIndex: Maybe<Scalars['Int']>,
  /** The type of Coupon Rule Set. */
  readonly ruleSetType: Scalars['String'],
  /** The Sanity ID of this rule product or product category. */
  readonly sanityId: Maybe<Scalars['String']>,
}

export interface ICouponListResponse {
  readonly __typename?: 'CouponListResponse',
  /** 
 * The count of elements in the response.
   * If this value is zero, there were no matching coupons.
 */
  readonly count: Scalars['Int'],
  /** 
 * The set of coupons retrieved.
   * If this array is empty, there were no matching coupons.
 */
  readonly coupons: ReadonlyArray<Maybe<ICoupon>>,
  /** 
 * A resume point for a subsequent call.
   * If this value is undefined or null, there are no more coupons.
   * Specify this value on a subsequent call to continue paginating through coupons.
 */
  readonly resumeAfter: Maybe<Scalars['String']>,
}

export interface ICouponRedemptionEligibility {
  readonly __typename?: 'CouponRedemptionEligibility',
  /** The ISO datetime when the offer expires, if applicable. */
  readonly expiresOn: Maybe<Scalars['String']>,
  /** Any feedback provided during evaluation, further describing the condition. */
  readonly evaluationFeedback: ReadonlyArray<Maybe<ICouponEvaluationFeedback>>,
  /** 
 * The overall redemption eligibility condition.
   * Only a Coupon Rule Set which can be parsed and is valid will potentially be redeemable.
   * If the offer is a Loyalty offer which is not active, then it will also not be redeemable.
 */
  readonly isRedeemable: Scalars['Boolean'],
  /** 
 * Whether the Coupon Rule Set structure and data is valid for evaluation.
   * A Coupon Rule Set which is not valid is not redeemable.
 */
  readonly isValid: Scalars['Boolean'],
  /** The redemption eligibility includes the specified moment of redemption. */
  readonly redeemedOn: Scalars['String'],
  /** Any errors which were encountered during Coupon Rule Set validation. */
  readonly validationErrors: ReadonlyArray<Maybe<ICouponValidationError>>,
}

export interface ICouponToken {
  readonly __typename?: 'CouponToken',
  /** Brief description on the situation that caused coupon to be issued */
  readonly comments: Maybe<Scalars['String']>,
  /** The coupon identity associated with the coupon token. */
  readonly couponId: Scalars['ID'],
  /** The ISO-formatted timestamp of when the coupon token was created. */
  readonly createdAt: Scalars['String'],
  /** 
 * The ISO-formatted timestamp of when the coupon token expires.
   * If the value is null, then the coupon token never expires.
 */
  readonly expiresOn: Maybe<Scalars['String']>,
  /** Reason for issuing the coupon */
  readonly reason: Maybe<Scalars['String']>,
  /** The partition key, which is equal to userId. */
  readonly pk: Scalars['String'],
  /** The id of the support agent who issue'd this coupon */
  readonly supportCognitoId: Maybe<Scalars['String']>,
  /** The email of the support agent who issue'd this coupon */
  readonly supportEmail: Maybe<Scalars['String']>,
  /** The identity of the coupon token. */
  readonly tokenId: Scalars['ID'],
  /** The identity of the user owning the coupon token. */
  readonly userId: Scalars['ID'],
}

export interface ICouponTokenListResponse {
  readonly __typename?: 'CouponTokenListResponse',
  /** 
 * The count of elements in the response.
   * If this value is zero, there were no matching coupon tokens.
 */
  readonly count: Scalars['Int'],
  /** 
 * A resume point for a subsequent call.
   * If this value is undefined or null, there are no more coupons.
   * Specify this value on a subsequent call to continue paginating through coupons.
 */
  readonly resumeAfter: Maybe<Scalars['String']>,
  /** 
 * The set of coupon tokens retrieved.
   * If this array is empty, there were no matching coupon tokens.
 */
  readonly tokens: ReadonlyArray<Maybe<ICouponToken>>,
}

export interface ICouponUserOffersFeedback {
  readonly __typename?: 'CouponUserOffersFeedback',
  /** The cart that was evaluated, if any. */
  readonly cart: Maybe<ICart>,
  /** All the feedback collected. */
  readonly offersFeedback: ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>,
}

export interface ICouponUserOffersFeedbackEntry {
  readonly __typename?: 'CouponUserOffersFeedbackEntry',
  /** 
 * If the offers evaluated are sourced from the cart, this is the cart entry offer.
   * Otherwise, this field is null.
 */
  readonly cartEntry: Maybe<ICartEntries>,
  /** 
 * The identity of the coupon.
   * This may be an empty string in the event there is no couponId.
 */
  readonly couponId: Scalars['String'],
  /** If truthy, then this offer was included by Loyalty. */
  readonly isLoyalty: Maybe<Scalars['Boolean']>,
  /** The stringified sanity offer data. */
  readonly offerDetails: Maybe<Scalars['String']>,
  /** The current state of the offer, if applicable. */
  readonly offerState: Maybe<CartOfferState>,
  /** Templated variables for loyalty offer. */
  readonly offerVariables: Maybe<ReadonlyArray<Maybe<IOfferVariable>>>,
  /** The eligibility of redemption for the coupon. */
  readonly redemptionEligibility: ICouponRedemptionEligibility,
  /** 
 * The token identifier associated with the offer, if applicable.
   * In the case of Tim Hortons Loyalty, this identifier can be used to activate an
   * offer which is not currently active.
 */
  readonly tokenId: Maybe<Scalars['String']>,
}

export interface ICouponValidationError {
  readonly __typename?: 'CouponValidationError',
  /** The message code for the message. */
  readonly code: Scalars['String'],
  /** The message string for the message. */
  readonly message: Scalars['String'],
  /** The type of Coupon Rule Set. */
  readonly ruleSetType: Scalars['String'],
}

export interface ICreateOtp {
  readonly __typename?: 'CreateOTP',
  /** The maximum validation attempts allowed for the created OTP */
  readonly maxLoginAttempts: Scalars['Int'],
  /** The maximum validation attempts allowed for the created OTP */
  readonly maxValidateAttempts: Scalars['Int'],
  /** The time-to-live for the one-time password, in seconds */
  readonly ttl: Scalars['Int'],
}

export interface ICreateOtpInput {
  /** 
 * The email of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - only email is implemented at this time
 */
  readonly email?: Maybe<Scalars['String']>,
  /** 
 * The phone number of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - not implemented
 */
  readonly phoneNumber?: Maybe<Scalars['String']>,
  /** Requestor's platform */
  readonly platform: Platform,
  /** 
 * A unique identifier to associate with the one-time password, to be provided on
   * validation attempts
 */
  readonly sessionId: Scalars['ID'],
}

export interface ICreditCard {
  readonly __typename?: 'CreditCard',
  /** Credit card last 4 digits */
  readonly alias: Scalars['String'],
  readonly billingAddress: Maybe<IBillingAddress>,
  /** Card Provider */
  readonly cardType: Scalars['String'],
  /** Two digit expiry month */
  readonly expiryMonth: Scalars['String'],
  /** Two digit expiry year */
  readonly expiryYear: Scalars['String'],
  readonly fullName: Scalars['String'],
  /** 
 * First Data credit card token.
   * 
   * Should be a numeric string, whose last 4 digits match the credit card alias.
 */
  readonly panToken: Maybe<Scalars['String']>,
}

export interface ICreditCardMetadataInput {
  /** 
 * First 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{6}$")
 */
  readonly ccBin?: Maybe<Scalars['String']>,
  /** Credit card 2 digit expiry month */
  readonly ccExpiryMonth?: Maybe<Scalars['String']>,
  /** Credit card 2 digit expiry year */
  readonly ccExpiryYear?: Maybe<Scalars['String']>,
  /** 
 * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{4}$")
 */
  readonly ccLast4?: Maybe<Scalars['String']>,
  /** The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX) */
  readonly creditType?: Maybe<CartPaymentCardType>,
}

/**  USD/840 CAD/124 */
export interface ICurrencyCode {
  readonly __typename?: 'CurrencyCode',
  readonly code: Scalars['String'],
  readonly number: Scalars['Int'],
}

export interface IDay {
  readonly __typename?: 'Day',
  readonly close: Maybe<Scalars['String']>,
  readonly open: Maybe<Scalars['String']>,
}

/** Delete an account (payment method) from the current user */
export interface IDeleteAccountInput {
  /** 
 * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * Use this field instead.
 */
  readonly accountIdentifier?: Maybe<Scalars['String']>,
  /** Account ID for account to be deleted */
  readonly fdAccountId?: Maybe<Scalars['String']>,
}

export interface IDelivery {
  readonly __typename?: 'Delivery',
  readonly assignedFleetName: Maybe<Scalars['String']>,
  readonly cancellation: Maybe<IDeliveryCancellation>,
  readonly customerId: Maybe<Scalars['String']>,
  readonly driver: Maybe<IDeliveryDriver>,
  readonly dropoff: IDeliveryWaypoint,
  readonly estimateId: Maybe<Scalars['String']>,
  readonly expiration: Maybe<Scalars['String']>,
  readonly feeCents: Scalars['Int'],
  readonly feeDiscountCents: Maybe<Scalars['Int']>,
  readonly fleetId: Maybe<Scalars['String']>,
  readonly instructions: Maybe<Scalars['String']>,
  readonly pickup: IDeliveryWaypoint,
  readonly quoteId: Maybe<Scalars['String']>,
  readonly quotedFeeCents: Maybe<Scalars['Int']>,
  readonly serviceFeeCents: Maybe<Scalars['Int']>,
  readonly shareUuid: Maybe<Scalars['String']>,
  readonly smallCartFeeCents: Maybe<Scalars['Int']>,
  readonly status: DeliveryStatus,
  readonly task: Maybe<IDeliveryTaskDetails>,
  readonly tipCents: Maybe<Scalars['Int']>,
  readonly userId: Maybe<Scalars['String']>,
}

export interface IDeliveryAddress {
  readonly __typename?: 'DeliveryAddress',
  /** Address Line limited to 150 chars */
  readonly addressLine1: Scalars['String'],
  /** Address Line 2 limited to 150 chars */
  readonly addressLine2: Maybe<Scalars['String']>,
  /** city name limited to 150 chars */
  readonly city: Scalars['String'],
  /** isoCountryCode */
  readonly country: Maybe<IsoCountryCode>,
  /** 10 digit phone number spaces don't matter */
  readonly phoneNumber: Scalars['String'],
  /** state abbreviation FL, GA, etc */
  readonly state: Maybe<Scalars['String']>,
  /** zipCode 5-10 digits no spaces */
  readonly zip: Maybe<Scalars['String']>,
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly route: Maybe<Scalars['String']>,
  readonly streetNumber: Maybe<Scalars['String']>,
}

export interface IDeliveryCancellation {
  readonly __typename?: 'DeliveryCancellation',
  readonly description: Maybe<Scalars['String']>,
  readonly id: Maybe<Scalars['Int']>,
  readonly text: Maybe<Scalars['String']>,
}

export interface IDeliveryDriver {
  readonly __typename?: 'DeliveryDriver',
  readonly name: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly profileImageUrl: Maybe<Scalars['String']>,
}

export interface IDeliveryRestaurant {
  readonly __typename?: 'DeliveryRestaurant',
  /** Extended restaurant data containing all fields from Sanity + Dynamo */
  readonly restaurant: Maybe<IRestaurantNode>,
  /** Status of delivery store */
  readonly storeStatus: DeliveryStoreStatus,
  /** Status of delivery order */
  readonly quote: Maybe<DeliveryStatus>,
  /** Next available delivery time for store */
  readonly nextEarliestOpen: Maybe<Scalars['String']>,
}

export enum DeliveryStatus {
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  DRIVER_AT_CUSTOMER = 'DRIVER_AT_CUSTOMER',
  DRIVER_AT_STORE = 'DRIVER_AT_STORE',
  DRIVER_STARTING = 'DRIVER_STARTING',
  DRIVER_UNASSIGNED = 'DRIVER_UNASSIGNED',
  ORDER_ABANDONED = 'ORDER_ABANDONED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_DROPPED_OFF = 'ORDER_DROPPED_OFF',
  ORDER_ERROR = 'ORDER_ERROR',
  ORDER_PICKED_UP = 'ORDER_PICKED_UP',
  ORDER_TIMEOUT = 'ORDER_TIMEOUT',
  QUOTE_ERROR = 'QUOTE_ERROR',
  QUOTE_REQUESTED = 'QUOTE_REQUESTED',
  QUOTE_SUCCESSFUL = 'QUOTE_SUCCESSFUL',
  QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE'
}

export enum DeliveryStoreStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  NO_DELIVERY = 'NO_DELIVERY'
}

export interface IDeliveryTaskDetails {
  readonly __typename?: 'DeliveryTaskDetails',
  readonly createdAt: Maybe<Scalars['String']>,
  readonly id: Maybe<Scalars['String']>,
  readonly status: Maybe<Scalars['String']>,
  readonly uuid: Maybe<Scalars['String']>,
}

export interface IDeliveryWaypoint {
  readonly __typename?: 'DeliveryWaypoint',
  readonly afterTime: Maybe<Scalars['String']>,
  readonly arrivalTime: Maybe<Scalars['String']>,
  readonly beforeTime: Maybe<Scalars['String']>,
  readonly id: Maybe<Scalars['String']>,
  readonly addressLine1: Scalars['String'],
  readonly addressLine2: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country: Maybe<Scalars['String']>,
  readonly phoneNumber: Scalars['String'],
  readonly state: Maybe<Scalars['String']>,
  readonly zip: Maybe<Scalars['String']>,
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly shareUuid: Maybe<Scalars['String']>,
  readonly trackingUrl: Maybe<Scalars['String']>,
}

export interface IDeliveryWaypointInput {
  readonly addressLine1: Scalars['String'],
  readonly addressLine2?: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country?: Maybe<Scalars['String']>,
  readonly phoneNumber: Scalars['String'],
  readonly route?: Maybe<Scalars['String']>,
  /** flag to determine wether or not the waypoint should be saved */
  readonly shouldSave?: Maybe<Scalars['Boolean']>,
  readonly state?: Maybe<Scalars['String']>,
  readonly streetNumber?: Maybe<Scalars['String']>,
  readonly zip?: Maybe<Scalars['String']>,
  readonly latitude?: Maybe<Scalars['Float']>,
  readonly longitude?: Maybe<Scalars['Float']>,
}

export interface IDiscount {
  readonly __typename?: 'Discount',
  readonly name: Maybe<DiscountTypes>,
  /** values are represented as positive integers in cents */
  readonly value: Maybe<Scalars['Int']>,
}

export enum DiscountTypes {
  ALL_DISCOUNTS = 'ALL_DISCOUNTS',
  COMBO_AND_OFFER_DISCOUNTS = 'COMBO_AND_OFFER_DISCOUNTS',
  REWARDS_DISCOUNTS = 'REWARDS_DISCOUNTS'
}

/** 
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * 
 * An edge provides an association between a node and it's associated cursor.
 */
export interface IEdge {
  readonly node: INode,
  readonly cursor: Scalars['String'],
}

/** All details necessary to encrypt CC information for First Data */
export interface IEncryptionDetails {
  readonly __typename?: 'EncryptionDetails',
  /** Public key for performing RSA encryption on specific First Data requests */
  readonly fdPublicKey: Scalars['String'],
  /** Access token for accessing First Data API. Limited TTL. */
  readonly fdAccessToken: Scalars['String'],
  /** Time until public key expires (milliseconds?) */
  readonly fdPublicKeyExpiresInSeconds: Scalars['Int'],
  /** ISO datetime for when public key was issued */
  readonly fdPublicKeyIssuesOn: Scalars['String'],
  /** RBI specific API key for accessing First Data */
  readonly fdApiKey: Scalars['String'],
  /** 
 * Encryption algorithm.
   * 
   * You should be able to ignore this value, as we only support 'RSA/NONE/PKCS1Padding'
 */
  readonly algorithm: Maybe<Scalars['String']>,
  /** First data customer ID. Derived from provided authentication header. */
  readonly fdCustomerId: Maybe<Scalars['String']>,
}

export interface IExchangeOtpCodeForCredentialsInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'],
  /** 
 * The email of the user requesting a One-Time Password. Optional, one of either
   * email or phoneNumber must always be provided
   * @todo - only email is implemented at this time
 */
  readonly email?: Maybe<Scalars['String']>,
  /** 
 * The phone number of the user logging in with a One-Time Password. Optional, one of either
   * email or phoneNumber must always be provided.
   * @todo - not implemented
 */
  readonly phoneNumber?: Maybe<Scalars['String']>,
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'],
}

export interface IFavoriteStore {
  readonly __typename?: 'FavoriteStore',
  /** Favorite Store ID */
  readonly storeId: Maybe<Scalars['String']>,
  /** Favorite Store Number */
  readonly storeNumber: Maybe<Scalars['String']>,
}

export interface IFavoriteStoreInput {
  readonly storeId?: Maybe<Scalars['String']>,
  readonly storeNumber?: Maybe<Scalars['String']>,
}

export interface IFees {
  readonly __typename?: 'Fees',
  readonly name: Maybe<Scalars['String']>,
  readonly priceCents: Maybe<Scalars['Int']>,
  readonly quantity: Maybe<Scalars['Int']>,
  readonly totalCents: Maybe<Scalars['Int']>,
}

export enum FilterRestaurantType {
  NEARBY = 'NEARBY',
  RECENT = 'RECENT',
  FAVORITE = 'FAVORITE'
}

export interface IFirstDataPayment {
  /** 
 * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or fdNonce
   * and fdAccessToken should be passed.
 */
  readonly accountIdentifier?: Maybe<Scalars['String']>,
  /** Valid access token for accessing First Data API */
  readonly fdAccessToken?: Maybe<Scalars['String']>,
  /** 
 * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce. If accountIdentifier is not passed this must
   * be passed.
 */
  readonly fdNonce?: Maybe<Scalars['String']>,
}

/** A First Data gift card account (prepaid payment method) */
export interface IGiftAccount {
  readonly __typename?: 'GiftAccount',
  /** First Data account ID */
  readonly fdAccountId: Scalars['String'],
  readonly prepaid: IGiftCard,
}

/** First Data prepaid account */
export interface IGiftCard {
  readonly __typename?: 'GiftCard',
  /** last 4 digits of prepaid gift card number */
  readonly alias: Scalars['String'],
  /** amount card was loaded with (cents) upon creation */
  readonly currentBalance: Maybe<Scalars['Int']>,
  readonly cardNumber: Scalars['String'],
  /** Two digit expiry month */
  readonly expiryMonth: Scalars['String'],
  /** Two digit expiry year */
  readonly expiryYear: Scalars['String'],
  readonly feFormattedCurrentBalance: Maybe<Scalars['Int']>,
  /** Use to generate barcode */
  readonly shuffledCardNumber: Scalars['String'],
}

export interface IGiftOffer {
  readonly __typename?: 'GiftOffer',
  /** The offer identity. */
  readonly offerId: Scalars['ID'],
  /** The title as a string */
  readonly title: Scalars['String'],
  /** The title formatted with points required, e.g. "Free Coffee (50 Points)" */
  readonly titleFormatted: Scalars['String'],
  /** Can the Gift Offer be redeemed. */
  readonly isRedeemable: Scalars['Boolean'],
  /** The cost in points to redeem */
  readonly costInPoints: Scalars['Int'],
}

export interface IGiftOfferInput {
  /** The Id of the offer to gift */
  readonly offerId: Scalars['String'],
  /** The email address to send the offer to */
  readonly toEmail: Scalars['String'],
  /** The name the offer will come from */
  readonly fromName: Scalars['String'],
  /** The message to include in the email */
  readonly message: Scalars['String'],
}

export interface IGiftOfferListResponse {
  readonly __typename?: 'GiftOfferListResponse',
  /** 
 * The count of elements in the response.
   * If this value is zero, there were no matching coupons.
 */
  readonly count: Scalars['Int'],
  /** 
 * The set of offers retrieved.
   * If this array is empty, there were no matching coupons.
 */
  readonly offers: ReadonlyArray<Maybe<IGiftOffer>>,
}

/** Details from Google Pay used for Google Pay funding. */
export interface IGooglePay {
  /** Signature as passed through from Google Pay */
  readonly signature: Scalars['String'],
  /** Country Code from user account */
  readonly country: CountryCode,
  /** Signature message passed through from Google Pay */
  readonly data: Scalars['String'],
  /** Formatted billing address from Google Pay */
  readonly formatted: Scalars['String'],
  readonly primary: Scalars['Boolean'],
  readonly version: Scalars['String'],
  readonly type: Scalars['String'],
  /** Billing address from Google Pay */
  readonly billingAddress: IBillingAddressInput,
  /** Encrypted token including signature and signature message as passed through from Google Pay. */
  readonly paymentData?: Maybe<Scalars['String']>,
  /** Data of the payment method used for Google Pay. */
  readonly PaymentMethodData?: Maybe<IPaymentMethodData>,
}

export { IsoCountryCode };

export interface IKiosk {
  readonly __typename?: 'Kiosk',
  /** The kiosk identity. */
  readonly serialNumber: Scalars['String'],
}

export interface IKioskInput {
  /** The kiosk identity. */
  readonly serialNumber: Scalars['String'],
}

export interface IKioskSignInDetails {
  readonly __typename?: 'KioskSignInDetails',
  readonly decryptedCode: Scalars['String'],
  readonly sessionId: Scalars['String'],
}

export enum Locale {
  EN = 'en',
  FR = 'fr',
  IT = 'it',
  DE = 'de'
}

export interface ILoyaltyCard {
  readonly __typename?: 'LoyaltyCard',
  readonly barcode: Scalars['String'],
  readonly cardFormat: UserCardCardFormat,
  /** 
 * 12 digit card number, eg '1G96025DZ9ZG'.
   * 
   * This is the number printed on the back of a physical card
 */
  readonly cardId: Scalars['String'],
  readonly cardType: UserCardCardType,
  readonly name: Scalars['String'],
  readonly status: UserCardCardStatus,
}

export interface ILoyaltyCardApplePass {
  readonly __typename?: 'LoyaltyCardApplePass',
  readonly encodedPass: Scalars['String'],
}

export interface ILoyaltyCardDetails {
  readonly __typename?: 'LoyaltyCardDetails',
  /** The number of available redemptions available to the user. */
  readonly availableRedemptions: Scalars['Int'],
  /** Specifies whether a user is eligible to earn a reward visit. */
  readonly canEarnVisit: Scalars['Boolean'],
  /** Specifies whether a user is eligible to redeem a reward. */
  readonly canRedeemReward: Scalars['Boolean'],
  /** The type of loyalty card. */
  readonly cardType: UserCardCardType,
  /** (e.g. 0001-01-01T00:00:00.000Z) */
  readonly discountActiveUntil: Scalars['String'],
  readonly numberOfTransactionsInTimePeriod: Scalars['Int'],
  /** The total number of visits this loyalty card has been issued towards the next reward. */
  readonly numberOfTransactionsMadeTowardsNextReward: Scalars['Int'],
  /** The total number of visits a loyalty card needs to be issues a reward. */
  readonly numberOfTransactionsNeeded: Scalars['Int'],
  /** The total number of offers attached to a loyalty card. */
  readonly offers: ReadonlyArray<Maybe<ILoyaltyOffer>>,
  /** (e.g. 9899-12-31T23:59:59.999Z) */
  readonly periodEndTimestamp: Scalars['String'],
  /** (e.g. 1999-01-01T00:00:00.000Z) */
  readonly periodStartTimestamp: Scalars['String'],
  /** The user's point expiry data. */
  readonly pointExpiry: ReadonlyArray<ILoyaltyPointExpiry>,
  /** 
 * The user's available loyalty points.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
 */
  readonly points: Maybe<Scalars['Int']>,
  /** 
 * The user's selected reward tier.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
 */
  readonly rewardsTier: Maybe<Scalars['String']>,
  /** The donation status for a loyalty user card */
  readonly donationUpcharge: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyCardDetailsKiosk {
  readonly __typename?: 'LoyaltyCardDetailsKiosk',
  /** The number of available redemptions available to the user. */
  readonly availableRedemptions: Scalars['Int'],
  /** ??? */
  readonly currentPoints: Scalars['Int'],
  /** The total number of visits issues to this loyalty card in an unknown period of time. */
  readonly numberOfTransactionsInTimePeriod: Scalars['Int'],
  /** The total number of visits a loyalty card needs to be issues a reward. */
  readonly numberOfTransactionsNeeded: Scalars['Int'],
  /** The total number of visits this loyalty card has been issued towards the next reward. */
  readonly numberOfTransactionsMadeTowardsNextReward: Scalars['Int'],
}

export interface ILoyaltyCardGooglePass {
  readonly __typename?: 'LoyaltyCardGooglePass',
  readonly jwt: Scalars['String'],
}

export interface ILoyaltyCardsResp {
  readonly __typename?: 'LoyaltyCardsResp',
  readonly cards: ReadonlyArray<Maybe<ILoyaltyCard>>,
  readonly count: Scalars['Int'],
}

export interface ILoyaltyCardTransaction {
  readonly __typename?: 'LoyaltyCardTransaction',
  /** The taxes of the basket. */
  readonly basketTaxes: Maybe<Scalars['Int']>,
  /** Bonus points earned */
  readonly bonusPoints: Maybe<Scalars['Int']>,
  /** The total of the basket including taxes. */
  readonly basketTotal: Maybe<Scalars['Int']>,
  /** City of store where loyalty was redeemed */
  readonly city: Maybe<Scalars['String']>,
  /** The total amount discounted */
  readonly discountAmount: Maybe<Scalars['Int']>,
  readonly expiredPoints: Maybe<ILoyaltyExpiredPoints>,
  /** True if this visit was given from customer support. False otherwise. */
  readonly isCustomerServiceVisit: Maybe<Scalars['Boolean']>,
  /** True if the transaction counted as a visit. */
  readonly isVisit: Maybe<Scalars['Boolean']>,
  /** Offer that was associated with the transaction */
  readonly offerId: Maybe<Scalars['Int']>,
  /** Loyalty points earned from transaction */
  readonly pointsEarned: Maybe<Scalars['Int']>,
  /** Loyalty points used from transaction */
  readonly pointsUsed: Maybe<Scalars['Int']>,
  /** True if this transaction earned a rewards */
  readonly rewardEarned: Maybe<Scalars['Boolean']>,
  /** Reward redeemed upon transaction */
  readonly rewardRedeemed: Maybe<Scalars['Boolean']>,
  /** State or Province of store where loyalty was redeemed */
  readonly stateOrProvince: Maybe<Scalars['String']>,
  /** Store ID where loyalty was redeemed */
  readonly storeId: Maybe<Scalars['String']>,
  /** 
 * Tag string indicating the source of the rewards earned
   * e.g. FREQUENCY_CHALLENGE_COMPLETE, HOCKEY_1
 */
  readonly tag: Maybe<Scalars['String']>,
  /** The time of the transaction in UTC. */
  readonly timestamp: Maybe<Scalars['String']>,
  /** A unique identifier for transaction */
  readonly transactionId: Maybe<Scalars['String']>,
  /** 
 * A tag for the type of visit. This will be null for normal transactions.
   * When a visit or reward is issued through the IssueVisit/IssueReward endpoints
   * a VisitType may be specified that will surface in this field
 */
  readonly visitType: Maybe<Scalars['String']>,
  /** 
 * True if the discount was active or available for this transaction.
   * False if no discount was applied.
 */
  readonly wasDiscountActive: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyCardTransactions {
  readonly __typename?: 'LoyaltyCardTransactions',
  readonly count: Scalars['Int'],
  readonly transactions: ReadonlyArray<Maybe<ILoyaltyCardTransaction>>,
}

export interface ILoyaltyDonationUpcharge {
  readonly __typename?: 'LoyaltyDonationUpcharge',
  readonly donationUpcharge: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyExpiredPoints {
  readonly __typename?: 'LoyaltyExpiredPoints',
  /** Loyalty card barcode */
  readonly barcode: Maybe<Scalars['String']>,
  readonly expirationDate: Maybe<Scalars['String']>,
  readonly points: Maybe<Scalars['Int']>,
  readonly ttl: Maybe<Scalars['String']>,
}

export interface ILoyaltyOffer {
  readonly __typename?: 'LoyaltyOffer',
  readonly activated: Scalars['Boolean'],
  readonly challengeStatus: Maybe<ReadonlyArray<Maybe<ILoyaltyOfferChallengeStatus>>>,
  readonly challengeType: Maybe<Scalars['String']>,
  readonly challengeReward: Maybe<ILoyaltyOfferRewardType>,
  readonly expiryDate: Scalars['String'],
  readonly key: Maybe<Scalars['String']>,
  readonly offerId: Scalars['String'],
  readonly startDate: Scalars['String'],
}

export interface ILoyaltyOfferChallengeStatus {
  readonly __typename?: 'LoyaltyOfferChallengeStatus',
  readonly goals: Maybe<ILoyaltyOfferGoalType>,
  readonly goalId: Scalars['String'],
  readonly reward: Maybe<ILoyaltyOfferRewardType>,
  readonly status: Scalars['String'],
}

export interface ILoyaltyOfferGoalType {
  readonly __typename?: 'LoyaltyOfferGoalType',
  readonly category: Maybe<Scalars['String']>,
  readonly daypart: Maybe<Scalars['String']>,
  readonly foodType: Maybe<Scalars['String']>,
  readonly minSpend: Maybe<Scalars['Int']>,
}

export interface ILoyaltyOfferRewardType {
  readonly __typename?: 'LoyaltyOfferRewardType',
  readonly points: Maybe<Scalars['Int']>,
}

export interface ILoyaltyPointExpiry {
  readonly __typename?: 'LoyaltyPointExpiry',
  readonly points: Scalars['Int'],
  readonly expirationDate: Scalars['String'],
}

export interface ILoyaltyRollUpTheRimPrizesStats {
  readonly __typename?: 'LoyaltyRollUpTheRimPrizesStats',
  /** Cumulative sum of all prizes for contest period (not including unlimited prizes) */
  readonly total: Maybe<Scalars['Int']>,
  /** Cumulative sum of all prizes awarded to guests for contest period. */
  readonly awarded: Maybe<Scalars['Int']>,
  /** Prizes */
  readonly details: Maybe<ReadonlyArray<Maybe<ILoyaltyRollUpTheRimPrizeStats>>>,
}

export interface ILoyaltyRollUpTheRimPrizeStats {
  readonly __typename?: 'LoyaltyRollUpTheRimPrizeStats',
  /** Prize identifier */
  readonly prizeId: Maybe<Scalars['String']>,
  /** Total number of prizes allocated for contest period. For prizes with no cap, total will be undefined. */
  readonly total: Maybe<Scalars['Int']>,
  /** Total number of prizes awarded to guests for contest period. */
  readonly awarded: Maybe<Scalars['Int']>,
}

export interface ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry',
  /** This is the barcode used for scanning the timeline event entry. */
  readonly barcode: Scalars['String'],
  /** 
 * The moment the timeline event entry was created.
   * This is an ISO formatted timestamp, in UTC e.g. 2020-02-02T20:20:20.020Z
 */
  readonly createdAt: Scalars['String'],
  /** The associated event identifier for the timeline event entry. */
  readonly eventId: Scalars['String'],
  /** The reference identifier for the timeline event entry. */
  readonly referenceId: Scalars['String'],
}

export interface ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList',
  /** The count of rolls which were accepted. */
  readonly count: Scalars['Int'],
  /** The list of rolls which were accepted. */
  readonly rolls: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry>>,
}

export interface ILoyaltyRollUpTheRimTimelineEventEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventEntry',
  /** 
 * If present, this is the barcode used for scanning the timeline event entry.
   * Otherwise, this value is null.
 */
  readonly barcode: Maybe<Scalars['String']>,
  /** 
 * The moment the timeline event entry was created.
   * This is an ISO formatted timestamp, in UTC e.g. 2020-02-02T20:20:20.020Z
 */
  readonly createdAt: Scalars['String'],
  /** The associated event identifier for the timeline event entry. */
  readonly eventId: Scalars['String'],
  /** 
 * If this timeline event entry is for a prize, this is the prize identifier.
   * Otherwise, this value is null.
 */
  readonly prizeId: Maybe<Scalars['String']>,
  /** 
 * The reference identifier for the timeline event entry.
   * Specify this value for revealing a roll.
   * Multiple events may occur for a given reference identity.
   * Only the most recent event for any reference identity is returned.
 */
  readonly referenceId: Scalars['String'],
  /** The unique identifier for the timeline event entry. */
  readonly timelineId: Scalars['String'],
  /** The type of timeline event entry. */
  readonly type: Scalars['String'],
  /** The associated offer for the timeline event entry. */
  readonly offerStatus: Maybe<ILoyaltyRollUpTheRimTimelineEventOfferStatus>,
}

export interface ILoyaltyRollUpTheRimTimelineEventList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventList',
  readonly count: Scalars['Int'],
  readonly events: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventEntry>>,
  readonly resumeAfter: Maybe<Scalars['String']>,
}

export interface ILoyaltyRollUpTheRimTimelineEventOfferStatus {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventOfferStatus',
  /** The associated offer identifier for the timeline event entry. */
  readonly offerId: Maybe<Scalars['String']>,
  /** The activation status of the associated offer */
  readonly activated: Maybe<Scalars['Boolean']>,
  /** The status of the associated offer */
  readonly used: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyRollUpTheRimTimelineEventRollResult {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventRollResult',
  readonly id: Scalars['String'],
  readonly type: Scalars['String'],
  readonly code: Maybe<Scalars['String']>,
}

export interface ILoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry',
  /** The count of shared rolls represented by the token. */
  readonly count: Scalars['Int'],
  /** 
 * The token representing the number of shared rolls.
   * This can be used to accept the rolls by another user.
 */
  readonly token: Scalars['String'],
}

export interface ILoyaltyRollUpTheRimTimelineEventSharedRollTokenList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSharedRollTokenList',
  /** The count of tokens in the list. */
  readonly count: Scalars['Int'],
  /** The tokens representing shared rolls from the user's timeline events. */
  readonly tokens: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry>>,
}

export interface ILoyaltyRollUpTheRimTimelineEventShareRollResult {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventShareRollResult',
  /** The generated token which can be used to accept the shared rolls. */
  readonly token: Scalars['String'],
}

export interface ILoyaltyRollUpTheRimTimelineEventSummaryEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSummaryEntry',
  readonly count: Scalars['Int'],
  readonly eventId: Scalars['String'],
}

export interface ILoyaltyRollUpTheRimTimelineEventSummaryList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSummaryList',
  readonly count: Scalars['Int'],
  readonly events: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventSummaryEntry>>,
  readonly resumeAfter: Maybe<Scalars['String']>,
}

export interface ILoyaltyTransaction {
  readonly __typename?: 'LoyaltyTransaction',
  readonly id: Scalars['String'],
  /** Points earned. */
  readonly pointsEarned: Scalars['Int'],
  /** Bonus points earned. */
  readonly bonusPointsEarned: Scalars['Int'],
  /** Points used. */
  readonly pointsUsed: Scalars['Int'],
  /** Points balance after this transaction. */
  readonly pointsBalance: Scalars['Int'],
  /** Number of rewards used. */
  readonly rewardsUsed: Scalars['Int'],
}

export interface IMeInput {
  /** 
 * Should the unique items check for modifier differences
   * Example: Should a Medium Coffee with Cream and Sugar
   * be considered distinctly different from a
   * Medium Coffee with Cream and NO Sugar
   * Includes quantity as well.
   * Example: Medium Coffee with 1 Cream and 1 Sugar
   * is different than a Medium Coffee with 2 Cream and 1 Sugar
 */
  readonly shouldUniqueByModifiers?: Maybe<Scalars['Boolean']>,
  /** Should the unique items count extras added in the cart */
  readonly shouldIncludeExtras?: Maybe<Scalars['Boolean']>,
}

/** A Prepaid Merge two gift cards response */
export interface IMerge {
  readonly __typename?: 'Merge',
  /** dollar amount destination gift card begins with */
  readonly beginBalance: Scalars['Int'],
  /** destination card currency code */
  readonly currencyCode: Scalars['String'],
  /** new balance of destination gift card after merge in dollars */
  readonly currentBalance: Scalars['Int'],
  /** card number of destination gift card */
  readonly destinationCardNumber: Scalars['String'],
  readonly fdCorrelationId: Maybe<Scalars['String']>,
  /** card number of source gift card that was deleted */
  readonly sourceCardNumber: Scalars['String'],
  readonly transactionId: Scalars['String'],
  readonly fdAccountId: Maybe<Scalars['String']>,
}

export interface IMissingItem {
  /** Line Id of item */
  readonly lineId: Scalars['String'],
  /** Quantity of items requested for refund */
  readonly refundQuantity: Scalars['Int'],
  /** Total quantity of items in a Combo or OfferCombo */
  readonly totalQuantity?: Maybe<Scalars['Int']>,
}

export interface IMissingOrderRefundDetails {
  readonly __typename?: 'MissingOrderRefundDetails',
  /** Amount refunded in cents */
  readonly approvedAmount: Scalars['Int'],
  /** Date time when refund was issued */
  readonly transactionDateTime: Scalars['String'],
}

export interface IMissingOrderResolution {
  readonly __typename?: 'MissingOrderResolution',
  /** Refund details */
  readonly refund: Maybe<IMissingOrderRefundDetails>,
  /** Knowledge Force or Zendesk support ticket */
  readonly ticket: Maybe<Scalars['String']>,
}

export interface IMutation {
  readonly __typename?: 'Mutation',
  /** 
 * Accepts the rolls represented by the shared rolls token specified.
   * The authenticated user is the user which accepts the shared rolls.
 */
  readonly acceptLoyaltyRollUpTheRimTimelineEventSharedRolls: Maybe<ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList>,
  /** Activates a loyalty offer for a user. */
  readonly activateLoyaltyOffer: Maybe<Scalars['Boolean']>,
  /** 
 * Add an FD account (credit card) for a customer using a nonce.
   * Can throw MaxCreditCardsExistError.
 */
  readonly addAccount: IAccount,
  /** 
 * Add a Ayden or First Data account (credit card) for a customer.
   * Can throw MaxCreditCardsExistError.
 */
  readonly addCreditAccount: IAccount,
  /** 
 * Add a gift account (gift card) for a customer using a vaulted fd account.
   * Can throw MaxGiftCardsExistError.
 */
  readonly addGiftAccount: IGiftAccount,
  /** Gift an offer */
  readonly addGiftOfferByEmail: Scalars['Boolean'],
  /** Validate a gift token */
  readonly addOfferByToken: Scalars['Boolean'],
  /** Activates a loyalty offer for a user. */
  readonly addVoucher: Maybe<Scalars['Boolean']>,
  /** Assign one coupon token to the authenticated user id. */
  readonly assignCouponToken: ICouponToken,
  /** Claim a prize in Roll Up the Rim. */
  readonly claimLoyaltyRollUpTheRimPrize: Maybe<Scalars['Boolean']>,
  readonly commitKioskOrder: IOrder,
  /** 
 * Collect payments and commit the order to the PoS.
   * 
   * If the service mode in the previously priced order was DRIVE_THRU or DELIVERY,
   * then the PoS will immediately start cooking the order. Else the PoS
   * will not cook the order until the customer arrives.
   * 
   * (Please note that despite the name this is not a "transactional" flow)
 */
  readonly commitOrder: IOrder,
  /** 
 * Store Member will choose wether to fulfill or accept the order at this point
   * Decline: will refund and send appropriate emails to user and store
   * Accept: will send a user and confirmation emails that the store will process
   * the order
 */
  readonly confirmCateringOrder: IOrder,
  /** Request a jwt to auth for a given vendor */
  readonly createLoginForVendor: Maybe<Scalars['String']>,
  /** Request a one-time password for the given user */
  readonly createLoginOTP: ICreateOtp,
  /** Create a loyalty user record associated with a given user */
  readonly createLoyaltyUser: IUser,
  /** Request a one-time password for the given user */
  readonly createOTP: ICreateOtp,
  /** Create a support case */
  readonly createSupportCase: Maybe<ISupportCase>,
  /** Create user session with WLL Loyalty vendor */
  readonly createWllSession: Maybe<IWllSession>,
  /** Delete a customer's account */
  readonly deleteAccount: Maybe<Scalars['Boolean']>,
  /** 
 * Merges the existing loyalty card for a user into a new
   * loyalty card created at run time. This deletes the existing
   * loyalty card.
 */
  readonly deleteLoyaltyCard: Maybe<ILoyaltyCard>,
  /** Delete current user */
  readonly deleteMe: Maybe<Scalars['Boolean']>,
  /** Fetch public key & access token for encrypting CC values. */
  readonly encryptionDetails: IEncryptionDetails,
  /** 
 * Validates a previously-created OTP code and then exchanges the
   * valid code for Cognito credentials
 */
  readonly exchangeOTPCodeForCognitoCredentials: ICognitoCredentials,
  readonly kioskSignIn: Maybe<IKioskSignInDetails>,
  /** 
 * Merges the physical cardId (existingCardId) into existingCardId for a user
   * This deletes the existing loyalty card.
 */
  readonly mergeLoyaltyCards: Maybe<ILoyaltyCard>,
  /** 
 * Collect payments and send emails to user and the store for further acknowledgement
   * and fulfillment of this order
 */
  readonly placeCateringOrder: IOrder,
  /** Get balance for prepaid account */
  readonly prepaidsBalance: IBalance,
  /** Transfer balance of prepaid gift card into one and delete it */
  readonly prepaidsMerge: IMerge,
  /** Reload a prepaid gift card account */
  readonly prepaidsReload: IReload,
  /** 
 * Price an order using the store's PoS.
   * 
   * This endpoint _must_ be called previous to finalizing the order.
 */
  readonly priceOrder: IOrder,
  /** Redeem one coupon for the authenticated user id. */
  readonly redeemCoupon: ICoupon,
  /** 
 * DEPRECATED - tragically unlaunched feature
   * 
   * Request a heartbeat refresh for a specific restaurant
 */
  readonly refreshRestaurantAvailability: Scalars['Boolean'],
  /** Kicks off email with all data we have on the user */
  readonly requestMyInfo: Maybe<Scalars['Boolean']>,
  /** Re-sends the current OTP code for the given user email/phone number */
  readonly resendCurrentLoginOTP: ICreateOtp,
  /** Re-sends the verification email to the current user */
  readonly resendVerificationEmail: Maybe<Scalars['Boolean']>,
  /** Reveals the result of a timeline event roll. */
  readonly revealLoyaltyRollUpTheRimTimelineEventRoll: Maybe<ILoyaltyRollUpTheRimTimelineEventRollResult>,
  /** Set donation up charge for a loyalty user card */
  readonly setLoyaltyDonationUpcharge: Maybe<ILoyaltyDonationUpcharge>,
  /** Share quantity of Roll Up the Rim timeline event rolls. */
  readonly shareLoyaltyRollUpTheRimTimelineEventRolls: Maybe<ILoyaltyRollUpTheRimTimelineEventShareRollResult>,
  /** Sign in the current user */
  readonly signIn: Maybe<Scalars['Boolean']>,
  /** Kicks off part one of Login Flow */
  readonly signInJWT: Maybe<Scalars['Boolean']>,
  /** Sign up user with cognito returns a JWT */
  readonly signUp: Maybe<Scalars['String']>,
  /** Update current user */
  readonly updateMe: IUser,
  /** 
 * Update an order using the store's PoS.
   * 
   * This endpoint _must_ be called after committing the order.
 */
  readonly updateOrder: IOrder,
  /** Update the stores */
  readonly updateStore: IStore,
  /** User reports order or items in a order that are missing */
  readonly userReportsMissingOrder: IMissingOrderResolution,
  /** Validate the RBI generated JWT and exchange for cognito credentials */
  readonly validateAuthJwt: ICognitoCredentials,
  /** Void a sale, issuing a full refund to the original payment method */
  readonly voidSale: Maybe<ISale>,
}


export interface IMutationAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsArgs {
  token: Scalars['String']
}


export interface IMutationActivateLoyaltyOfferArgs {
  tokenId: Scalars['String']
}


export interface IMutationAddAccountArgs {
  input: IAddAccountInput
}


export interface IMutationAddCreditAccountArgs {
  input: IAddCreditAccountInput
}


export interface IMutationAddGiftAccountArgs {
  input: IAddGiftAccountInput
}


export interface IMutationAddGiftOfferByEmailArgs {
  input: IGiftOfferInput
}


export interface IMutationAddOfferByTokenArgs {
  token: Scalars['String']
}


export interface IMutationAddVoucherArgs {
  voucherId: Scalars['String']
}


export interface IMutationAssignCouponTokenArgs {
  couponId: Scalars['ID'],
  expiresOn: Maybe<Scalars['String']>,
  tokenId: Maybe<Scalars['ID']>,
  userId: Maybe<Scalars['ID']>
}


export interface IMutationClaimLoyaltyRollUpTheRimPrizeArgs {
  email: Scalars['String'],
  giftCardValueCents: Maybe<Scalars['Int']>,
  isMajorPrize: Scalars['Boolean'],
  isTimHortonsGiftCard: Scalars['Boolean'],
  language: Scalars['String'],
  name: Scalars['String'],
  referenceId: Scalars['String']
}


export interface IMutationCommitKioskOrderArgs {
  input: ICommitKioskOrderInput
}


export interface IMutationCommitOrderArgs {
  input: ICommitOrderInput,
  delivery: Maybe<ICommitDeliveryInput>,
  skipCoolingPeriod: Maybe<Scalars['Boolean']>
}


export interface IMutationConfirmCateringOrderArgs {
  input: IConfirmCateringOrderInput
}


export interface IMutationCreateLoginForVendorArgs {
  vendor: Scalars['String']
}


export interface IMutationCreateLoginOtpArgs {
  input: ICreateOtpInput
}


export interface IMutationCreateLoyaltyUserArgs {
  cognitoId: Scalars['String']
}


export interface IMutationCreateOtpArgs {
  input: ICreateOtpInput
}


export interface IMutationCreateSupportCaseArgs {
  caseInfo: ISupportCaseInput
}


export interface IMutationDeleteAccountArgs {
  input: IDeleteAccountInput
}


export interface IMutationDeleteLoyaltyCardArgs {
  existingCardId: Scalars['String']
}


export interface IMutationExchangeOtpCodeForCognitoCredentialsArgs {
  input: IExchangeOtpCodeForCredentialsInput
}


export interface IMutationKioskSignInArgs {
  userInfo: ISignInUserInput
}


export interface IMutationMergeLoyaltyCardsArgs {
  cardId: Scalars['String'],
  existingCardId: Scalars['String']
}


export interface IMutationPlaceCateringOrderArgs {
  input: IPlaceCateringOrderInput
}


export interface IMutationPrepaidsBalanceArgs {
  cardNumber: Scalars['String'],
  feCountryCode: Maybe<IsoCountryCode>
}


export interface IMutationPrepaidsMergeArgs {
  input: IPrepaidsMergeInput
}


export interface IMutationPrepaidsReloadArgs {
  input: IPrepaidsReloadInput
}


export interface IMutationPriceOrderArgs {
  input: IPriceOrderInput,
  delivery: Maybe<IPriceDeliveryInput>
}


export interface IMutationRedeemCouponArgs {
  couponId: Scalars['ID']
}


export interface IMutationRefreshRestaurantAvailabilityArgs {
  storeId: Maybe<Scalars['String']>,
  storeNumber: Maybe<Scalars['String']>
}


export interface IMutationResendCurrentLoginOtpArgs {
  input: IResendOtpInput
}


export interface IMutationResendVerificationEmailArgs {
  input: IResendVerificationEmailInput
}


export interface IMutationRevealLoyaltyRollUpTheRimTimelineEventRollArgs {
  referenceId: Scalars['String'],
  developmentPrize: Maybe<Scalars['String']>
}


export interface IMutationSetLoyaltyDonationUpchargeArgs {
  cardId: Scalars['String'],
  donationUpcharge: Scalars['Boolean']
}


export interface IMutationShareLoyaltyRollUpTheRimTimelineEventRollsArgs {
  quantity: Scalars['Int']
}


export interface IMutationSignInArgs {
  userInfo: ISignInUserInput
}


export interface IMutationSignInJwtArgs {
  userInfo: ISignInUserInput
}


export interface IMutationSignUpArgs {
  userInfo: ISignUpUserInput
}


export interface IMutationUpdateMeArgs {
  details: IUpdateUserDetailsInput
}


export interface IMutationUpdateOrderArgs {
  input: IUpdateOrderInput
}


export interface IMutationUpdateStoreArgs {
  input: IStoreInput
}


export interface IMutationUserReportsMissingOrderArgs {
  input: IUserReportsMissingOrderInput
}


export interface IMutationValidateAuthJwtArgs {
  authInput: IValidateAuthJwtInput
}


export interface IMutationVoidSaleArgs {
  fdSaleId: Scalars['String']
}

/** 
 * https://relay.dev/graphql/connections.htm#sec-Node
 * 
 * Interface that is implemented by an application data node.
 */
export interface INode {
  readonly id: Maybe<Scalars['ID']>,
}

export enum OfferType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface IOfferVariable {
  readonly __typename?: 'OfferVariable',
  /** The key of OfferVariable. */
  readonly key: Scalars['String'],
  /** 
 * The type of OfferVariable to be used by FE. Available types:
   * 'currency',
   * 'datetime',
   * 'int',
   * 'number',
   * 'string',
 */
  readonly type: Scalars['String'],
  /** The value of OfferVariable. */
  readonly value: Scalars['String'],
}

/** 
 * Operating hours for a restaurant in local time formatted
 * as "YYYY-MM-DD hh:mm:ss" (the date component should be ignored)
 */
export interface IOperatingHours {
  readonly __typename?: 'OperatingHours',
  /** Monday operating hours open */
  readonly monOpen: Maybe<Scalars['String']>,
  /** Monday operating hours close */
  readonly monClose: Maybe<Scalars['String']>,
  /** Tuesday operating hours open */
  readonly tueOpen: Maybe<Scalars['String']>,
  /** Tuesday operating hours close */
  readonly tueClose: Maybe<Scalars['String']>,
  /** Wednesday operating hours open */
  readonly wedOpen: Maybe<Scalars['String']>,
  /** Wednesday operating hours close */
  readonly wedClose: Maybe<Scalars['String']>,
  /** Thursday operating hours open */
  readonly thrOpen: Maybe<Scalars['String']>,
  /** Thursday operating hours close */
  readonly thrClose: Maybe<Scalars['String']>,
  /** Friday operating hours open */
  readonly friOpen: Maybe<Scalars['String']>,
  /** Friday operating hours close */
  readonly friClose: Maybe<Scalars['String']>,
  /** Saturday operating hours open */
  readonly satOpen: Maybe<Scalars['String']>,
  /** Saturday operating hours close */
  readonly satClose: Maybe<Scalars['String']>,
  /** Sunday operating hours open */
  readonly sunOpen: Maybe<Scalars['String']>,
  /** Sunday operating hours close */
  readonly sunClose: Maybe<Scalars['String']>,
}

export enum OperationalStatus {
  CLOSED = 'CLOSED',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
  OPEN = 'OPEN',
  PROJECTED = 'PROJECTED'
}

export interface IOrder {
  readonly __typename?: 'Order',
  readonly cart: ICart,
  readonly catering: Maybe<ICatering>,
  readonly createdAt: Scalars['String'],
  readonly delivery: Maybe<IDelivery>,
  readonly fireOrderIn: Maybe<Scalars['Int']>,
  /** Same value as rbiOrderId, used for Apollo Cache */
  readonly id: Maybe<Scalars['String']>,
  readonly order: Maybe<IRbiOrder>,
  readonly pk: Scalars['String'],
  readonly posOrderId: Maybe<Scalars['String']>,
  readonly posVendor: PosVendor,
  readonly rbiOrderId: Scalars['String'],
  readonly revision: Scalars['Int'],
  readonly sk: Scalars['String'],
  readonly status: RbiOrderStatus,
  readonly updatedAt: Scalars['String'],
  readonly userId: Maybe<Scalars['String']>,
  readonly userSortKey: Scalars['String'],
  readonly loyaltyTransaction: Maybe<ILoyaltyTransaction>,
}

export enum OrderingStatus {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LIVE = 'live',
  PROD = 'prod',
  TEMPORARY_UNAVAILABLE = 'temporary_unavailable',
  TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable'
}

export interface IOrderListResponse {
  readonly __typename?: 'OrderListResponse',
  readonly count: Scalars['Int'],
  readonly orders: Maybe<ReadonlyArray<Maybe<IOrder>>>,
  readonly resumeAfter: Maybe<Scalars['String']>,
}

/** 
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * 
 * Page information to determine if there are more results, and what node,
 * determined by it's cursor, is at the start and end of the page returned.
 */
export interface IPageInfo {
  readonly __typename?: 'PageInfo',
  readonly hasNextPage: Scalars['Boolean'],
  readonly hasPreviousPage: Scalars['Boolean'],
  readonly startCursor: Maybe<Scalars['String']>,
  readonly endCursor: Maybe<Scalars['String']>,
}

export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu',
  readonly plu: Maybe<Scalars['String']>,
  readonly childPlu: Maybe<Scalars['String']>,
}

export interface IParentChildPluInput {
  readonly plu?: Maybe<Scalars['String']>,
  readonly childPlu?: Maybe<Scalars['String']>,
}

export interface IPayment {
  readonly __typename?: 'Payment',
  readonly approvalNumber: Maybe<Scalars['String']>,
  readonly cardType: Maybe<Scalars['String']>,
  readonly ccLast4: Maybe<Scalars['String']>,
  readonly fdCorrelationId: Maybe<Scalars['String']>,
  readonly fdSaleId: Scalars['String'],
  readonly panToken: Maybe<Scalars['String']>,
  readonly paymentType: Maybe<CartPaymentType>,
}

export interface IPaymentInput {
  /** Adyen payment data */
  readonly adyenInput?: Maybe<IAdyenPayment>,
  /** Details from Apple Pay for payment. */
  readonly applePayDetails?: Maybe<IApplePay>,
  /** Billing address associated to card */
  readonly billingAddress?: Maybe<IBillingAddressInput>,
  /** Denotes a cash payment */
  readonly cashPayment?: Maybe<Scalars['Boolean']>,
  /** Contains supplemental data for CC transactions */
  readonly ccMetadata?: Maybe<ICreditCardMetadataInput>,
  /** chase id from TH endpoint to trigger direct payment */
  readonly chaseProfileId?: Maybe<Scalars['String']>,
  /** First Data payment data */
  readonly firstDataInput?: Maybe<IFirstDataPayment>,
  /** Name on credit card */
  readonly fullName: Scalars['String'],
  /** Details from Google Pay for payment. */
  readonly googlePayDetails?: Maybe<IGooglePay>,
  /** 
 * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
 */
  readonly kountSessionId?: Maybe<Scalars['String']>,
}

export interface IPaymentMethodData {
  /** Card display name with last 4 digits of the credit card */
  readonly displayName?: Maybe<Scalars['String']>,
  /** Payment type used for digital pay */
  readonly paymentType?: Maybe<Scalars['String']>,
}

export enum PaymentProcessor {
  ADYEN = 'ADYEN',
  CHASE = 'CHASE',
  FIRSTDATA = 'FIRSTDATA'
}

export interface IPhysicalAddress {
  readonly __typename?: 'PhysicalAddress',
  readonly address1: Maybe<Scalars['String']>,
  readonly address2: Maybe<Scalars['String']>,
  readonly city: Maybe<Scalars['String']>,
  readonly country: Maybe<Scalars['String']>,
  readonly postalCode: Maybe<Scalars['String']>,
  readonly stateProvince: Maybe<Scalars['String']>,
}

export interface IPlaceCateringOrderInput {
  /** 
 * Billing address Comes in the following format
   * billingStreetAddress, billingApt, billingCity, billingState, billingZip
 */
  readonly billingAddress?: Maybe<IBillingAddressInput>,
  /** 
 * Catering Information
   * contains Datetime for the catering
 */
  readonly cateringInfo: ICateringInfoInput,
  /** 
 * First 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{6}$")
 */
  readonly ccBin?: Maybe<Scalars['String']>,
  /** Credit card 2 digit expiry month */
  readonly ccExpiryMonth?: Maybe<Scalars['String']>,
  /** Credit card 2 digit expiry year */
  readonly ccExpiryYear?: Maybe<Scalars['String']>,
  /** 
 * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{4}$")
 */
  readonly ccLast4?: Maybe<Scalars['String']>,
  /** The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX) */
  readonly creditType?: Maybe<CartPaymentCardType>,
  /** Store email address */
  readonly storeEmail?: Maybe<Scalars['String']>,
  /** Valid access token for accessing First Data API */
  readonly fdAccessToken?: Maybe<Scalars['String']>,
  /** 
 * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce.
 */
  readonly fdNonce?: Maybe<Scalars['String']>,
  /** 
 * The First Data payment method ID which must be associated to the user
   * making the request.
 */
  readonly fdAccountId?: Maybe<Scalars['String']>,
  /** Customer full name */
  readonly fullName?: Maybe<Scalars['String']>,
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'],
  /** 
 * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
 */
  readonly kountSessionId?: Maybe<Scalars['String']>,
  /** 
 * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   * 
   * Note that the "sessionId" field is deprecated and will be ignored.
 */
  readonly sessionId?: Maybe<Scalars['String']>,
  /** 
 * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
 */
  readonly redeemedOn?: Maybe<Scalars['String']>,
}

export { Platform };

export interface IPlu {
  readonly __typename?: 'Plu',
  readonly connector: Maybe<Scalars['String']>,
  readonly ncr: Maybe<Scalars['String']>,
  readonly ncrDelivery: Maybe<Scalars['String']>,
  readonly productNumber: Maybe<Scalars['String']>,
  readonly productNumberDelivery: Maybe<Scalars['String']>,
  /** QST is not current supported */
  readonly qst: Maybe<Scalars['String']>,
  readonly sicom: Maybe<Scalars['String']>,
  readonly sicomDelivery: Maybe<Scalars['String']>,
}

export interface IPluData {
  readonly __typename?: 'PluData',
  readonly plus: Maybe<Scalars['String']>,
  readonly deliveryPlus: Maybe<Scalars['String']>,
  readonly updatedAt: Maybe<Scalars['String']>,
}

export interface IPluInput {
  readonly connector?: Maybe<Scalars['String']>,
  readonly ncr?: Maybe<Scalars['String']>,
  readonly ncrDelivery?: Maybe<Scalars['String']>,
  readonly productNumber?: Maybe<Scalars['String']>,
  readonly qst?: Maybe<Scalars['String']>,
  readonly rpos?: Maybe<Scalars['String']>,
  readonly rposDelivery?: Maybe<Scalars['String']>,
  readonly sicom?: Maybe<Scalars['String']>,
  readonly sicomDelivery?: Maybe<Scalars['String']>,
}

export enum PosVendor {
  CARROLS = 'CARROLS',
  CONNECTOR = 'CONNECTOR',
  NCR = 'NCR',
  OHEICS = 'OHEICS',
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  QDI = 'QDI',
  QST = 'QST',
  RPOS = 'RPOS',
  SICOM = 'SICOM',
  TABLET = 'TABLET'
}

/** Merge two prepaid gift cards into one. Source gets deleted. */
export interface IPrepaidsMergeInput {
  /** Destination first data gift card Account ID gets balance from source */
  readonly destinationFdAccountId?: Maybe<Scalars['String']>,
  /** Number of physical Gift Card which is the funding source (card being deactivated) */
  readonly sourceCardNumber: Scalars['String'],
  /** Pin number for physical gift card which is the funding source (card being deactivated) */
  readonly sourcePin?: Maybe<Scalars['String']>,
}

/** Reload a prepaid gift card (payment method) */
export interface IPrepaidsReloadInput {
  /** Country of currency to reload card */
  readonly countryCode?: Maybe<CountryCode>,
  /** 
 * Vaulted first data Account ID (credit) used to fund gift card.
   * Either this or applePayDetails is required.
   * Only one of fdAccountId or
   * applePayDetails or googlePayDetails should be provided.
 */
  readonly fdAccountId?: Maybe<Scalars['String']>,
  /** Amount to fund to gift card account in cents */
  readonly fundValue: Scalars['Int'],
  /** First Data Account ID of prepaid gift card to be reloaded */
  readonly prepaidFdAccountId: Scalars['String'],
  /** 
 * Details from Apple Pay for funding. Only one of fdAccountId or
   * applePayDetails or googlePayDetails should be provided.
 */
  readonly applePayDetails?: Maybe<IApplePay>,
  /** 
 * Details from Goole Pay for funding. Only one of fdAccountId or
   * applePayDetails or googlePayDetails should be provided.
 */
  readonly googlePayDetails?: Maybe<IGooglePay>,
  /** 
 * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
 */
  readonly kountSessionId?: Maybe<Scalars['String']>,
  /** 
 * Session ID as set by the FE.
   * 
   * Note that the "sessionId" field is deprecated and will be ignored.
 */
  readonly sessionId?: Maybe<Scalars['String']>,
}

/** A transaction for a prepaid gift card */
export interface IPrepaidTransaction {
  readonly __typename?: 'PrepaidTransaction',
  /** First Data account ID */
  readonly amount: Scalars['Int'],
  readonly currencyCode: ICurrencyCode,
  readonly info: Scalars['String'],
  readonly transactionTime: Scalars['String'],
}

export interface IPriceDeliveryInput {
  readonly instructions?: Maybe<Scalars['String']>,
  readonly dropoff: IDeliveryWaypointInput,
  readonly tipCents?: Maybe<Scalars['Int']>,
}

export interface IPriceOrderInput {
  /** payment method - for cash orders */
  readonly paymentMethod?: Maybe<CartPaymentCardType>,
  /** Store Address, derived from MDM. */
  readonly storeAddress: IStoreAddressInput,
  /** Store ID, derived from MDM. This value will be validated within First Data. */
  readonly storeId: Scalars['String'],
  /** The internal Store ID. */
  readonly storePosId?: Maybe<Scalars['String']>,
  /** The brand of the store. */
  readonly brand: Brand,
  /** The Platform */
  readonly platform?: Maybe<Platform>,
  /** The POS Vendor */
  readonly posVendor: PosVendor,
  /** The locale of the customer. */
  readonly customerLocale?: Maybe<Scalars['String']>,
  /** 
 * The name of the customer. If provided, this will
   * supersede the user's name on this order.
 */
  readonly customerName?: Maybe<Scalars['String']>,
  /** How the order will be executed. */
  readonly serviceMode: ServiceMode,
  /** Requested sale amount in cents (USD) */
  readonly requestedAmountCents: Scalars['Int'],
  /** The order cart entries to be injected into the POS. */
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntryInput>>,
  /** The cart shape version. */
  readonly cartVersion?: Maybe<Scalars['Int']>,
  /** barcode of user's loyalty card to apply reward/visit */
  readonly loyaltyBarcode?: Maybe<Scalars['String']>,
  /** flag for reward redemption, if true must provide loyaltyBarcode */
  readonly redeemReward?: Maybe<Scalars['Boolean']>,
  /** Offers applied to cart */
  readonly appliedOffers?: Maybe<ReadonlyArray<Maybe<IAppliedOffer>>>,
  /** Reward ids being applied to cart */
  readonly rewardsApplied?: Maybe<ReadonlyArray<Maybe<IAppliedReward>>>,
  /** 
 * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
 */
  readonly redeemedOn?: Maybe<Scalars['String']>,
  /** 
 * Cart Item swaps being applied to cart
   * @deprecated(reason: "Not needed anymore since it is included in AppliedOffer")
 */
  readonly swaps?: Maybe<ReadonlyArray<Maybe<ISwapInput>>>,
  /** vat number on the restaurant document for BK UK */
  readonly vatNumber?: Maybe<Scalars['String']>,
}

export interface IQuantityPlu {
  readonly __typename?: 'QuantityPlu',
  readonly qualifier: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Int']>,
  readonly plu: Maybe<Scalars['String']>,
}

export interface IQuantityPluInput {
  readonly qualifier?: Maybe<Scalars['String']>,
  readonly quantity?: Maybe<Scalars['Int']>,
  readonly plu?: Maybe<Scalars['String']>,
}

export interface IQuery {
  readonly __typename?: 'Query',
  /** API Metadata */
  readonly api: Maybe<IApiMetadata>,
  /** Query an order by providing a catering JWT for the current order */
  readonly cateringOrder: Maybe<IOrder>,
  /** Obtain a quote to deliver an order. */
  readonly deliveryQuote: IDelivery,
  /** Returns an available delivery restaurant based on vendor quote given provided address and search radius. */
  readonly deliveryRestaurant: IDeliveryRestaurant,
  /** 
 * Evaluate all couponIds from sanity. All cart-dependent rules are bypassed.
   * If authenticated, offers will evaluated in the context of the authenticated user id.
 */
  readonly evaluateAllUserOffers: ICouponUserOffersFeedback,
  /** 
 * Evaluate user offers: either those in the cart or a set to be evaluated against one.
   * If no cart and no RBI order are specified, then all cart-dependent rules are bypassed.
   * If authenticated, offers will evaluated in the context of the authenticated user id.
   * Setting the evaluateAllCouponIds flag will ignore couponIds and evaluate all couponIds from sanity.
 */
  readonly evaluateUserOffers: ICouponUserOffersFeedback,
  /** Get a specific coupon for the authenticated user id. */
  readonly getCoupon: Maybe<ICoupon>,
  /** Gets a base64 encoded Apple Pass for a loyalty card */
  readonly getLoyaltyCardApplePass: Maybe<ILoyaltyCardApplePass>,
  /** Get the details for a user's loyalty card */
  readonly getLoyaltyCardDetails: Maybe<ILoyaltyCardDetails>,
  /** Get the details for a user's loyalty card via barcode *UNAUTHENTICATED* */
  readonly getLoyaltyCardDetailsKiosk: Maybe<ILoyaltyCardDetailsKiosk>,
  /** Gets a jwt for Google Pass for a loyalty card */
  readonly getLoyaltyCardGooglePass: Maybe<ILoyaltyCardGooglePass>,
  /** Get the transactions for a user's loyalty card */
  readonly getLoyaltyCardTransactions: Maybe<ILoyaltyCardTransactions>,
  /** Get the loyalty cards for a user. @todo put this on me */
  readonly getLoyaltyCards: Maybe<ILoyaltyCardsResp>,
  /** Get the Roll Up The Rim prizes stats */
  readonly getLoyaltyRollUpTheRimPrizesStats: Maybe<ILoyaltyRollUpTheRimPrizesStats>,
  /** Get the list of tokens representing shared rolls from a user's event timeline. */
  readonly getLoyaltyRollUpTheRimTimelineEventSharedRollTokens: Maybe<ILoyaltyRollUpTheRimTimelineEventSharedRollTokenList>,
  /** Get the Roll Up The Rim timeline events, summarized for a user */
  readonly getLoyaltyRollUpTheRimTimelineEventSummary: Maybe<ILoyaltyRollUpTheRimTimelineEventSummaryList>,
  /** Get the Roll Up The Rim timeline events for a user */
  readonly getLoyaltyRollUpTheRimTimelineEvents: Maybe<ILoyaltyRollUpTheRimTimelineEventList>,
  /** Get a specific store by id */
  readonly getStore: Maybe<IStore>,
  /** Evaluate the redemption eligibility of a coupon for the authenticated user id. */
  readonly isCouponRedeemable: ICouponRedemptionEligibility,
  /** Query all coupon tokens by coupon and the authenticated user id. */
  readonly listCouponTokens: ICouponTokenListResponse,
  /** Query all coupons for the authenticated user id. */
  readonly listCoupons: ICouponListResponse,
  /** Query all gift offers. */
  readonly listGiftOffers: Maybe<IGiftOfferListResponse>,
  readonly listUserCouponTokens: ICouponTokenListResponse,
  readonly me: IUser,
  /** Query an order by order id for the current user. */
  readonly order: Maybe<IOrder>,
  /** Query an order's history by order id */
  readonly orderRevisions: IOrderListResponse,
  readonly pluData: Maybe<IPluData>,
  /** Return transaction history for prepaid gift card account from FD */
  readonly prepaidsTransactions: Maybe<ITransactionListResponse>,
  /** Returns a restaurant entity given store id */
  readonly restaurant: IRestaurant,
  /** 
 * Returns a list of restaurants based on provided filters.
   * @todo: Return result with pagination metadata
 */
  readonly restaurants: Maybe<IRestaurantsConnection>,
  /** Check if the registration is complete */
  readonly signUpComplete: Maybe<Scalars['Boolean']>,
  /** Query orders from unique stores for current user. */
  readonly uniqueStores: IOrderListResponse,
  /** Fetch all accounts for current customer (limit 100) */
  readonly userAccounts: Maybe<IAccountListResponse>,
  readonly userGeo: IUserCountry,
  /** 
 * Query all orders for current user.
   * 
   * Note that the "userId" field is deprecated and will be ignored.
 */
  readonly userOrders: IOrderListResponse,
}


export interface IQueryCateringOrderArgs {
  cateringJwt: Scalars['String']
}


export interface IQueryDeliveryQuoteArgs {
  dropoff: IDeliveryWaypointInput,
  pickup: IDeliveryWaypointInput,
  requestedAmountCents: Maybe<Scalars['Int']>,
  serviceMode: Maybe<ServiceMode>
}


export interface IQueryDeliveryRestaurantArgs {
  dropoff: IDeliveryWaypointInput,
  searchRadius: Scalars['Float']
}


export interface IQueryEvaluateAllUserOffersArgs {
  locale: Maybe<Locale>,
  platform: Maybe<Platform>,
  redeemedOn: Scalars['String'],
  serviceMode: Maybe<ServiceMode>,
  storeId: Maybe<Scalars['String']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryEvaluateUserOffersArgs {
  cart: Maybe<IPriceOrderInput>,
  couponIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>,
  evaluateAllCouponIds: Maybe<Scalars['Boolean']>,
  locale: Maybe<Locale>,
  platform: Maybe<Platform>,
  rbiOrderId: Maybe<Scalars['ID']>,
  redeemedOn: Scalars['String'],
  serviceMode: Maybe<ServiceMode>,
  storeId: Maybe<Scalars['String']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryGetCouponArgs {
  couponId: Scalars['ID'],
  userId: Maybe<Scalars['ID']>
}


export interface IQueryGetLoyaltyCardApplePassArgs {
  cardId: Scalars['String']
}


export interface IQueryGetLoyaltyCardDetailsArgs {
  cardId: Scalars['String']
}


export interface IQueryGetLoyaltyCardDetailsKioskArgs {
  barcode: Scalars['String'],
  operator: Scalars['String'],
  restaurantId: Scalars['String'],
  terminal: Scalars['String'],
  transactionId: Scalars['String']
}


export interface IQueryGetLoyaltyCardGooglePassArgs {
  cardId: Scalars['String']
}


export interface IQueryGetLoyaltyCardTransactionsArgs {
  cardId: Scalars['String'],
  endDate: Maybe<Scalars['String']>,
  page: Maybe<Scalars['String']>,
  pageSize: Maybe<Scalars['String']>,
  startDate: Maybe<Scalars['String']>
}


export interface IQueryGetLoyaltyCardsArgs {
  status: Maybe<Scalars['String']>
}


export interface IQueryGetLoyaltyRollUpTheRimPrizesStatsArgs {
  eventId: Maybe<Scalars['String']>
}


export interface IQueryGetLoyaltyRollUpTheRimTimelineEventSummaryArgs {
  eventId: Maybe<Scalars['String']>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>
}


export interface IQueryGetLoyaltyRollUpTheRimTimelineEventsArgs {
  eventId: Maybe<Scalars['String']>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>
}


export interface IQueryGetStoreArgs {
  storeId: Scalars['ID']
}


export interface IQueryIsCouponRedeemableArgs {
  cart: Maybe<IPriceOrderInput>,
  couponId: Scalars['ID'],
  rbiOrderId: Maybe<Scalars['ID']>,
  redeemedOn: Scalars['String'],
  ruleSet: Maybe<Scalars['String']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryListCouponTokensArgs {
  couponId: Scalars['ID'],
  expiresAfter: Maybe<Scalars['String']>,
  expiresBefore: Maybe<Scalars['String']>,
  limit: Maybe<Scalars['Int']>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryListCouponsArgs {
  expiresAfter: Maybe<Scalars['String']>,
  expiresBefore: Maybe<Scalars['String']>,
  includeRedeemed: Maybe<Scalars['Boolean']>,
  limit: Maybe<Scalars['Int']>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryListUserCouponTokensArgs {
  couponId: Maybe<Scalars['ID']>,
  expiresAfter: Maybe<Scalars['String']>,
  expiresBefore: Maybe<Scalars['String']>,
  limit: Maybe<Scalars['Int']>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryMeArgs {
  numUniquePurchasedItems: Maybe<Scalars['Int']>,
  customInput: Maybe<IMeInput>
}


export interface IQueryOrderArgs {
  rbiOrderId: Scalars['ID']
}


export interface IQueryOrderRevisionsArgs {
  limit: Maybe<Scalars['Int']>,
  rbiOrderId: Scalars['ID'],
  resumeAfter: Maybe<Scalars['String']>,
  revision: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>
}


export interface IQueryPluDataArgs {
  storeId: Scalars['String']
}


export interface IQueryPrepaidsTransactionsArgs {
  fdAccountId: Maybe<Scalars['String']>,
  cardNumber: Maybe<Scalars['String']>
}


export interface IQueryRestaurantArgs {
  storeId: Maybe<Scalars['String']>,
  storeNumber: Maybe<Scalars['String']>,
  localDateTime: Maybe<Scalars['String']>
}


export interface IQueryRestaurantsArgs {
  input: Maybe<IRestaurantsInput>
}


export interface IQuerySignUpCompleteArgs {
  jwt: Scalars['String']
}


export interface IQueryUniqueStoresArgs {
  createdAfter: Maybe<Scalars['String']>,
  createdBefore: Maybe<Scalars['String']>,
  limit: Maybe<Scalars['Int']>,
  orderStatuses: Maybe<ReadonlyArray<RbiOrderStatus>>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>
}


export interface IQueryUserAccountsArgs {
  feCountryCode: Maybe<IsoCountryCode>
}


export interface IQueryUserOrdersArgs {
  createdAfter: Maybe<Scalars['String']>,
  createdBefore: Maybe<Scalars['String']>,
  limit: Maybe<Scalars['Int']>,
  orderStatuses: Maybe<ReadonlyArray<RbiOrderStatus>>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>,
  userId: Maybe<Scalars['ID']>,
  shouldFilterByRegion: Maybe<Scalars['Boolean']>
}

export interface IRbiOrder {
  readonly __typename?: 'RbiOrder',
  readonly refund: Maybe<IRefund>,
}

export enum RbiOrderStatus {
  CATERING_DECLINED = 'CATERING_DECLINED',
  CATERING_ERROR = 'CATERING_ERROR',
  CATERING_PLACED = 'CATERING_PLACED',
  CATERING_SUCCESSFUL = 'CATERING_SUCCESSFUL',
  INSERT_ERROR = 'INSERT_ERROR',
  INSERT_REQUESTED = 'INSERT_REQUESTED',
  INSERT_SUCCESSFUL = 'INSERT_SUCCESSFUL',
  KOUNT_DENIAL = 'KOUNT_DENIAL',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_REQUESTED = 'PAYMENT_REQUESTED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',
  PRICE_ERROR = 'PRICE_ERROR',
  PRICE_REQUESTED = 'PRICE_REQUESTED',
  PRICE_SUCCESSFUL = 'PRICE_SUCCESSFUL',
  REFUND_ERROR = 'REFUND_ERROR',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_SUCCESSFUL = 'REFUND_SUCCESSFUL',
  UPDATE_ERROR = 'UPDATE_ERROR',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
  UPDATE_SUCCESSFUL = 'UPDATE_SUCCESSFUL',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export interface IRefund {
  readonly __typename?: 'Refund',
  /** Reason picked from a predefined dropdown list */
  readonly primaryReason: RefundReason,
  /** Items that were refunded. Undefined if order was fully refunded. */
  readonly refundedItems: Maybe<ReadonlyArray<Maybe<IRefundedItem>>>,
  /** Optional reason either added by a support agent or an user via the support form */
  readonly secondaryReason: Maybe<Scalars['String']>,
  readonly subtotal: Scalars['String'],
  readonly tax: Scalars['String'],
  /** Date time when refund was issued */
  readonly transactionDateTime: Scalars['String'],
}

export interface IRefundedItem {
  readonly __typename?: 'RefundedItem',
  /** Name of item refunded */
  readonly name: Maybe<Scalars['String']>,
  /** Plu of item refunded */
  readonly plu: Maybe<Scalars['String']>,
  /** Amount refunded in dollars for item */
  readonly refundAmount: Maybe<Scalars['String']>,
  /** Quantity of item refunded */
  readonly refundQuantity: Maybe<Scalars['String']>,
  /** SanityId of item refunded */
  readonly sanityId: Maybe<Scalars['String']>,
  /** Type of item refunded */
  readonly type: Maybe<CartEntryType>,
}

export enum RefundReason {
  CATERING_ORDER_DECLINED = 'CATERING_ORDER_DECLINED',
  CATERING_ORDER_ERROR = 'CATERING_ORDER_ERROR',
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  MISSING_OR_INCORRECT_ITEM = 'MISSING_OR_INCORRECT_ITEM',
  ORDER_ARRIVED_LATE = 'ORDER_ARRIVED_LATE',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_COMMIT_ERROR = 'ORDER_COMMIT_ERROR',
  ORDER_NEVER_ARRIVED = 'ORDER_NEVER_ARRIVED',
  ORDER_WAS_DAMAGED = 'ORDER_WAS_DAMAGED',
  RESTAURANT_CLOSED = 'RESTAURANT_CLOSED',
  RESTAURANT_COULDNT_FIND_ORDER = 'RESTAURANT_COULDNT_FIND_ORDER'
}

/** A Prepaid Reload response (payment method) */
export interface IReload {
  readonly __typename?: 'Reload',
  /** dollar amount gift card begins with */
  readonly beginBalance: Scalars['Int'],
  readonly currencyCode: Scalars['String'],
  /** current gift card balance in dollars */
  readonly currentBalance: Scalars['Int'],
  /** First Data account id of gift card */
  readonly fdAccountId: Scalars['String'],
  readonly fdCorrelationId: Maybe<Scalars['String']>,
  readonly transactionId: Scalars['String'],
}

export interface IResendOtpInput {
  /** 
 * User email. Only one of email or phone number should be provided
   * Example foobar@example.com
 */
  readonly email?: Maybe<Scalars['String']>,
  /** 
 * User phone number. Only one of email or phone number should be provided
   * Example 4258675309
 */
  readonly phoneNumber?: Maybe<Scalars['String']>,
  /** Requestor's platform */
  readonly platform: Platform,
}

export interface IResendVerificationEmailInput {
  /** user's current platform */
  readonly platform: Platform,
  /** user's current stage */
  readonly stage: Stage,
}

export interface IRestaurant {
  readonly __typename?: 'Restaurant',
  /** 
 * The MDM number identifier. This is the `number` property on the sanity store obj
   * this is NOT the `_id` property
 */
  readonly storeId: Maybe<Scalars['String']>,
  /** 
 * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in sanity
 */
  readonly available: Scalars['Boolean'],
  /** 
 * DEPRECATED
   * Last record heartbeat timestamp on this restaurant
 */
  readonly lastHeartbeatTimestamp: Maybe<Scalars['String']>,
  /** Pos Vendor associated with restaurant */
  readonly posVendor: Maybe<Scalars['String']>,
  /** Curside operating hours */
  readonly curbsideHours: Maybe<IOperatingHours>,
  /** Delivery operating hours */
  readonly deliveryHours: Maybe<IOperatingHours>,
  /** Dining room operating hours */
  readonly diningRoomHours: Maybe<IOperatingHours>,
  /** Drive through operating hours */
  readonly driveThruHours: Maybe<IOperatingHours>,
  /** Restaurant Vat Number for BK UK */
  readonly vatNumber: Maybe<Scalars['String']>,
}

export interface IRestaurantEdge  extends IEdge {
  readonly __typename?: 'RestaurantEdge',
  readonly cursor: Scalars['String'],
  readonly node: IRestaurantNode,
}

/** Extended restaurant data containing all fields from Sanity + Dynamo */
export interface IRestaurantNode  extends INode {
  readonly __typename?: 'RestaurantNode',
  /** Arbitrary unique identifier. */
  readonly id: Maybe<Scalars['ID']>,
  /** While pagination spec requires an id, Sanity and Frontend use _id */
  readonly _id: Maybe<Scalars['String']>,
  /** 
 * The MDM number identifier. This is the `number` property on the sanity store obj
   * this is NOT the `_id` property
 */
  readonly storeId: Maybe<Scalars['String']>,
  /** 
 * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in sanity
 */
  readonly isAvailable: Scalars['Boolean'],
  /** Pos Vendor associated with restaurant */
  readonly posVendor: Maybe<Scalars['String']>,
  readonly chaseMerchantId: Maybe<Scalars['String']>,
  readonly curbsideHours: Maybe<IOperatingHours>,
  readonly deliveryHours: Maybe<IOperatingHours>,
  readonly diningRoomHours: Maybe<IOperatingHours>,
  readonly distanceInMiles: Maybe<Scalars['Int']>,
  readonly drinkStationType: Maybe<Scalars['String']>,
  readonly driveThruHours: Maybe<IOperatingHours>,
  readonly driveThruLaneType: Maybe<Scalars['String']>,
  readonly email: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly environment: Maybe<RestaurantStatus>,
  readonly franchiseGroupId: Maybe<Scalars['Int']>,
  readonly franchiseGroupName: Maybe<Scalars['String']>,
  readonly frontCounterClosed: Maybe<Scalars['Boolean']>,
  readonly hasBreakfast: Maybe<Scalars['Boolean']>,
  readonly hasBurgersForBreakfast: Maybe<Scalars['Boolean']>,
  readonly hasCatering: Maybe<Scalars['Boolean']>,
  readonly hasCurbside: Maybe<Scalars['Boolean']>,
  readonly hasDelivery: Maybe<Scalars['Boolean']>,
  readonly hasDineIn: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering: Maybe<Scalars['Boolean']>,
  readonly hasParking: Maybe<Scalars['Boolean']>,
  readonly hasPlayground: Maybe<Scalars['Boolean']>,
  readonly hasTakeOut: Maybe<Scalars['Boolean']>,
  readonly hasWifi: Maybe<Scalars['Boolean']>,
  readonly isDarkKitchen: Maybe<Scalars['Boolean']>,
  readonly isFavorite: Scalars['Boolean'],
  readonly isRecent: Scalars['Boolean'],
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly mobileOrderingStatus: Maybe<OrderingStatus>,
  readonly name: Maybe<Scalars['String']>,
  readonly number: Maybe<Scalars['String']>,
  readonly parkingType: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly physicalAddress: Maybe<IPhysicalAddress>,
  readonly playgroundType: Maybe<Scalars['String']>,
  readonly pos: Maybe<IRestaurantPos>,
  readonly posRestaurantId: Maybe<Scalars['String']>,
  readonly restaurantImage: Maybe<ISanityImage>,
  readonly status: Maybe<Scalars['String']>,
  readonly restaurantPosData: Maybe<IRestaurantPosData>,
  readonly vatNumber: Maybe<Scalars['String']>,
}

export interface IRestaurantPos {
  readonly __typename?: 'RestaurantPos',
  readonly vendor: Maybe<Scalars['String']>,
}

export interface IRestaurantPosData {
  readonly __typename?: 'RestaurantPosData',
  readonly _id: Maybe<Scalars['String']>,
}

export interface IRestaurantsConnection  extends IConnection {
  readonly __typename?: 'RestaurantsConnection',
  readonly edges: ReadonlyArray<IRestaurantEdge>,
  readonly nodes: ReadonlyArray<IRestaurantNode>,
  readonly totalCount: Maybe<Scalars['Int']>,
  readonly pageInfo: IPageInfo,
}

export interface IRestaurantsInput {
  /** 
 * Return first provided number of edges for pagination query.
   * Used in combination with after field.
 */
  readonly first?: Maybe<Scalars['Int']>,
  /** 
 * Return last provided number of edges for pagination query.
   * Used in combination with before field.
 */
  readonly last?: Maybe<Scalars['Int']>,
  /** 
 * An opaque cursor for pagination. Return results after provided cursor.
   * Used in combination with first field.
 */
  readonly after?: Maybe<Scalars['String']>,
  /** 
 * An opaque cursor for pagination. Return results before provided cursor.
   * Used in combination with last field.
 */
  readonly before?: Maybe<Scalars['String']>,
  /** A coordinates object that sorts results based on location provided. */
  readonly coordinates?: Maybe<ICoordinates>,
  /** A list of store IDs to filter to */
  readonly ids?: Maybe<ReadonlyArray<Scalars['ID']>>,
  /** 
 * Filter to a subset of stores
   * Defaults to NEARBY
 */
  readonly filter?: Maybe<FilterRestaurantType>,
  /** 
 * A list of service modes to search for.
   * Filters list to subset of stores that have one of the service modes available.
 */
  readonly serviceModes?: Maybe<ReadonlyArray<ServiceMode>>,
  /** 
 * Restaurant operational status.
   * Filters list to subset of stores that have the provided status.
 */
  readonly status?: Maybe<OperationalStatus>,
  /** 
 * A flag to enable strict radius checking. When enabled, stores will be filtered
   * based on a circle radius. Any stores outside the radius are not included.
 */
  readonly radiusStrictMode?: Maybe<Scalars['Boolean']>,
}

export enum RestaurantStatus {
  DEV = 'DEV',
  PROD = 'PROD'
}

/** WARNING: Likely to be deprecated in favor of "order" */
export interface ISale {
  readonly __typename?: 'Sale',
  /** 
 * First Data sale id. This will be used for any further actions on the sale
   * (eg to void the sale)
 */
  readonly fdSaleId: Scalars['String'],
  /** Id for generated order */
  readonly orderId: Scalars['String'],
  readonly status: Maybe<Scalars['String']>,
}

export interface ISanityImage {
  readonly __typename?: 'SanityImage',
  readonly asset: Maybe<ISanityImageAsset>,
  readonly crop: Maybe<ISanityImageCrop>,
  readonly hotspot: Maybe<ISanityImageHotspot>,
}

export interface ISanityImageAsset {
  readonly __typename?: 'SanityImageAsset',
  readonly _id: Maybe<Scalars['String']>,
  readonly metadata: Maybe<ISanityImageMetaData>,
}

export interface ISanityImageCrop {
  readonly __typename?: 'SanityImageCrop',
  readonly top: Maybe<Scalars['Float']>,
  readonly bottom: Maybe<Scalars['Float']>,
  readonly left: Maybe<Scalars['Float']>,
  readonly right: Maybe<Scalars['Float']>,
}

export interface ISanityImageHotspot {
  readonly __typename?: 'SanityImageHotspot',
  readonly height: Maybe<Scalars['Float']>,
  readonly width: Maybe<Scalars['Float']>,
  readonly x: Maybe<Scalars['Float']>,
  readonly y: Maybe<Scalars['Float']>,
}

export interface ISanityImageMetaData {
  readonly __typename?: 'SanityImageMetaData',
  readonly lqip: Maybe<Scalars['String']>,
  readonly palette: Maybe<ISanityImagePalette>,
}

export interface ISanityImagePalette {
  readonly __typename?: 'SanityImagePalette',
  readonly dominant: Maybe<ISanityImagePaletteSwatch>,
}

export interface ISanityImagePaletteSwatch {
  readonly __typename?: 'SanityImagePaletteSwatch',
  readonly background: Maybe<Scalars['String']>,
  readonly foreground: Maybe<Scalars['String']>,
}

export enum ServiceMode {
  CATERING_DELIVERY = 'CATERING_DELIVERY',
  CATERING_PICKUP = 'CATERING_PICKUP',
  CURBSIDE = 'CURBSIDE',
  DELIVERY = 'DELIVERY',
  DRIVE_THRU = 'DRIVE_THRU',
  EAT_IN = 'EAT_IN',
  TAKEOUT = 'TAKEOUT'
}

export interface ISignInUserInput {
  readonly email: Scalars['String'],
  readonly platform: Platform,
  readonly stage: Stage,
}

export interface ISignUpUserInput {
  readonly country: IsoCountryCode,
  readonly dob?: Maybe<Scalars['String']>,
  readonly name: Scalars['String'],
  readonly phoneNumber?: Maybe<Scalars['String']>,
  readonly platform: Platform,
  readonly stage: Stage,
  readonly userName: Scalars['String'],
  readonly wantsPromotionalEmails: Scalars['Boolean'],
  readonly zipcode?: Maybe<Scalars['String']>,
}

export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu',
  readonly comboPlu: Maybe<Scalars['String']>,
  readonly comboSize: Maybe<Scalars['String']>,
}

export interface ISizeBasedPluInput {
  readonly comboPlu?: Maybe<Scalars['String']>,
  readonly comboSize?: Maybe<Scalars['String']>,
}

/** lowercase values are currently set in aws hence the lowercase here */
export enum Stage {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LOCALDEV = 'localdev',
  PROD = 'prod',
  QA = 'qa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
  TEST = 'test'
}

export interface IStore {
  readonly __typename?: 'Store',
  /** The store identity. */
  readonly storeId: Scalars['ID'],
  /** 
 * The set of kiosks retrieved.
   * If this array is empty, there were no matching stores.
 */
  readonly kiosks: Maybe<ReadonlyArray<Maybe<IKiosk>>>,
}

export interface IStoreAddress {
  readonly __typename?: 'StoreAddress',
  readonly addressLine1: Scalars['String'],
  readonly addressLine2: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country: Scalars['String'],
  readonly phoneNumber: Scalars['String'],
  readonly state: Scalars['String'],
  readonly zip: Scalars['String'],
}

export interface IStoreAddressInput {
  readonly addressLine1: Scalars['String'],
  readonly addressLine2?: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country: Scalars['String'],
  readonly phoneNumber: Scalars['String'],
  readonly state: Scalars['String'],
  readonly zip: Scalars['String'],
}

export interface IStoreDetails {
  readonly __typename?: 'StoreDetails',
  readonly deliveryHours: Maybe<IStoreHours>,
  readonly diningRoomHours: Maybe<IStoreHours>,
  readonly driveThruHours: Maybe<IStoreHours>,
  readonly franchiseGroupName: Maybe<Scalars['String']>,
  readonly franchiseGroupId: Maybe<Scalars['Int']>,
  readonly hasCatering: Maybe<Scalars['Boolean']>,
  readonly hasDelivery: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering: Maybe<Scalars['Boolean']>,
  /** Last date time when the store made an order */
  readonly lastActiveDateTime: Maybe<Scalars['String']>,
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly mobileOrderingStatus: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly posVendor: Maybe<Scalars['String']>,
  readonly status: Maybe<Scalars['String']>,
  readonly storeNumber: Maybe<Scalars['String']>,
}

export interface IStoreHours {
  readonly __typename?: 'StoreHours',
  readonly monday: Maybe<IDay>,
  readonly tuesday: Maybe<IDay>,
  readonly wednesday: Maybe<IDay>,
  readonly thursday: Maybe<IDay>,
  readonly friday: Maybe<IDay>,
  readonly saturday: Maybe<IDay>,
  readonly sunday: Maybe<IDay>,
}

export interface IStoreInput {
  /** The store identity. */
  readonly storeId: Scalars['String'],
  /** 
 * The set of kiosks to add.
   * Must contain atleast one kiosk
 */
  readonly kiosks: ReadonlyArray<IKioskInput>,
}

export interface ISupportCase {
  readonly __typename?: 'SupportCase',
  /** Identifier for the case. Useful for the user to have */
  readonly caseId: Maybe<Scalars['String']>,
}

export interface ISupportCaseInput {
  /** Description of the issue the user is having */
  readonly comments: Scalars['String'],
  /** User's email */
  readonly email: Scalars['String'],
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId: Scalars['String'],
  /** User's name */
  readonly name: Scalars['String'],
  /** Unique order identifier in RBI */
  readonly rbiOrderId?: Maybe<Scalars['String']>,
  /** User's region */
  readonly userRegion?: Maybe<Scalars['String']>,
  /** Region user signed up in (account region) */
  readonly userAccountRegion?: Maybe<Scalars['String']>,
}

export interface ISwap {
  readonly __typename?: 'Swap',
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
  readonly cartId: Scalars['String'],
  readonly swapType: Scalars['String'],
}

export interface ISwapInput {
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
  readonly cartId: Scalars['String'],
  readonly swapType: Scalars['String'],
}

export interface ITransactionListResponse {
  readonly __typename?: 'TransactionListResponse',
  readonly fdCorrelationId: Maybe<Scalars['String']>,
  readonly transactions: Maybe<ReadonlyArray<Maybe<IPrepaidTransaction>>>,
}

export interface IUnavailableCartEntry {
  readonly __typename?: 'UnavailableCartEntry',
  readonly lineId: Maybe<Scalars['String']>,
  readonly sanityId: Scalars['String'],
}

export interface IUpdateOrderInput {
  /** number of seconds from now to inject order */
  readonly fireOrderIn: Scalars['Int'],
  readonly rbiOrderId: Scalars['ID'],
}

export interface IUpdateUserDetailsInput {
  readonly autoReloadEnabled?: Maybe<Scalars['Boolean']>,
  readonly autoReloadThreshold?: Maybe<Scalars['Int']>,
  readonly communicationPreferences?: Maybe<ReadonlyArray<Maybe<ICommunicationPreferenceInput>>>,
  readonly defaultAccountIdentifier?: Maybe<Scalars['String']>,
  /** @deprecated(reason: "Use `defaultAccountIdentifier`.") */
  readonly defaultFdAccountId?: Maybe<Scalars['String']>,
  readonly defaultPaymentAccountId?: Maybe<Scalars['String']>,
  readonly defaultReloadAmt?: Maybe<Scalars['Int']>,
  readonly dob?: Maybe<Scalars['String']>,
  readonly favoriteStores?: Maybe<ReadonlyArray<Maybe<IFavoriteStoreInput>>>,
  readonly isoCountryCode?: Maybe<IsoCountryCode>,
  readonly loyaltyTier?: Maybe<Scalars['String']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly phoneNumber?: Maybe<Scalars['String']>,
  readonly promotionalEmails?: Maybe<Scalars['Boolean']>,
  readonly rutrFailedSkillsTestTimestamp?: Maybe<Scalars['String']>,
  readonly rutrPassedSkillsTestTimestamp?: Maybe<Scalars['String']>,
  readonly zipcode?: Maybe<Scalars['String']>,
}

export interface IUser {
  readonly __typename?: 'User',
  /** Cognito user id */
  readonly cognitoId: Scalars['ID'],
  readonly createdAt: Scalars['String'],
  readonly details: IUserDetails,
  /** TH Legacy Cogntio User ID */
  readonly thLegacyCognitoId: Maybe<Scalars['String']>,
  /** loyaltyId used for loyalty API lookup */
  readonly loyaltyId: Maybe<Scalars['String']>,
  readonly uniquePurchasedItems: Maybe<ReadonlyArray<Maybe<ICartEntries>>>,
  readonly updatedAt: Scalars['String'],
}

export enum UserCardCardFormat {
  DIGITAL = 'digital',
  PHYSICAL = 'physical'
}

export enum UserCardCardStatus {
  ACTIVE = 'Active',
  INACTIVE = 'InActive'
}

export enum UserCardCardType {
  ACCUMULATEREDEMPTIONS = 'AccumulateRedemptions'
}

export interface IUserCountry {
  readonly __typename?: 'UserCountry',
  readonly country: Maybe<Scalars['String']>,
}

export interface IUserDetails {
  readonly __typename?: 'UserDetails',
  /** 
 * User Adresses and phone number combinations to be used to alllow users
   * to select from multiple saced addresses
 */
  readonly deliveryAddresses: Maybe<ReadonlyArray<Maybe<IDeliveryAddress>>>,
  /** Giftcard can be auto reloaded */
  readonly autoReloadEnabled: Maybe<Scalars['Boolean']>,
  /** Amount in cents that balance must reach for auto reload */
  readonly autoReloadThreshold: Maybe<Scalars['Int']>,
  /** Array of Communication Preferences */
  readonly communicationPreferences: Maybe<ReadonlyArray<Maybe<ICommunicationPreference>>>,
  /** Account (Adyen or First-Data) ID of auto reload default payment method */
  readonly defaultAccountIdentifier: Maybe<Scalars['String']>,
  /** First Data ID of auto reload default payment method */
  readonly defaultFdAccountId: Maybe<Scalars['String']>,
  /** Adyen or First Data ID of default payment method */
  readonly defaultPaymentAccountId: Maybe<Scalars['String']>,
  /** Reload amount to default to for user's gift cards */
  readonly defaultReloadAmt: Maybe<Scalars['Int']>,
  /** Date of birth (format TBD) */
  readonly dob: Maybe<Scalars['String']>,
  readonly email: Maybe<Scalars['String']>,
  /** Whether the user has verified the email */
  readonly emailVerified: Maybe<Scalars['Boolean']>,
  /** User's saved list of favorite stores */
  readonly favoriteStores: Maybe<ReadonlyArray<Maybe<IFavoriteStore>>>,
  /** User's ISO Country Code (e.g. USA, CAN) */
  readonly isoCountryCode: Maybe<IsoCountryCode>,
  /** User's selected loyalty tier */
  readonly loyaltyTier: Maybe<Scalars['String']>,
  /** User's name */
  readonly name: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  /** Whether the user has opted in to promotional emails */
  readonly promotionalEmails: Maybe<Scalars['Boolean']>,
  /** Last time the user failed the skills tests of RUTR */
  readonly rutrFailedSkillsTestTimestamp: Maybe<Scalars['String']>,
  /** Last time the user passed the skills tests of RUTR */
  readonly rutrPassedSkillsTestTimestamp: Maybe<Scalars['String']>,
  readonly zipcode: Maybe<Scalars['String']>,
}

export interface IUserReportsMissingOrderInput {
  /** Order ID that the user is reporting */
  readonly rbiOrderId: Scalars['String'],
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId?: Maybe<Scalars['String']>,
  /** List of reported missing items. Undefined if entire order is missing */
  readonly missingItems?: Maybe<ReadonlyArray<Maybe<IMissingItem>>>,
  /** Optional user comment as part of the report */
  readonly userComment?: Maybe<Scalars['String']>,
}

export interface IValidateAuthJwtInput {
  readonly jwt: Scalars['String'],
}

export interface IVendorConfig {
  readonly __typename?: 'VendorConfig',
  readonly constantPlu: Maybe<Scalars['String']>,
  readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>,
  readonly pluType: Scalars['String'],
  readonly parentChildPlu: Maybe<IParentChildPlu>,
  readonly parentSanityId: Maybe<Scalars['String']>,
  readonly pullUpLevels: Maybe<Scalars['Int']>,
  readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>,
  readonly sizeBasedPlu: Maybe<ISizeBasedPlu>,
}

export interface IVendorConfigInput {
  readonly pluType: Scalars['String'],
  readonly parentSanityId?: Maybe<Scalars['String']>,
  readonly pullUpLevels?: Maybe<Scalars['Int']>,
  readonly constantPlu?: Maybe<Scalars['String']>,
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IQuantityPluInput>>>,
  readonly parentChildPlu?: Maybe<IParentChildPluInput>,
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IQuantityPluInput>>>,
  readonly sizeBasedPlu?: Maybe<ISizeBasedPluInput>,
}

export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs',
  readonly carrols: Maybe<IVendorConfig>,
  readonly carrolsDelivery: Maybe<IVendorConfig>,
  readonly ncr: Maybe<IVendorConfig>,
  readonly ncrDelivery: Maybe<IVendorConfig>,
  readonly productNumber: Maybe<IVendorConfig>,
  readonly productNumberDelivery: Maybe<IVendorConfig>,
  readonly qdi: Maybe<IVendorConfig>,
  readonly qdiDelivery: Maybe<IVendorConfig>,
  readonly rpos: Maybe<IVendorConfig>,
  readonly rposDelivery: Maybe<IVendorConfig>,
  readonly sicom: Maybe<IVendorConfig>,
  readonly sicomDelivery: Maybe<IVendorConfig>,
  readonly tablet: Maybe<IVendorConfig>,
  readonly tabletDelivery: Maybe<IVendorConfig>,
}

export interface IVendorConfigsInput {
  readonly carrols?: Maybe<IVendorConfigInput>,
  readonly carrolsDelivery?: Maybe<IVendorConfigInput>,
  /** HDX is not currently supported */
  readonly hdx?: Maybe<IVendorConfigInput>,
  readonly ncr?: Maybe<IVendorConfigInput>,
  readonly ncrDelivery?: Maybe<IVendorConfigInput>,
  readonly productNumber?: Maybe<IVendorConfigInput>,
  readonly productNumberDelivery?: Maybe<IVendorConfigInput>,
  readonly qdi?: Maybe<IVendorConfigInput>,
  readonly qdiDelivery?: Maybe<IVendorConfigInput>,
  /** QST is not currently supported */
  readonly qst?: Maybe<IVendorConfigInput>,
  readonly rpos?: Maybe<IVendorConfigInput>,
  readonly rposDelivery?: Maybe<IVendorConfigInput>,
  readonly sicom?: Maybe<IVendorConfigInput>,
  readonly sicomDelivery?: Maybe<IVendorConfigInput>,
  readonly tablet?: Maybe<IVendorConfigInput>,
  readonly tabletDelivery?: Maybe<IVendorConfigInput>,
}

export interface IWllSession {
  readonly __typename?: 'WllSession',
  /** Session id */
  readonly session: Scalars['String'],
  /** Vendor base url */
  readonly wllUrl: Scalars['String'],
  /** Web base url */
  readonly webUrl: Scalars['String'],
}

export type IDeleteMeMutationVariables = {};


export type IDeleteMeMutation = { readonly __typename?: 'Mutation', readonly deleteMe: Maybe<boolean> };

export type IDeliveryQuoteQueryVariables = {
  dropoff: IDeliveryWaypointInput,
  pickup: IDeliveryWaypointInput
};


export type IDeliveryQuoteQuery = { readonly __typename?: 'Query', readonly deliveryQuote: { readonly __typename?: 'Delivery', readonly status: DeliveryStatus } };

export type ICartEntryFragment = { readonly __typename?: 'CartEntries', readonly lineId: string, readonly image: Maybe<string>, readonly name: Maybe<string>, readonly pickerSelections: Maybe<string>, readonly price: Maybe<number>, readonly quantity: number, readonly sanityId: string, readonly type: CartEntryType, readonly url: Maybe<string>, readonly redeemable: Maybe<boolean>, readonly _id: string, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IOperatingHoursFragment = { readonly __typename?: 'OperatingHours', readonly friClose: Maybe<string>, readonly friOpen: Maybe<string>, readonly monClose: Maybe<string>, readonly monOpen: Maybe<string>, readonly satClose: Maybe<string>, readonly satOpen: Maybe<string>, readonly sunClose: Maybe<string>, readonly sunOpen: Maybe<string>, readonly thrClose: Maybe<string>, readonly thrOpen: Maybe<string>, readonly tueClose: Maybe<string>, readonly tueOpen: Maybe<string>, readonly wedClose: Maybe<string>, readonly wedOpen: Maybe<string> };

export type IRestaurantNodeFragment = { readonly __typename?: 'RestaurantNode', readonly _id: Maybe<string>, readonly storeId: Maybe<string>, readonly isAvailable: boolean, readonly posVendor: Maybe<string>, readonly chaseMerchantId: Maybe<string>, readonly distanceInMiles: Maybe<number>, readonly drinkStationType: Maybe<string>, readonly driveThruLaneType: Maybe<string>, readonly email: Maybe<ReadonlyArray<string>>, readonly environment: Maybe<RestaurantStatus>, readonly franchiseGroupId: Maybe<number>, readonly franchiseGroupName: Maybe<string>, readonly frontCounterClosed: Maybe<boolean>, readonly hasBreakfast: Maybe<boolean>, readonly hasBurgersForBreakfast: Maybe<boolean>, readonly hasCatering: Maybe<boolean>, readonly hasCurbside: Maybe<boolean>, readonly hasDelivery: Maybe<boolean>, readonly hasDineIn: Maybe<boolean>, readonly hasDriveThru: Maybe<boolean>, readonly hasMobileOrdering: Maybe<boolean>, readonly hasParking: Maybe<boolean>, readonly hasPlayground: Maybe<boolean>, readonly hasTakeOut: Maybe<boolean>, readonly hasWifi: Maybe<boolean>, readonly isDarkKitchen: Maybe<boolean>, readonly isFavorite: boolean, readonly isRecent: boolean, readonly latitude: Maybe<number>, readonly longitude: Maybe<number>, readonly mobileOrderingStatus: Maybe<OrderingStatus>, readonly name: Maybe<string>, readonly number: Maybe<string>, readonly parkingType: Maybe<string>, readonly phoneNumber: Maybe<string>, readonly playgroundType: Maybe<string>, readonly posRestaurantId: Maybe<string>, readonly status: Maybe<string>, readonly vatNumber: Maybe<string>, readonly curbsideHours: Maybe<(
    { readonly __typename?: 'OperatingHours' }
    & IOperatingHoursFragment
  )>, readonly deliveryHours: Maybe<(
    { readonly __typename?: 'OperatingHours' }
    & IOperatingHoursFragment
  )>, readonly diningRoomHours: Maybe<(
    { readonly __typename?: 'OperatingHours' }
    & IOperatingHoursFragment
  )>, readonly driveThruHours: Maybe<(
    { readonly __typename?: 'OperatingHours' }
    & IOperatingHoursFragment
  )>, readonly physicalAddress: Maybe<{ readonly __typename?: 'PhysicalAddress', readonly address1: Maybe<string>, readonly address2: Maybe<string>, readonly city: Maybe<string>, readonly country: Maybe<string>, readonly postalCode: Maybe<string>, readonly stateProvince: Maybe<string> }>, readonly pos: Maybe<{ readonly __typename?: 'RestaurantPos', readonly vendor: Maybe<string> }>, readonly restaurantImage: Maybe<{ readonly __typename?: 'SanityImage', readonly asset: Maybe<{ readonly __typename?: 'SanityImageAsset', readonly _id: Maybe<string>, readonly metadata: Maybe<{ readonly __typename?: 'SanityImageMetaData', readonly lqip: Maybe<string>, readonly palette: Maybe<{ readonly __typename?: 'SanityImagePalette', readonly dominant: Maybe<{ readonly __typename?: 'SanityImagePaletteSwatch', readonly background: Maybe<string>, readonly foreground: Maybe<string> }> }> }> }>, readonly crop: Maybe<{ readonly __typename?: 'SanityImageCrop', readonly top: Maybe<number>, readonly bottom: Maybe<number>, readonly left: Maybe<number>, readonly right: Maybe<number> }>, readonly hotspot: Maybe<{ readonly __typename?: 'SanityImageHotspot', readonly height: Maybe<number>, readonly width: Maybe<number>, readonly x: Maybe<number>, readonly y: Maybe<number> }> }>, readonly restaurantPosData: Maybe<{ readonly __typename?: 'RestaurantPosData', readonly _id: Maybe<string> }> };

export type IUserDetailsFragment = { readonly __typename?: 'UserDetails', readonly name: Maybe<string>, readonly dob: Maybe<string>, readonly phoneNumber: Maybe<string>, readonly email: Maybe<string>, readonly emailVerified: Maybe<boolean>, readonly promotionalEmails: Maybe<boolean>, readonly isoCountryCode: Maybe<IsoCountryCode>, readonly zipcode: Maybe<string>, readonly defaultAccountIdentifier: Maybe<string>, readonly defaultFdAccountId: Maybe<string>, readonly defaultPaymentAccountId: Maybe<string>, readonly defaultReloadAmt: Maybe<number>, readonly autoReloadEnabled: Maybe<boolean>, readonly autoReloadThreshold: Maybe<number>, readonly loyaltyTier: Maybe<string>, readonly rutrPassedSkillsTestTimestamp: Maybe<string>, readonly rutrFailedSkillsTestTimestamp: Maybe<string>, readonly deliveryAddresses: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'DeliveryAddress', readonly addressLine1: string, readonly addressLine2: Maybe<string>, readonly city: string, readonly country: Maybe<IsoCountryCode>, readonly phoneNumber: string, readonly route: Maybe<string>, readonly state: Maybe<string>, readonly streetNumber: Maybe<string>, readonly zip: Maybe<string> }>>>, readonly communicationPreferences: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CommunicationPreference', readonly id: Maybe<string>, readonly value: Maybe<string> }>>>, readonly favoriteStores: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'FavoriteStore', readonly storeId: Maybe<string>, readonly storeNumber: Maybe<string> }>>> };

export type IUserOrderFragment = { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly createdAt: string, readonly updatedAt: string, readonly fireOrderIn: Maybe<number>, readonly status: RbiOrderStatus, readonly _id: string, readonly delivery: Maybe<{ readonly __typename?: 'Delivery', readonly feeCents: number, readonly tipCents: Maybe<number>, readonly feeDiscountCents: Maybe<number>, readonly status: DeliveryStatus, readonly serviceFeeCents: Maybe<number>, readonly smallCartFeeCents: Maybe<number> }>, readonly cart: { readonly __typename?: 'Cart', readonly ticketNumber: Maybe<string>, readonly storeId: string, readonly vatNumber: Maybe<string>, readonly serviceMode: ServiceMode, readonly posVendor: PosVendor, readonly cartVersion: Maybe<number>, readonly subTotalCents: Maybe<number>, readonly taxCents: Maybe<number>, readonly totalCents: Maybe<number>, readonly wasLoyaltyEarned: Maybe<boolean>, readonly storeAddress: { readonly __typename?: 'StoreAddress', readonly addressLine1: string, readonly addressLine2: Maybe<string>, readonly city: string, readonly state: string, readonly zip: string }, readonly cartEntries: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries' }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly reorderCartEntries: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries' }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly unavailableCartEntries: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'UnavailableCartEntry', readonly lineId: Maybe<string>, readonly sanityId: string }>>> } };

export type IVendorConfigFragment = { readonly __typename?: 'VendorConfig', readonly pluType: string, readonly parentSanityId: Maybe<string>, readonly pullUpLevels: Maybe<number>, readonly constantPlu: Maybe<string>, readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuantityPlu', readonly quantity: Maybe<number>, readonly plu: Maybe<string>, readonly qualifier: Maybe<string> }>>>, readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuantityPlu', readonly quantity: Maybe<number>, readonly plu: Maybe<string>, readonly qualifier: Maybe<string> }>>>, readonly parentChildPlu: Maybe<{ readonly __typename?: 'ParentChildPlu', readonly plu: Maybe<string>, readonly childPlu: Maybe<string> }>, readonly sizeBasedPlu: Maybe<{ readonly __typename?: 'SizeBasedPlu', readonly comboPlu: Maybe<string>, readonly comboSize: Maybe<string> }> };

export type IVendorConfigsFragment = { readonly __typename?: 'VendorConfigs', readonly carrols: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly carrolsDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncr: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncrDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumber: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumberDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicom: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicomDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdi: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdiDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rpos: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rposDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tablet: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tabletDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )> };

export type IGetRestaurantQueryVariables = {
  storeId?: Maybe<Scalars['String']>,
  storeNumber?: Maybe<Scalars['String']>
};


export type IGetRestaurantQuery = { readonly __typename?: 'Query', readonly restaurant: { readonly __typename?: 'Restaurant', readonly available: boolean, readonly curbsideHours: Maybe<(
      { readonly __typename?: 'OperatingHours' }
      & IOperatingHoursFragment
    )>, readonly deliveryHours: Maybe<(
      { readonly __typename?: 'OperatingHours' }
      & IOperatingHoursFragment
    )>, readonly diningRoomHours: Maybe<(
      { readonly __typename?: 'OperatingHours' }
      & IOperatingHoursFragment
    )>, readonly driveThruHours: Maybe<(
      { readonly __typename?: 'OperatingHours' }
      & IOperatingHoursFragment
    )> } };

export type IRefreshRestaurantAvailabilityMutationVariables = {
  storeId?: Maybe<Scalars['String']>,
  storeNumber?: Maybe<Scalars['String']>
};


export type IRefreshRestaurantAvailabilityMutation = { readonly __typename?: 'Mutation', readonly refreshRestaurantAvailability: boolean };

export type IGetAvailableGiftOffersQueryVariables = {};


export type IGetAvailableGiftOffersQuery = { readonly __typename?: 'Query', readonly listGiftOffers: Maybe<{ readonly __typename?: 'GiftOfferListResponse', readonly count: number, readonly offers: ReadonlyArray<Maybe<{ readonly __typename?: 'GiftOffer', readonly title: string, readonly titleFormatted: string, readonly offerId: string, readonly costInPoints: number, readonly isRedeemable: boolean }>> }> };

export type IGiftOfferMutationVariables = {
  input: IGiftOfferInput
};


export type IGiftOfferMutation = { readonly __typename?: 'Mutation', readonly addGiftOfferByEmail: boolean };

export type IAddOfferByTokenMutationVariables = {
  token: Scalars['String']
};


export type IAddOfferByTokenMutation = { readonly __typename?: 'Mutation', readonly addOfferByToken: boolean };

export type ICreateSupportCaseMutationVariables = {
  caseInfo: ISupportCaseInput
};


export type ICreateSupportCaseMutation = { readonly __typename?: 'Mutation', readonly createSupportCase: Maybe<{ readonly __typename?: 'SupportCase', readonly caseId: Maybe<string> }> };

export type IGetLoyaltyCardsQueryVariables = {};


export type IGetLoyaltyCardsQuery = { readonly __typename?: 'Query', readonly getLoyaltyCards: Maybe<{ readonly __typename?: 'LoyaltyCardsResp', readonly count: number, readonly cards: ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyCard', readonly barcode: string, readonly cardFormat: UserCardCardFormat, readonly cardId: string, readonly cardType: UserCardCardType, readonly name: string }>> }> };

export type IGetLoyaltyCardDetailsQueryVariables = {
  cardId: Scalars['String']
};


export type IGetLoyaltyCardDetailsQuery = { readonly __typename?: 'Query', readonly getLoyaltyCardDetails: Maybe<{ readonly __typename?: 'LoyaltyCardDetails', readonly availableRedemptions: number, readonly canEarnVisit: boolean, readonly canRedeemReward: boolean, readonly cardType: UserCardCardType, readonly discountActiveUntil: string, readonly donationUpcharge: Maybe<boolean>, readonly numberOfTransactionsInTimePeriod: number, readonly numberOfTransactionsMadeTowardsNextReward: number, readonly numberOfTransactionsNeeded: number, readonly periodEndTimestamp: string, readonly periodStartTimestamp: string, readonly points: Maybe<number>, readonly pointExpiry: ReadonlyArray<{ readonly __typename?: 'LoyaltyPointExpiry', readonly points: number, readonly expirationDate: string }> }> };

export type IGetLoyaltyCardTransactionsQueryVariables = {
  cardId: Scalars['String'],
  endDate?: Maybe<Scalars['String']>,
  page?: Maybe<Scalars['String']>,
  pageSize?: Maybe<Scalars['String']>,
  startDate?: Maybe<Scalars['String']>
};


export type IGetLoyaltyCardTransactionsQuery = { readonly __typename?: 'Query', readonly getLoyaltyCardTransactions: Maybe<{ readonly __typename?: 'LoyaltyCardTransactions', readonly transactions: ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyCardTransaction', readonly bonusPoints: Maybe<number>, readonly tag: Maybe<string>, readonly transactionId: Maybe<string>, readonly timestamp: Maybe<string>, readonly basketTotal: Maybe<number>, readonly rewardRedeemed: Maybe<boolean>, readonly discountAmount: Maybe<number>, readonly isVisit: Maybe<boolean>, readonly pointsEarned: Maybe<number>, readonly pointsUsed: Maybe<number>, readonly isCustomerServiceVisit: Maybe<boolean> }>> }> };

export type IGetLoyaltyCardDetailsFromBarcodeQueryVariables = {
  barcode: Scalars['String']
};


export type IGetLoyaltyCardDetailsFromBarcodeQuery = { readonly __typename?: 'Query', readonly getLoyaltyCardDetailsKiosk: Maybe<{ readonly __typename?: 'LoyaltyCardDetailsKiosk', readonly availableRedemptions: number, readonly numberOfTransactionsInTimePeriod: number, readonly numberOfTransactionsMadeTowardsNextReward: number, readonly numberOfTransactionsNeeded: number }> };

export type IGetLoyaltyRollUpTheRimTimelineEventsQueryVariables = {
  eventId?: Maybe<Scalars['String']>,
  resumeAfter?: Maybe<Scalars['String']>,
  sortAscending?: Maybe<Scalars['Boolean']>
};


export type IGetLoyaltyRollUpTheRimTimelineEventsQuery = { readonly __typename?: 'Query', readonly getLoyaltyRollUpTheRimTimelineEvents: Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventList', readonly count: number, readonly resumeAfter: Maybe<string>, readonly events: ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventEntry', readonly prizeId: Maybe<string>, readonly createdAt: string, readonly eventId: string, readonly referenceId: string, readonly timelineId: string, readonly type: string, readonly offerStatus: Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventOfferStatus', readonly offerId: Maybe<string>, readonly activated: Maybe<boolean>, readonly used: Maybe<boolean> }> }>> }> };

export type IAddVoucherMutationVariables = {
  voucherId: Scalars['String']
};


export type IAddVoucherMutation = { readonly __typename?: 'Mutation', readonly addVoucher: Maybe<boolean> };

export type ISetLoyaltyCardRewardsTierMutationVariables = {
  loyaltyTier: Scalars['String']
};


export type ISetLoyaltyCardRewardsTierMutation = { readonly __typename?: 'Mutation', readonly updateMe: { readonly __typename?: 'User', readonly details: { readonly __typename?: 'UserDetails', readonly loyaltyTier: Maybe<string> } } };

export type IMergeLoyaltyCardsMutationVariables = {
  cardId: Scalars['String'],
  existingCardId: Scalars['String']
};


export type IMergeLoyaltyCardsMutation = { readonly __typename?: 'Mutation', readonly mergeLoyaltyCards: Maybe<{ readonly __typename?: 'LoyaltyCard', readonly cardId: string }> };

export type IDeleteLoyaltyCardMutationVariables = {
  cardId: Scalars['String']
};


export type IDeleteLoyaltyCardMutation = { readonly __typename?: 'Mutation', readonly deleteLoyaltyCard: Maybe<{ readonly __typename?: 'LoyaltyCard', readonly cardId: string }> };

export type ISetLoyaltyDonationUpchargeMutationVariables = {
  cardId: Scalars['String'],
  donationUpcharge: Scalars['Boolean']
};


export type ISetLoyaltyDonationUpchargeMutation = { readonly __typename?: 'Mutation', readonly setLoyaltyDonationUpcharge: Maybe<{ readonly __typename?: 'LoyaltyDonationUpcharge', readonly donationUpcharge: Maybe<boolean> }> };

export type IOfferFeedbackEntryFragment = { readonly __typename?: 'CouponUserOffersFeedbackEntry', readonly tokenId: Maybe<string>, readonly couponId: string, readonly offerDetails: Maybe<string>, readonly offerState: Maybe<CartOfferState>, readonly _id: string, readonly cartEntry: Maybe<{ readonly __typename?: 'CartEntries', readonly cartId: string }>, readonly offerVariables: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'OfferVariable', readonly key: string, readonly type: string, readonly value: string }>>>, readonly redemptionEligibility: { readonly __typename?: 'CouponRedemptionEligibility', readonly isRedeemable: boolean, readonly isValid: boolean, readonly evaluationFeedback: ReadonlyArray<Maybe<{ readonly __typename?: 'CouponEvaluationFeedback', readonly code: string, readonly condition: boolean, readonly message: string, readonly redeemableForSeconds: Maybe<number>, readonly redeemableInSeconds: Maybe<number>, readonly ruleSetType: string, readonly sanityId: Maybe<string> }>>, readonly validationErrors: ReadonlyArray<Maybe<{ readonly __typename?: 'CouponValidationError', readonly code: string, readonly message: string, readonly ruleSetType: string }>> } };

export type IEvaluateUserOffersQueryVariables = {
  cart?: Maybe<IPriceOrderInput>,
  couponIds?: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>,
  evaluateAllCouponIds?: Maybe<Scalars['Boolean']>,
  locale?: Maybe<Locale>,
  platform?: Maybe<Platform>,
  rbiOrderId?: Maybe<Scalars['ID']>,
  redeemedOn: Scalars['String'],
  serviceMode?: Maybe<ServiceMode>,
  storeId?: Maybe<Scalars['String']>
};


export type IEvaluateUserOffersQuery = { readonly __typename?: 'Query', readonly evaluateUserOffers: { readonly __typename?: 'CouponUserOffersFeedback', readonly offersFeedback: ReadonlyArray<Maybe<(
      { readonly __typename?: 'CouponUserOffersFeedbackEntry' }
      & IOfferFeedbackEntryFragment
    )>> } };

export type IEvaluateAllUserOffersQueryVariables = {
  locale?: Maybe<Locale>,
  platform?: Maybe<Platform>,
  redeemedOn: Scalars['String'],
  serviceMode?: Maybe<ServiceMode>,
  storeId?: Maybe<Scalars['String']>
};


export type IEvaluateAllUserOffersQuery = { readonly __typename?: 'Query', readonly evaluateAllUserOffers: { readonly __typename?: 'CouponUserOffersFeedback', readonly offersFeedback: ReadonlyArray<Maybe<(
      { readonly __typename?: 'CouponUserOffersFeedbackEntry' }
      & IOfferFeedbackEntryFragment
    )>> } };

export type IListOffersByUserIdQueryVariables = {};


export type IListOffersByUserIdQuery = { readonly __typename?: 'Query', readonly listUserCouponTokens: { readonly __typename?: 'CouponTokenListResponse', readonly count: number, readonly tokens: ReadonlyArray<Maybe<{ readonly __typename?: 'CouponToken', readonly couponId: string, readonly createdAt: string, readonly expiresOn: Maybe<string>, readonly tokenId: string }>> } };

export type IRedeemOfferMutationVariables = {
  couponId: Scalars['ID']
};


export type IRedeemOfferMutation = { readonly __typename?: 'Mutation', readonly redeemCoupon: { readonly __typename?: 'Coupon', readonly couponId: string, readonly redeemedOn: Maybe<string> } };

export type IGetEncryptionDetailsMutationVariables = {};


export type IGetEncryptionDetailsMutation = { readonly __typename?: 'Mutation', readonly encryptionDetails: { readonly __typename?: 'EncryptionDetails', readonly fdPublicKey: string, readonly fdAccessToken: string, readonly fdPublicKeyExpiresInSeconds: number, readonly fdApiKey: string, readonly algorithm: Maybe<string>, readonly fdCustomerId: Maybe<string> } };

export type IAddCreditAccountMutationVariables = {
  input: IAddCreditAccountInput
};


export type IAddCreditAccountMutation = { readonly __typename?: 'Mutation', readonly addCreditAccount: { readonly __typename?: 'Account', readonly accountIdentifier: Maybe<string>, readonly fdAccountId: Maybe<string>, readonly chaseProfileId: Maybe<string>, readonly credit: Maybe<{ readonly __typename?: 'CreditCard', readonly alias: string, readonly cardType: string, readonly expiryMonth: string, readonly expiryYear: string, readonly panToken: Maybe<string>, readonly billingAddress: Maybe<{ readonly __typename?: 'BillingAddress', readonly locality: string, readonly postalCode: string, readonly region: string, readonly streetAddress: string, readonly unitNumber: Maybe<string> }> }> } };

export type IDeleteAccountMutationVariables = {
  input: IDeleteAccountInput
};


export type IDeleteAccountMutation = { readonly __typename?: 'Mutation', readonly deleteAccount: Maybe<boolean> };

export type IUserAccountsQueryVariables = {
  feCountryCode: IsoCountryCode
};


export type IUserAccountsQuery = { readonly __typename?: 'Query', readonly userAccounts: Maybe<{ readonly __typename?: 'AccountListResponse', readonly count: number, readonly paymentProcessor: Maybe<PaymentProcessor>, readonly accounts: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Account', readonly accountIdentifier: Maybe<string>, readonly fdAccountId: Maybe<string>, readonly chaseProfileId: Maybe<string>, readonly credit: Maybe<{ readonly __typename?: 'CreditCard', readonly alias: string, readonly cardType: string, readonly expiryYear: string, readonly expiryMonth: string, readonly panToken: Maybe<string> }>, readonly prepaid: Maybe<{ readonly __typename?: 'GiftCard', readonly alias: string, readonly currentBalance: Maybe<number>, readonly cardNumber: string, readonly expiryMonth: string, readonly expiryYear: string, readonly feFormattedCurrentBalance: Maybe<number>, readonly shuffledCardNumber: string }> }>>> }> };

export type IPluDataQueryVariables = {
  storeId: Scalars['String']
};


export type IPluDataQuery = { readonly __typename?: 'Query', readonly pluData: Maybe<{ readonly __typename?: 'PluData', readonly plus: Maybe<string>, readonly deliveryPlus: Maybe<string>, readonly updatedAt: Maybe<string> }> };

export type IPrepaidsReloadMutationVariables = {
  input: IPrepaidsReloadInput
};


export type IPrepaidsReloadMutation = { readonly __typename?: 'Mutation', readonly prepaidsReload: { readonly __typename?: 'Reload', readonly currentBalance: number, readonly fdAccountId: string, readonly fdCorrelationId: Maybe<string>, readonly transactionId: string } };

export type IAddPrepaidCardMutationVariables = {
  input: IAddGiftAccountInput
};


export type IAddPrepaidCardMutation = { readonly __typename?: 'Mutation', readonly addGiftAccount: { readonly __typename?: 'GiftAccount', readonly fdAccountId: string, readonly prepaid: { readonly __typename?: 'GiftCard', readonly currentBalance: Maybe<number> } } };

export type IPrepaidTransactionCurrencyCodesQueryVariables = {
  cardNumber: Scalars['String']
};


export type IPrepaidTransactionCurrencyCodesQuery = { readonly __typename?: 'Query', readonly prepaidsTransactions: Maybe<{ readonly __typename?: 'TransactionListResponse', readonly transactions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PrepaidTransaction', readonly currencyCode: { readonly __typename?: 'CurrencyCode', readonly number: number } }>>> }> };

export type IRequestMyInfoMutationVariables = {};


export type IRequestMyInfoMutation = { readonly __typename?: 'Mutation', readonly requestMyInfo: Maybe<boolean> };

export type IGetRestaurantsQueryVariables = {
  input?: Maybe<IRestaurantsInput>
};


export type IGetRestaurantsQuery = { readonly __typename?: 'Query', readonly restaurants: Maybe<{ readonly __typename?: 'RestaurantsConnection', readonly totalCount: Maybe<number>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor: Maybe<string> }, readonly nodes: ReadonlyArray<(
      { readonly __typename?: 'RestaurantNode' }
      & IRestaurantNodeFragment
    )> }> };

export type IDeliveryRestaurantQueryVariables = {
  dropoff: IDeliveryWaypointInput,
  searchRadius: Scalars['Float']
};


export type IDeliveryRestaurantQuery = { readonly __typename?: 'Query', readonly deliveryRestaurant: { readonly __typename?: 'DeliveryRestaurant', readonly storeStatus: DeliveryStoreStatus, readonly quote: Maybe<DeliveryStatus>, readonly nextEarliestOpen: Maybe<string>, readonly restaurant: Maybe<(
      { readonly __typename?: 'RestaurantNode' }
      & IRestaurantNodeFragment
    )> } };

export type IRevealLoyaltyRollUpTheRimTimelineEventRollMutationVariables = {
  referenceId: Scalars['String'],
  developmentPrize?: Maybe<Scalars['String']>
};


export type IRevealLoyaltyRollUpTheRimTimelineEventRollMutation = { readonly __typename?: 'Mutation', readonly revealLoyaltyRollUpTheRimTimelineEventRoll: Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventRollResult', readonly id: string, readonly type: string, readonly code: Maybe<string> }> };

export type IGetLoyaltyRollUpTheRimPrizesStatsQueryVariables = {
  eventId?: Maybe<Scalars['String']>
};


export type IGetLoyaltyRollUpTheRimPrizesStatsQuery = { readonly __typename?: 'Query', readonly getLoyaltyRollUpTheRimPrizesStats: Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimPrizesStats', readonly total: Maybe<number>, readonly awarded: Maybe<number>, readonly details: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimPrizeStats', readonly total: Maybe<number>, readonly awarded: Maybe<number>, readonly prizeId: Maybe<string> }>>> }> };

export type IGetLoyaltyRollUpTheRimTimelineEventSummaryQueryVariables = {
  eventId?: Maybe<Scalars['String']>
};


export type IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery = { readonly __typename?: 'Query', readonly getLoyaltyRollUpTheRimTimelineEventSummary: Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSummaryList', readonly count: number, readonly resumeAfter: Maybe<string>, readonly events: ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSummaryEntry', readonly count: number, readonly eventId: string }>> }> };

export type IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQueryVariables = {};


export type IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery = { readonly __typename?: 'Query', readonly getLoyaltyRollUpTheRimTimelineEventSharedRollTokens: Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSharedRollTokenList', readonly count: number, readonly tokens: ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry', readonly count: number, readonly token: string }>> }> };

export type IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationVariables = {
  sharedRollsToken: Scalars['String']
};


export type IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation = { readonly __typename?: 'Mutation', readonly acceptLoyaltyRollUpTheRimTimelineEventSharedRolls: Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList', readonly count: number, readonly rolls: ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry', readonly barcode: string, readonly createdAt: string, readonly eventId: string, readonly referenceId: string }>> }> };

export type IClaimLoyaltyRollUpTheRimPrizeMutationVariables = {
  email: Scalars['String'],
  giftCardValueCents?: Maybe<Scalars['Int']>,
  isMajorPrize: Scalars['Boolean'],
  isTimHortonsGiftCard: Scalars['Boolean'],
  language: Scalars['String'],
  name: Scalars['String'],
  referenceId: Scalars['String']
};


export type IClaimLoyaltyRollUpTheRimPrizeMutation = { readonly __typename?: 'Mutation', readonly claimLoyaltyRollUpTheRimPrize: Maybe<boolean> };

export type IShareLoyaltyRollUpTheRimTimelineEventRollsMutationVariables = {
  quantity: Scalars['Int']
};


export type IShareLoyaltyRollUpTheRimTimelineEventRollsMutation = { readonly __typename?: 'Mutation', readonly shareLoyaltyRollUpTheRimTimelineEventRolls: Maybe<{ readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventShareRollResult', readonly token: string }> };

export type IReportMissingOrderMutationVariables = {
  input: IUserReportsMissingOrderInput
};


export type IReportMissingOrderMutation = { readonly __typename?: 'Mutation', readonly userReportsMissingOrder: { readonly __typename?: 'MissingOrderResolution', readonly ticket: Maybe<string>, readonly refund: Maybe<{ readonly __typename?: 'MissingOrderRefundDetails', readonly approvedAmount: number, readonly transactionDateTime: string }> } };

export type IGetUniqueStoresQueryVariables = {
  orderStatuses?: Maybe<ReadonlyArray<RbiOrderStatus>>
};


export type IGetUniqueStoresQuery = { readonly __typename?: 'Query', readonly uniqueStores: { readonly __typename?: 'OrderListResponse', readonly orders: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Order', readonly cart: { readonly __typename?: 'Cart', readonly storeId: string } }>>> } };

export type IUpsertKiosksMutationVariables = {
  storeKiosks: IStoreInput
};


export type IUpsertKiosksMutation = { readonly __typename?: 'Mutation', readonly updateStore: { readonly __typename?: 'Store', readonly storeId: string, readonly kiosks: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Kiosk', readonly serialNumber: string }>>> } };

export type IGetUserOrdersQueryVariables = {
  userId?: Maybe<Scalars['ID']>,
  limit?: Maybe<Scalars['Int']>,
  resumeAfter?: Maybe<Scalars['String']>,
  orderStatuses?: Maybe<ReadonlyArray<RbiOrderStatus>>,
  createdAfter?: Maybe<Scalars['String']>,
  shouldFilterByRegion?: Maybe<Scalars['Boolean']>
};


export type IGetUserOrdersQuery = { readonly __typename?: 'Query', readonly userOrders: { readonly __typename?: 'OrderListResponse', readonly count: number, readonly resumeAfter: Maybe<string>, readonly orders: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Order' }
      & IUserOrderFragment
    )>>> } };

export type IGetUserOrderQueryVariables = {
  id: Scalars['ID']
};


export type IGetUserOrderQuery = { readonly __typename?: 'Query', readonly order: Maybe<(
    { readonly __typename?: 'Order' }
    & IUserOrderFragment
  )> };

export type IUpdateMeMutationVariables = {
  input: IUpdateUserDetailsInput
};


export type IUpdateMeMutation = { readonly __typename?: 'Mutation', readonly updateMe: { readonly __typename?: 'User', readonly details: (
      { readonly __typename?: 'UserDetails' }
      & IUserDetailsFragment
    ) } };

export type ISignInJwtMutationVariables = {
  input: ISignInUserInput
};


export type ISignInJwtMutation = { readonly __typename?: 'Mutation', readonly signInJWT: Maybe<boolean> };

export type ISignUpMutationVariables = {
  input: ISignUpUserInput
};


export type ISignUpMutation = { readonly __typename?: 'Mutation', readonly signUp: Maybe<string> };

export type ICreateLoyaltyUserMutationVariables = {
  cognitoId: Scalars['String']
};


export type ICreateLoyaltyUserMutation = { readonly __typename?: 'Mutation', readonly createLoyaltyUser: { readonly __typename?: 'User', readonly loyaltyId: Maybe<string> } };

export type IValidateAuthJwtMutationVariables = {
  input: IValidateAuthJwtInput
};


export type IValidateAuthJwtMutation = { readonly __typename?: 'Mutation', readonly validateAuthJwt: { readonly __typename?: 'CognitoCredentials', readonly challengeCode: string, readonly sessionId: string } };

export type ICreateOtpMutationVariables = {
  input: ICreateOtpInput
};


export type ICreateOtpMutation = { readonly __typename?: 'Mutation', readonly createOTP: { readonly __typename?: 'CreateOTP', readonly maxValidateAttempts: number, readonly ttl: number } };

export type IResendCurrentLoginOtpMutationVariables = {
  input: IResendOtpInput
};


export type IResendCurrentLoginOtpMutation = { readonly __typename?: 'Mutation', readonly resendCurrentLoginOTP: { readonly __typename?: 'CreateOTP', readonly maxValidateAttempts: number, readonly ttl: number } };

export type IValidateOtpMutationVariables = {
  input: IExchangeOtpCodeForCredentialsInput
};


export type IValidateOtpMutation = { readonly __typename?: 'Mutation', readonly exchangeOTPCodeForCognitoCredentials: { readonly __typename?: 'CognitoCredentials', readonly challengeCode: string, readonly sessionId: string } };

export type ISignUpCompleteQueryVariables = {
  jwt: Scalars['String']
};


export type ISignUpCompleteQuery = { readonly __typename?: 'Query', readonly signUpComplete: Maybe<boolean> };

export type IResendVerificationEmailMutationVariables = {
  input: IResendVerificationEmailInput
};


export type IResendVerificationEmailMutation = { readonly __typename?: 'Mutation', readonly resendVerificationEmail: Maybe<boolean> };

export type ICreateLoginForVendorMutationVariables = {
  vendor: Scalars['String']
};


export type ICreateLoginForVendorMutation = { readonly __typename?: 'Mutation', readonly createLoginForVendor: Maybe<string> };

export type IUserGeoQueryVariables = {};


export type IUserGeoQuery = { readonly __typename?: 'Query', readonly userGeo: { readonly __typename?: 'UserCountry', readonly country: Maybe<string> } };

export type IGetLoyaltyApplePassQueryVariables = {
  cardId: Scalars['String']
};


export type IGetLoyaltyApplePassQuery = { readonly __typename?: 'Query', readonly getLoyaltyCardApplePass: Maybe<{ readonly __typename?: 'LoyaltyCardApplePass', readonly encodedPass: string }> };

export type ICreateWllSessionMutationVariables = {};


export type ICreateWllSessionMutation = { readonly __typename?: 'Mutation', readonly createWllSession: Maybe<{ readonly __typename?: 'WllSession', readonly session: string, readonly wllUrl: string, readonly webUrl: string }> };

export type IPrepaidsMergeMutationVariables = {
  input: IPrepaidsMergeInput
};


export type IPrepaidsMergeMutation = { readonly __typename?: 'Mutation', readonly prepaidsMerge: { readonly __typename?: 'Merge', readonly currentBalance: number, readonly fdAccountId: Maybe<string> } };

export type IOrderFragment = { readonly __typename?: 'Order', readonly createdAt: string, readonly posOrderId: Maybe<string>, readonly rbiOrderId: string, readonly status: RbiOrderStatus, readonly fireOrderIn: Maybe<number>, readonly _id: string, readonly cart: { readonly __typename?: 'Cart', readonly customerName: string, readonly cartVersion: Maybe<number>, readonly posVendor: PosVendor, readonly serviceMode: ServiceMode, readonly subTotalCents: Maybe<number>, readonly taxCents: Maybe<number>, readonly ticketNumber: Maybe<string>, readonly totalCents: Maybe<number>, readonly wasLoyaltyEarned: Maybe<boolean>, readonly vatNumber: Maybe<string>, readonly cartEntries: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries' }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly discounts: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Discount', readonly name: Maybe<DiscountTypes>, readonly value: Maybe<number> }>>>, readonly fees: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Fees', readonly name: Maybe<string>, readonly priceCents: Maybe<number>, readonly quantity: Maybe<number>, readonly totalCents: Maybe<number> }>>>, readonly offersFeedback: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CouponUserOffersFeedbackEntry', readonly couponId: string, readonly cartEntry: Maybe<{ readonly __typename?: 'CartEntries', readonly lineId: string }>, readonly redemptionEligibility: { readonly __typename?: 'CouponRedemptionEligibility', readonly isRedeemable: boolean, readonly isValid: boolean, readonly evaluationFeedback: ReadonlyArray<Maybe<{ readonly __typename?: 'CouponEvaluationFeedback', readonly code: string, readonly condition: boolean, readonly message: string, readonly redeemableForSeconds: Maybe<number>, readonly redeemableInSeconds: Maybe<number>, readonly ruleSetType: string }>> } }>>>, readonly payment: Maybe<{ readonly __typename?: 'Payment', readonly cardType: Maybe<string>, readonly ccLast4: Maybe<string>, readonly panToken: Maybe<string>, readonly paymentType: Maybe<CartPaymentType> }>, readonly rewardsApplied: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CartAppliedReward', readonly cartId: string, readonly rewardId: string, readonly timesApplied: number }>>>, readonly storeAddress: { readonly __typename?: 'StoreAddress', readonly addressLine1: string, readonly addressLine2: Maybe<string>, readonly city: string, readonly state: string, readonly zip: string }, readonly storeDetails: Maybe<{ readonly __typename?: 'StoreDetails', readonly latitude: Maybe<number>, readonly longitude: Maybe<number>, readonly storeNumber: Maybe<string> }>, readonly unavailableCartEntries: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'UnavailableCartEntry', readonly lineId: Maybe<string>, readonly sanityId: string }>>> }, readonly delivery: Maybe<{ readonly __typename?: 'Delivery', readonly feeCents: number, readonly feeDiscountCents: Maybe<number>, readonly instructions: Maybe<string>, readonly status: DeliveryStatus, readonly tipCents: Maybe<number>, readonly serviceFeeCents: Maybe<number>, readonly smallCartFeeCents: Maybe<number>, readonly pickup: { readonly __typename?: 'DeliveryWaypoint', readonly latitude: Maybe<number>, readonly longitude: Maybe<number> }, readonly dropoff: { readonly __typename?: 'DeliveryWaypoint', readonly arrivalTime: Maybe<string>, readonly beforeTime: Maybe<string>, readonly addressLine1: string, readonly addressLine2: Maybe<string>, readonly city: string, readonly state: Maybe<string>, readonly zip: Maybe<string>, readonly latitude: Maybe<number>, readonly longitude: Maybe<number>, readonly phoneNumber: string }, readonly driver: Maybe<{ readonly __typename?: 'DeliveryDriver', readonly name: Maybe<string>, readonly profileImageUrl: Maybe<string>, readonly phoneNumber: Maybe<string> }> }>, readonly loyaltyTransaction: Maybe<{ readonly __typename?: 'LoyaltyTransaction', readonly id: string, readonly pointsEarned: number, readonly bonusPointsEarned: number, readonly pointsUsed: number, readonly pointsBalance: number, readonly rewardsUsed: number }> };

export type IListCouponsQueryVariables = {
  expiresAfter?: Maybe<Scalars['String']>,
  expiresBefore?: Maybe<Scalars['String']>,
  includeRedeemed?: Maybe<Scalars['Boolean']>,
  limit?: Maybe<Scalars['Int']>,
  resumeAfter?: Maybe<Scalars['String']>,
  sortAscending?: Maybe<Scalars['Boolean']>
};


export type IListCouponsQuery = { readonly __typename?: 'Query', readonly listCoupons: { readonly __typename?: 'CouponListResponse', readonly count: number, readonly resumeAfter: Maybe<string>, readonly coupons: ReadonlyArray<Maybe<{ readonly __typename?: 'Coupon', readonly couponId: string, readonly createdAt: string, readonly expiresOn: Maybe<string>, readonly redeemedOn: Maybe<string>, readonly updatedAt: string, readonly userId: string }>> } };

export type IIsOfferRedeemableQueryVariables = {
  couponId: Scalars['ID'],
  cart?: Maybe<IPriceOrderInput>,
  rbiOrderId?: Maybe<Scalars['ID']>,
  redeemedOn: Scalars['String'],
  ruleSet?: Maybe<Scalars['String']>
};


export type IIsOfferRedeemableQuery = { readonly __typename?: 'Query', readonly isCouponRedeemable: { readonly __typename?: 'CouponRedemptionEligibility', readonly isRedeemable: boolean, readonly evaluationFeedback: ReadonlyArray<Maybe<{ readonly __typename?: 'CouponEvaluationFeedback', readonly code: string, readonly condition: boolean, readonly message: string, readonly ruleSetType: string }>> } };

export type IActivateLoyaltyOfferMutationVariables = {
  tokenId: Scalars['String']
};


export type IActivateLoyaltyOfferMutation = { readonly __typename?: 'Mutation', readonly activateLoyaltyOffer: Maybe<boolean> };

export type IPriceOrderMutationVariables = {
  input: IPriceOrderInput,
  delivery?: Maybe<IPriceDeliveryInput>
};


export type IPriceOrderMutation = { readonly __typename?: 'Mutation', readonly priceOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type IGetOrderQueryVariables = {
  rbiOrderId: Scalars['ID']
};


export type IGetOrderQuery = { readonly __typename?: 'Query', readonly order: Maybe<(
    { readonly __typename?: 'Order' }
    & IOrderFragment
  )> };

export type IGetStoreOrderQueryVariables = {
  storeOrderJwt: Scalars['String']
};


export type IGetStoreOrderQuery = { readonly __typename?: 'Query', readonly cateringOrder: Maybe<(
    { readonly __typename?: 'Order', readonly catering: Maybe<{ readonly __typename?: 'Catering', readonly pickupTime: string, readonly notes: Maybe<string>, readonly declineReason: Maybe<CateringDeclineReasons> }>, readonly cart: { readonly __typename?: 'Cart', readonly userDetails: Maybe<{ readonly __typename?: 'UserDetails', readonly phoneNumber: Maybe<string>, readonly email: Maybe<string> }> } }
    & IOrderFragment
  )> };

export type IConfirmCateringOrderMutationVariables = {
  input: IConfirmCateringOrderInput
};


export type IConfirmCateringOrderMutation = { readonly __typename?: 'Mutation', readonly confirmCateringOrder: { readonly __typename?: 'Order', readonly status: RbiOrderStatus } };

export type ICommitOrderMutationVariables = {
  input: ICommitOrderInput,
  delivery?: Maybe<ICommitDeliveryInput>,
  skipCoolingPeriod?: Maybe<Scalars['Boolean']>
};


export type ICommitOrderMutation = { readonly __typename?: 'Mutation', readonly commitOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type IDeliveryOrderStatusQueryVariables = {
  rbiOrderId: Scalars['ID']
};


export type IDeliveryOrderStatusQuery = { readonly __typename?: 'Query', readonly order: Maybe<{ readonly __typename?: 'Order', readonly delivery: Maybe<{ readonly __typename?: 'Delivery', readonly status: DeliveryStatus, readonly shareUuid: Maybe<string>, readonly dropoff: { readonly __typename?: 'DeliveryWaypoint', readonly arrivalTime: Maybe<string>, readonly beforeTime: Maybe<string> }, readonly driver: Maybe<{ readonly __typename?: 'DeliveryDriver', readonly name: Maybe<string>, readonly phoneNumber: Maybe<string>, readonly profileImageUrl: Maybe<string> }>, readonly task: Maybe<{ readonly __typename?: 'DeliveryTaskDetails', readonly uuid: Maybe<string> }> }> }> };

export type IUpdateOrderMutationVariables = {
  input: IUpdateOrderInput
};


export type IUpdateOrderMutation = { readonly __typename?: 'Mutation', readonly updateOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly fireOrderIn: Maybe<number> } };

export type IPlaceCateringOrderMutationVariables = {
  input: IPlaceCateringOrderInput
};


export type IPlaceCateringOrderMutation = { readonly __typename?: 'Mutation', readonly placeCateringOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type IGetPrepaidsBalanceMutationVariables = {
  cardNumber: Scalars['String'],
  feCountryCode: IsoCountryCode
};


export type IGetPrepaidsBalanceMutation = { readonly __typename?: 'Mutation', readonly prepaidsBalance: { readonly __typename?: 'Balance', readonly currentBalance: number } };

export type IMergePrepaidsMutationVariables = {
  input: IPrepaidsMergeInput
};


export type IMergePrepaidsMutation = { readonly __typename?: 'Mutation', readonly prepaidsMerge: { readonly __typename?: 'Merge', readonly currentBalance: number } };

export type IDetailsFragment = { readonly __typename?: 'UserDetails', readonly name: Maybe<string>, readonly dob: Maybe<string>, readonly phoneNumber: Maybe<string>, readonly email: Maybe<string>, readonly emailVerified: Maybe<boolean>, readonly promotionalEmails: Maybe<boolean>, readonly isoCountryCode: Maybe<IsoCountryCode>, readonly zipcode: Maybe<string>, readonly defaultAccountIdentifier: Maybe<string>, readonly defaultFdAccountId: Maybe<string>, readonly defaultPaymentAccountId: Maybe<string>, readonly defaultReloadAmt: Maybe<number>, readonly autoReloadEnabled: Maybe<boolean>, readonly autoReloadThreshold: Maybe<number>, readonly loyaltyTier: Maybe<string>, readonly rutrPassedSkillsTestTimestamp: Maybe<string>, readonly rutrFailedSkillsTestTimestamp: Maybe<string>, readonly deliveryAddresses: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'DeliveryAddress', readonly addressLine1: string, readonly addressLine2: Maybe<string>, readonly city: string, readonly country: Maybe<IsoCountryCode>, readonly latitude: Maybe<number>, readonly longitude: Maybe<number>, readonly phoneNumber: string, readonly route: Maybe<string>, readonly state: Maybe<string>, readonly streetNumber: Maybe<string>, readonly zip: Maybe<string> }>>>, readonly communicationPreferences: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CommunicationPreference', readonly id: Maybe<string>, readonly value: Maybe<string> }>>>, readonly favoriteStores: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'FavoriteStore', readonly storeId: Maybe<string>, readonly storeNumber: Maybe<string> }>>> };

export type IGetMeQueryVariables = {
  numUniquePurchasedItems?: Maybe<Scalars['Int']>,
  customInput?: Maybe<IMeInput>
};


export type IGetMeQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly thLegacyCognitoId: Maybe<string>, readonly cognitoId: string, readonly loyaltyId: Maybe<string>, readonly details: (
      { readonly __typename?: 'UserDetails' }
      & IDetailsFragment
    ), readonly uniquePurchasedItems: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CartEntries', readonly name: Maybe<string>, readonly image: Maybe<string>, readonly lineId: string, readonly sanityId: string, readonly quantity: number, readonly type: CartEntryType, readonly price: Maybe<number>, readonly url: Maybe<string>, readonly pickerSelections: Maybe<string>, readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )>, readonly children: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
                  { readonly __typename?: 'CartEntries' }
                  & ICartEntryFragment
                )>>> }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }>>> } };

export type IKioskSignInUserMutationVariables = {
  input: ISignInUserInput
};


export type IKioskSignInUserMutation = { readonly __typename?: 'Mutation', readonly kioskSignIn: Maybe<{ readonly __typename?: 'KioskSignInDetails', readonly decryptedCode: string, readonly sessionId: string }> };

export const OperatingHoursFragmentFragmentDoc = gql`
    fragment OperatingHoursFragment on OperatingHours {
  friClose
  friOpen
  monClose
  monOpen
  satClose
  satOpen
  sunClose
  sunOpen
  thrClose
  thrOpen
  tueClose
  tueOpen
  wedClose
  wedOpen
}
    `;
export const RestaurantNodeFragmentFragmentDoc = gql`
    fragment RestaurantNodeFragment on RestaurantNode {
  _id
  storeId
  isAvailable
  posVendor
  chaseMerchantId
  curbsideHours {
    ...OperatingHoursFragment
  }
  deliveryHours {
    ...OperatingHoursFragment
  }
  diningRoomHours {
    ...OperatingHoursFragment
  }
  distanceInMiles
  drinkStationType
  driveThruHours {
    ...OperatingHoursFragment
  }
  driveThruLaneType
  email
  environment
  franchiseGroupId
  franchiseGroupName
  frontCounterClosed
  hasBreakfast
  hasBurgersForBreakfast
  hasCatering
  hasCurbside
  hasDelivery
  hasDineIn
  hasDriveThru
  hasMobileOrdering
  hasParking
  hasPlayground
  hasTakeOut
  hasWifi
  isDarkKitchen
  isFavorite
  isRecent
  latitude
  longitude
  mobileOrderingStatus
  name
  number
  parkingType
  phoneNumber
  physicalAddress {
    address1
    address2
    city
    country
    postalCode
    stateProvince
  }
  playgroundType
  pos {
    vendor
  }
  posRestaurantId
  restaurantImage {
    asset {
      _id
      metadata {
        lqip
        palette {
          dominant {
            background
            foreground
          }
        }
      }
    }
    crop {
      top
      bottom
      left
      right
    }
    hotspot {
      height
      width
      x
      y
    }
  }
  restaurantPosData {
    _id
  }
  status
  vatNumber
}
    ${OperatingHoursFragmentFragmentDoc}`;
export const UserDetailsFragmentFragmentDoc = gql`
    fragment UserDetailsFragment on UserDetails {
  name
  dob
  phoneNumber
  email
  emailVerified
  promotionalEmails
  isoCountryCode
  zipcode
  defaultAccountIdentifier
  defaultFdAccountId
  defaultPaymentAccountId
  defaultReloadAmt
  autoReloadEnabled
  autoReloadThreshold
  deliveryAddresses {
    addressLine1
    addressLine2
    city
    country
    phoneNumber
    route
    state
    streetNumber
    zip
  }
  communicationPreferences {
    id
    value
  }
  favoriteStores {
    storeId
    storeNumber
  }
  loyaltyTier
  rutrPassedSkillsTestTimestamp
  rutrFailedSkillsTestTimestamp
}
    `;
export const VendorConfigFragmentFragmentDoc = gql`
    fragment VendorConfigFragment on VendorConfig {
  pluType
  parentSanityId
  pullUpLevels
  constantPlu
  quantityBasedPlu {
    quantity
    plu
    qualifier
  }
  multiConstantPlus {
    quantity
    plu
    qualifier
  }
  parentChildPlu {
    plu
    childPlu
  }
  sizeBasedPlu {
    comboPlu
    comboSize
  }
}
    `;
export const VendorConfigsFragmentFragmentDoc = gql`
    fragment VendorConfigsFragment on VendorConfigs {
  carrols {
    ...VendorConfigFragment
  }
  carrolsDelivery {
    ...VendorConfigFragment
  }
  ncr {
    ...VendorConfigFragment
  }
  ncrDelivery {
    ...VendorConfigFragment
  }
  productNumber {
    ...VendorConfigFragment
  }
  productNumberDelivery {
    ...VendorConfigFragment
  }
  sicom {
    ...VendorConfigFragment
  }
  sicomDelivery {
    ...VendorConfigFragment
  }
  qdi {
    ...VendorConfigFragment
  }
  qdiDelivery {
    ...VendorConfigFragment
  }
  rpos {
    ...VendorConfigFragment
  }
  rposDelivery {
    ...VendorConfigFragment
  }
  tablet {
    ...VendorConfigFragment
  }
  tabletDelivery {
    ...VendorConfigFragment
  }
}
    ${VendorConfigFragmentFragmentDoc}`;
export const CartEntryFragmentFragmentDoc = gql`
    fragment CartEntryFragment on CartEntries {
  _id: lineId
  lineId
  image
  name
  pickerSelections
  price
  quantity
  sanityId
  type
  url
  redeemable
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${VendorConfigsFragmentFragmentDoc}`;
export const UserOrderFragmentFragmentDoc = gql`
    fragment UserOrderFragment on Order {
  _id: rbiOrderId
  rbiOrderId
  createdAt
  updatedAt
  fireOrderIn
  status
  delivery {
    feeCents
    tipCents
    feeDiscountCents
    status
    serviceFeeCents
    smallCartFeeCents
  }
  cart {
    ticketNumber
    storeId
    vatNumber
    serviceMode
    posVendor
    cartVersion
    storeAddress {
      addressLine1
      addressLine2
      city
      state
      zip
    }
    cartEntries {
      ...CartEntryFragment
      children {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
              }
            }
          }
        }
      }
    }
    reorderCartEntries {
      ...CartEntryFragment
      children {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
              }
            }
          }
        }
      }
    }
    subTotalCents
    taxCents
    ticketNumber
    totalCents
    unavailableCartEntries {
      lineId
      sanityId
    }
    wasLoyaltyEarned
    vatNumber
  }
}
    ${CartEntryFragmentFragmentDoc}`;
export const OfferFeedbackEntryFragmentFragmentDoc = gql`
    fragment OfferFeedbackEntryFragment on CouponUserOffersFeedbackEntry {
  cartEntry {
    cartId: lineId
  }
  _id: couponId
  tokenId
  couponId
  offerDetails
  offerState
  offerVariables {
    key
    type
    value
  }
  redemptionEligibility {
    isRedeemable
    isValid
    evaluationFeedback {
      code
      condition
      message
      redeemableForSeconds
      redeemableInSeconds
      ruleSetType
      sanityId
    }
    validationErrors {
      code
      message
      ruleSetType
    }
  }
}
    `;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  _id: rbiOrderId
  createdAt
  posOrderId
  rbiOrderId
  status
  fireOrderIn
  cart {
    customerName
    cartEntries {
      ...CartEntryFragment
      children {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
              }
            }
          }
        }
      }
    }
    cartVersion
    discounts {
      name
      value
    }
    fees {
      name
      priceCents
      quantity
      totalCents
    }
    offersFeedback {
      cartEntry {
        lineId
      }
      couponId
      redemptionEligibility {
        evaluationFeedback {
          code
          condition
          message
          redeemableForSeconds
          redeemableInSeconds
          ruleSetType
        }
        isRedeemable
        isValid
      }
    }
    payment {
      cardType
      ccLast4
      panToken
      paymentType
    }
    posVendor
    rewardsApplied {
      cartId
      rewardId
      timesApplied
    }
    serviceMode
    storeAddress {
      addressLine1
      addressLine2
      city
      state
      zip
    }
    storeDetails {
      latitude
      longitude
      storeNumber
    }
    subTotalCents
    taxCents
    ticketNumber
    totalCents
    unavailableCartEntries {
      lineId
      sanityId
    }
    wasLoyaltyEarned
    vatNumber
  }
  delivery {
    pickup {
      latitude
      longitude
    }
    dropoff {
      arrivalTime
      beforeTime
      addressLine1
      addressLine2
      city
      state
      zip
      latitude
      longitude
      phoneNumber
    }
    driver {
      name
      profileImageUrl
      phoneNumber
    }
    feeCents
    feeDiscountCents
    instructions
    status
    tipCents
    serviceFeeCents
    smallCartFeeCents
  }
  loyaltyTransaction {
    id
    pointsEarned
    bonusPointsEarned
    pointsUsed
    pointsBalance
    rewardsUsed
  }
}
    ${CartEntryFragmentFragmentDoc}`;
export const DetailsFragmentFragmentDoc = gql`
    fragment DetailsFragment on UserDetails {
  name
  dob
  phoneNumber
  email
  emailVerified
  promotionalEmails
  isoCountryCode
  zipcode
  defaultAccountIdentifier
  defaultFdAccountId
  defaultPaymentAccountId
  defaultReloadAmt
  autoReloadEnabled
  autoReloadThreshold
  deliveryAddresses {
    addressLine1
    addressLine2
    city
    country
    latitude
    longitude
    phoneNumber
    route
    state
    streetNumber
    zip
  }
  communicationPreferences {
    id
    value
  }
  favoriteStores {
    storeId
    storeNumber
  }
  loyaltyTier
  rutrPassedSkillsTestTimestamp
  rutrFailedSkillsTestTimestamp
}
    `;
export const DeleteMeDocument = gql`
    mutation DeleteMe @authRequired {
  deleteMe
}
    `;
export type IDeleteMeMutationFn = ApolloReactCommon.MutationFunction<IDeleteMeMutation, IDeleteMeMutationVariables>;

/**
 * __useDeleteMeMutation__
 *
 * To run a mutation, you first call `useDeleteMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeMutation, { data, loading, error }] = useDeleteMeMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IDeleteMeMutation, IDeleteMeMutationVariables>) {
        return ApolloReactHooks.useMutation<IDeleteMeMutation, IDeleteMeMutationVariables>(DeleteMeDocument, baseOptions);
      }
export type DeleteMeMutationHookResult = ReturnType<typeof useDeleteMeMutation>;
export type DeleteMeMutationResult = ApolloReactCommon.MutationResult<IDeleteMeMutation>;
export type DeleteMeMutationOptions = ApolloReactCommon.BaseMutationOptions<IDeleteMeMutation, IDeleteMeMutationVariables>;
export const DeliveryQuoteDocument = gql`
    query DeliveryQuote($dropoff: DeliveryWaypointInput!, $pickup: DeliveryWaypointInput!) {
  deliveryQuote(dropoff: $dropoff, pickup: $pickup) {
    status
  }
}
    `;

/**
 * __useDeliveryQuoteQuery__
 *
 * To run a query within a React component, call `useDeliveryQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryQuoteQuery({
 *   variables: {
 *      dropoff: // value for 'dropoff'
 *      pickup: // value for 'pickup'
 *   },
 * });
 */
export function useDeliveryQuoteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IDeliveryQuoteQuery, IDeliveryQuoteQueryVariables>) {
        return ApolloReactHooks.useQuery<IDeliveryQuoteQuery, IDeliveryQuoteQueryVariables>(DeliveryQuoteDocument, baseOptions);
      }
export function useDeliveryQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IDeliveryQuoteQuery, IDeliveryQuoteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IDeliveryQuoteQuery, IDeliveryQuoteQueryVariables>(DeliveryQuoteDocument, baseOptions);
        }
export type DeliveryQuoteQueryHookResult = ReturnType<typeof useDeliveryQuoteQuery>;
export type DeliveryQuoteLazyQueryHookResult = ReturnType<typeof useDeliveryQuoteLazyQuery>;
export type DeliveryQuoteQueryResult = ApolloReactCommon.QueryResult<IDeliveryQuoteQuery, IDeliveryQuoteQueryVariables>;
export const GetRestaurantDocument = gql`
    query GetRestaurant($storeId: String, $storeNumber: String) {
  restaurant(storeId: $storeId, storeNumber: $storeNumber) {
    available
    curbsideHours {
      ...OperatingHoursFragment
    }
    deliveryHours {
      ...OperatingHoursFragment
    }
    diningRoomHours {
      ...OperatingHoursFragment
    }
    driveThruHours {
      ...OperatingHoursFragment
    }
  }
}
    ${OperatingHoursFragmentFragmentDoc}`;

/**
 * __useGetRestaurantQuery__
 *
 * To run a query within a React component, call `useGetRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      storeNumber: // value for 'storeNumber'
 *   },
 * });
 */
export function useGetRestaurantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetRestaurantQuery, IGetRestaurantQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetRestaurantQuery, IGetRestaurantQueryVariables>(GetRestaurantDocument, baseOptions);
      }
export function useGetRestaurantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetRestaurantQuery, IGetRestaurantQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetRestaurantQuery, IGetRestaurantQueryVariables>(GetRestaurantDocument, baseOptions);
        }
export type GetRestaurantQueryHookResult = ReturnType<typeof useGetRestaurantQuery>;
export type GetRestaurantLazyQueryHookResult = ReturnType<typeof useGetRestaurantLazyQuery>;
export type GetRestaurantQueryResult = ApolloReactCommon.QueryResult<IGetRestaurantQuery, IGetRestaurantQueryVariables>;
export const RefreshRestaurantAvailabilityDocument = gql`
    mutation RefreshRestaurantAvailability($storeId: String, $storeNumber: String) {
  refreshRestaurantAvailability(storeId: $storeId, storeNumber: $storeNumber)
}
    `;
export type IRefreshRestaurantAvailabilityMutationFn = ApolloReactCommon.MutationFunction<IRefreshRestaurantAvailabilityMutation, IRefreshRestaurantAvailabilityMutationVariables>;

/**
 * __useRefreshRestaurantAvailabilityMutation__
 *
 * To run a mutation, you first call `useRefreshRestaurantAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshRestaurantAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshRestaurantAvailabilityMutation, { data, loading, error }] = useRefreshRestaurantAvailabilityMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      storeNumber: // value for 'storeNumber'
 *   },
 * });
 */
export function useRefreshRestaurantAvailabilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IRefreshRestaurantAvailabilityMutation, IRefreshRestaurantAvailabilityMutationVariables>) {
        return ApolloReactHooks.useMutation<IRefreshRestaurantAvailabilityMutation, IRefreshRestaurantAvailabilityMutationVariables>(RefreshRestaurantAvailabilityDocument, baseOptions);
      }
export type RefreshRestaurantAvailabilityMutationHookResult = ReturnType<typeof useRefreshRestaurantAvailabilityMutation>;
export type RefreshRestaurantAvailabilityMutationResult = ApolloReactCommon.MutationResult<IRefreshRestaurantAvailabilityMutation>;
export type RefreshRestaurantAvailabilityMutationOptions = ApolloReactCommon.BaseMutationOptions<IRefreshRestaurantAvailabilityMutation, IRefreshRestaurantAvailabilityMutationVariables>;
export const GetAvailableGiftOffersDocument = gql`
    query getAvailableGiftOffers {
  listGiftOffers {
    count
    offers {
      title
      titleFormatted
      offerId
      costInPoints
      isRedeemable
    }
  }
}
    `;

/**
 * __useGetAvailableGiftOffersQuery__
 *
 * To run a query within a React component, call `useGetAvailableGiftOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableGiftOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableGiftOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableGiftOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetAvailableGiftOffersQuery, IGetAvailableGiftOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetAvailableGiftOffersQuery, IGetAvailableGiftOffersQueryVariables>(GetAvailableGiftOffersDocument, baseOptions);
      }
export function useGetAvailableGiftOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetAvailableGiftOffersQuery, IGetAvailableGiftOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetAvailableGiftOffersQuery, IGetAvailableGiftOffersQueryVariables>(GetAvailableGiftOffersDocument, baseOptions);
        }
export type GetAvailableGiftOffersQueryHookResult = ReturnType<typeof useGetAvailableGiftOffersQuery>;
export type GetAvailableGiftOffersLazyQueryHookResult = ReturnType<typeof useGetAvailableGiftOffersLazyQuery>;
export type GetAvailableGiftOffersQueryResult = ApolloReactCommon.QueryResult<IGetAvailableGiftOffersQuery, IGetAvailableGiftOffersQueryVariables>;
export const GiftOfferMutationDocument = gql`
    mutation GiftOfferMutation($input: GiftOfferInput!) {
  addGiftOfferByEmail(input: $input)
}
    `;
export type IGiftOfferMutationMutationFn = ApolloReactCommon.MutationFunction<IGiftOfferMutation, IGiftOfferMutationVariables>;

/**
 * __useGiftOfferMutation__
 *
 * To run a mutation, you first call `useGiftOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiftOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giftOfferMutation, { data, loading, error }] = useGiftOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiftOfferMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IGiftOfferMutation, IGiftOfferMutationVariables>) {
        return ApolloReactHooks.useMutation<IGiftOfferMutation, IGiftOfferMutationVariables>(GiftOfferMutationDocument, baseOptions);
      }
export type GiftOfferMutationHookResult = ReturnType<typeof useGiftOfferMutation>;
export type GiftOfferMutationMutationResult = ApolloReactCommon.MutationResult<IGiftOfferMutation>;
export type GiftOfferMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<IGiftOfferMutation, IGiftOfferMutationVariables>;
export const AddOfferByTokenDocument = gql`
    mutation AddOfferByToken($token: String!) {
  addOfferByToken(token: $token)
}
    `;
export type IAddOfferByTokenMutationFn = ApolloReactCommon.MutationFunction<IAddOfferByTokenMutation, IAddOfferByTokenMutationVariables>;

/**
 * __useAddOfferByTokenMutation__
 *
 * To run a mutation, you first call `useAddOfferByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOfferByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOfferByTokenMutation, { data, loading, error }] = useAddOfferByTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAddOfferByTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IAddOfferByTokenMutation, IAddOfferByTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<IAddOfferByTokenMutation, IAddOfferByTokenMutationVariables>(AddOfferByTokenDocument, baseOptions);
      }
export type AddOfferByTokenMutationHookResult = ReturnType<typeof useAddOfferByTokenMutation>;
export type AddOfferByTokenMutationResult = ApolloReactCommon.MutationResult<IAddOfferByTokenMutation>;
export type AddOfferByTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<IAddOfferByTokenMutation, IAddOfferByTokenMutationVariables>;
export const CreateSupportCaseDocument = gql`
    mutation CreateSupportCase($caseInfo: SupportCaseInput!) {
  createSupportCase(caseInfo: $caseInfo) {
    caseId
  }
}
    `;
export type ICreateSupportCaseMutationFn = ApolloReactCommon.MutationFunction<ICreateSupportCaseMutation, ICreateSupportCaseMutationVariables>;

/**
 * __useCreateSupportCaseMutation__
 *
 * To run a mutation, you first call `useCreateSupportCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportCaseMutation, { data, loading, error }] = useCreateSupportCaseMutation({
 *   variables: {
 *      caseInfo: // value for 'caseInfo'
 *   },
 * });
 */
export function useCreateSupportCaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateSupportCaseMutation, ICreateSupportCaseMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateSupportCaseMutation, ICreateSupportCaseMutationVariables>(CreateSupportCaseDocument, baseOptions);
      }
export type CreateSupportCaseMutationHookResult = ReturnType<typeof useCreateSupportCaseMutation>;
export type CreateSupportCaseMutationResult = ApolloReactCommon.MutationResult<ICreateSupportCaseMutation>;
export type CreateSupportCaseMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateSupportCaseMutation, ICreateSupportCaseMutationVariables>;
export const GetLoyaltyCardsDocument = gql`
    query GetLoyaltyCards @authRequired {
  getLoyaltyCards {
    count
    cards {
      barcode
      cardFormat
      cardId
      cardType
      name
    }
  }
}
    `;

/**
 * __useGetLoyaltyCardsQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoyaltyCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyCardsQuery, IGetLoyaltyCardsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyCardsQuery, IGetLoyaltyCardsQueryVariables>(GetLoyaltyCardsDocument, baseOptions);
      }
export function useGetLoyaltyCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyCardsQuery, IGetLoyaltyCardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyCardsQuery, IGetLoyaltyCardsQueryVariables>(GetLoyaltyCardsDocument, baseOptions);
        }
export type GetLoyaltyCardsQueryHookResult = ReturnType<typeof useGetLoyaltyCardsQuery>;
export type GetLoyaltyCardsLazyQueryHookResult = ReturnType<typeof useGetLoyaltyCardsLazyQuery>;
export type GetLoyaltyCardsQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyCardsQuery, IGetLoyaltyCardsQueryVariables>;
export const GetLoyaltyCardDetailsDocument = gql`
    query GetLoyaltyCardDetails($cardId: String!) @authRequired {
  getLoyaltyCardDetails(cardId: $cardId) {
    availableRedemptions
    canEarnVisit
    canRedeemReward
    cardType
    discountActiveUntil
    donationUpcharge
    numberOfTransactionsInTimePeriod
    numberOfTransactionsMadeTowardsNextReward
    numberOfTransactionsNeeded
    periodEndTimestamp
    periodStartTimestamp
    pointExpiry {
      points
      expirationDate
    }
    points
  }
}
    `;

/**
 * __useGetLoyaltyCardDetailsQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyCardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyCardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyCardDetailsQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetLoyaltyCardDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyCardDetailsQuery, IGetLoyaltyCardDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyCardDetailsQuery, IGetLoyaltyCardDetailsQueryVariables>(GetLoyaltyCardDetailsDocument, baseOptions);
      }
export function useGetLoyaltyCardDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyCardDetailsQuery, IGetLoyaltyCardDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyCardDetailsQuery, IGetLoyaltyCardDetailsQueryVariables>(GetLoyaltyCardDetailsDocument, baseOptions);
        }
export type GetLoyaltyCardDetailsQueryHookResult = ReturnType<typeof useGetLoyaltyCardDetailsQuery>;
export type GetLoyaltyCardDetailsLazyQueryHookResult = ReturnType<typeof useGetLoyaltyCardDetailsLazyQuery>;
export type GetLoyaltyCardDetailsQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyCardDetailsQuery, IGetLoyaltyCardDetailsQueryVariables>;
export const GetLoyaltyCardTransactionsDocument = gql`
    query GetLoyaltyCardTransactions($cardId: String!, $endDate: String, $page: String, $pageSize: String, $startDate: String) @authRequired {
  getLoyaltyCardTransactions(cardId: $cardId, endDate: $endDate, page: $page, pageSize: $pageSize, startDate: $startDate) {
    transactions {
      bonusPoints
      tag
      transactionId
      timestamp
      basketTotal
      rewardRedeemed
      discountAmount
      isVisit
      pointsEarned
      pointsUsed
      isCustomerServiceVisit
    }
  }
}
    `;

/**
 * __useGetLoyaltyCardTransactionsQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyCardTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyCardTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyCardTransactionsQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      endDate: // value for 'endDate'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetLoyaltyCardTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyCardTransactionsQuery, IGetLoyaltyCardTransactionsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyCardTransactionsQuery, IGetLoyaltyCardTransactionsQueryVariables>(GetLoyaltyCardTransactionsDocument, baseOptions);
      }
export function useGetLoyaltyCardTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyCardTransactionsQuery, IGetLoyaltyCardTransactionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyCardTransactionsQuery, IGetLoyaltyCardTransactionsQueryVariables>(GetLoyaltyCardTransactionsDocument, baseOptions);
        }
export type GetLoyaltyCardTransactionsQueryHookResult = ReturnType<typeof useGetLoyaltyCardTransactionsQuery>;
export type GetLoyaltyCardTransactionsLazyQueryHookResult = ReturnType<typeof useGetLoyaltyCardTransactionsLazyQuery>;
export type GetLoyaltyCardTransactionsQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyCardTransactionsQuery, IGetLoyaltyCardTransactionsQueryVariables>;
export const GetLoyaltyCardDetailsFromBarcodeDocument = gql`
    query GetLoyaltyCardDetailsFromBarcode($barcode: String!) @authRequired {
  getLoyaltyCardDetailsKiosk(barcode: $barcode, operator: "0", restaurantId: "100000", terminal: "0", transactionId: "0") {
    availableRedemptions
    numberOfTransactionsInTimePeriod
    numberOfTransactionsMadeTowardsNextReward
    numberOfTransactionsNeeded
  }
}
    `;

/**
 * __useGetLoyaltyCardDetailsFromBarcodeQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyCardDetailsFromBarcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyCardDetailsFromBarcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyCardDetailsFromBarcodeQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *   },
 * });
 */
export function useGetLoyaltyCardDetailsFromBarcodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyCardDetailsFromBarcodeQuery, IGetLoyaltyCardDetailsFromBarcodeQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyCardDetailsFromBarcodeQuery, IGetLoyaltyCardDetailsFromBarcodeQueryVariables>(GetLoyaltyCardDetailsFromBarcodeDocument, baseOptions);
      }
export function useGetLoyaltyCardDetailsFromBarcodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyCardDetailsFromBarcodeQuery, IGetLoyaltyCardDetailsFromBarcodeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyCardDetailsFromBarcodeQuery, IGetLoyaltyCardDetailsFromBarcodeQueryVariables>(GetLoyaltyCardDetailsFromBarcodeDocument, baseOptions);
        }
export type GetLoyaltyCardDetailsFromBarcodeQueryHookResult = ReturnType<typeof useGetLoyaltyCardDetailsFromBarcodeQuery>;
export type GetLoyaltyCardDetailsFromBarcodeLazyQueryHookResult = ReturnType<typeof useGetLoyaltyCardDetailsFromBarcodeLazyQuery>;
export type GetLoyaltyCardDetailsFromBarcodeQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyCardDetailsFromBarcodeQuery, IGetLoyaltyCardDetailsFromBarcodeQueryVariables>;
export const GetLoyaltyRollUpTheRimTimelineEventsDocument = gql`
    query GetLoyaltyRollUpTheRimTimelineEvents($eventId: String, $resumeAfter: String, $sortAscending: Boolean) @authRequired {
  getLoyaltyRollUpTheRimTimelineEvents(eventId: $eventId, resumeAfter: $resumeAfter, sortAscending: $sortAscending) {
    count
    events {
      prizeId
      createdAt
      eventId
      referenceId
      timelineId
      type
      offerStatus {
        offerId
        activated
        used
      }
    }
    resumeAfter
  }
}
    `;

/**
 * __useGetLoyaltyRollUpTheRimTimelineEventsQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyRollUpTheRimTimelineEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyRollUpTheRimTimelineEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyRollUpTheRimTimelineEventsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      resumeAfter: // value for 'resumeAfter'
 *      sortAscending: // value for 'sortAscending'
 *   },
 * });
 */
export function useGetLoyaltyRollUpTheRimTimelineEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyRollUpTheRimTimelineEventsQuery, IGetLoyaltyRollUpTheRimTimelineEventsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyRollUpTheRimTimelineEventsQuery, IGetLoyaltyRollUpTheRimTimelineEventsQueryVariables>(GetLoyaltyRollUpTheRimTimelineEventsDocument, baseOptions);
      }
export function useGetLoyaltyRollUpTheRimTimelineEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyRollUpTheRimTimelineEventsQuery, IGetLoyaltyRollUpTheRimTimelineEventsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyRollUpTheRimTimelineEventsQuery, IGetLoyaltyRollUpTheRimTimelineEventsQueryVariables>(GetLoyaltyRollUpTheRimTimelineEventsDocument, baseOptions);
        }
export type GetLoyaltyRollUpTheRimTimelineEventsQueryHookResult = ReturnType<typeof useGetLoyaltyRollUpTheRimTimelineEventsQuery>;
export type GetLoyaltyRollUpTheRimTimelineEventsLazyQueryHookResult = ReturnType<typeof useGetLoyaltyRollUpTheRimTimelineEventsLazyQuery>;
export type GetLoyaltyRollUpTheRimTimelineEventsQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyRollUpTheRimTimelineEventsQuery, IGetLoyaltyRollUpTheRimTimelineEventsQueryVariables>;
export const AddVoucherDocument = gql`
    mutation AddVoucher($voucherId: String!) @authRequired {
  addVoucher(voucherId: $voucherId)
}
    `;
export type IAddVoucherMutationFn = ApolloReactCommon.MutationFunction<IAddVoucherMutation, IAddVoucherMutationVariables>;

/**
 * __useAddVoucherMutation__
 *
 * To run a mutation, you first call `useAddVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVoucherMutation, { data, loading, error }] = useAddVoucherMutation({
 *   variables: {
 *      voucherId: // value for 'voucherId'
 *   },
 * });
 */
export function useAddVoucherMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IAddVoucherMutation, IAddVoucherMutationVariables>) {
        return ApolloReactHooks.useMutation<IAddVoucherMutation, IAddVoucherMutationVariables>(AddVoucherDocument, baseOptions);
      }
export type AddVoucherMutationHookResult = ReturnType<typeof useAddVoucherMutation>;
export type AddVoucherMutationResult = ApolloReactCommon.MutationResult<IAddVoucherMutation>;
export type AddVoucherMutationOptions = ApolloReactCommon.BaseMutationOptions<IAddVoucherMutation, IAddVoucherMutationVariables>;
export const SetLoyaltyCardRewardsTierDocument = gql`
    mutation SetLoyaltyCardRewardsTier($loyaltyTier: String!) @authRequired {
  updateMe(details: {loyaltyTier: $loyaltyTier}) {
    details {
      loyaltyTier
    }
  }
}
    `;
export type ISetLoyaltyCardRewardsTierMutationFn = ApolloReactCommon.MutationFunction<ISetLoyaltyCardRewardsTierMutation, ISetLoyaltyCardRewardsTierMutationVariables>;

/**
 * __useSetLoyaltyCardRewardsTierMutation__
 *
 * To run a mutation, you first call `useSetLoyaltyCardRewardsTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLoyaltyCardRewardsTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLoyaltyCardRewardsTierMutation, { data, loading, error }] = useSetLoyaltyCardRewardsTierMutation({
 *   variables: {
 *      loyaltyTier: // value for 'loyaltyTier'
 *   },
 * });
 */
export function useSetLoyaltyCardRewardsTierMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISetLoyaltyCardRewardsTierMutation, ISetLoyaltyCardRewardsTierMutationVariables>) {
        return ApolloReactHooks.useMutation<ISetLoyaltyCardRewardsTierMutation, ISetLoyaltyCardRewardsTierMutationVariables>(SetLoyaltyCardRewardsTierDocument, baseOptions);
      }
export type SetLoyaltyCardRewardsTierMutationHookResult = ReturnType<typeof useSetLoyaltyCardRewardsTierMutation>;
export type SetLoyaltyCardRewardsTierMutationResult = ApolloReactCommon.MutationResult<ISetLoyaltyCardRewardsTierMutation>;
export type SetLoyaltyCardRewardsTierMutationOptions = ApolloReactCommon.BaseMutationOptions<ISetLoyaltyCardRewardsTierMutation, ISetLoyaltyCardRewardsTierMutationVariables>;
export const MergeLoyaltyCardsDocument = gql`
    mutation MergeLoyaltyCards($cardId: String!, $existingCardId: String!) @authRequired {
  mergeLoyaltyCards(cardId: $cardId, existingCardId: $existingCardId) {
    cardId
  }
}
    `;
export type IMergeLoyaltyCardsMutationFn = ApolloReactCommon.MutationFunction<IMergeLoyaltyCardsMutation, IMergeLoyaltyCardsMutationVariables>;

/**
 * __useMergeLoyaltyCardsMutation__
 *
 * To run a mutation, you first call `useMergeLoyaltyCardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeLoyaltyCardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeLoyaltyCardsMutation, { data, loading, error }] = useMergeLoyaltyCardsMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      existingCardId: // value for 'existingCardId'
 *   },
 * });
 */
export function useMergeLoyaltyCardsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IMergeLoyaltyCardsMutation, IMergeLoyaltyCardsMutationVariables>) {
        return ApolloReactHooks.useMutation<IMergeLoyaltyCardsMutation, IMergeLoyaltyCardsMutationVariables>(MergeLoyaltyCardsDocument, baseOptions);
      }
export type MergeLoyaltyCardsMutationHookResult = ReturnType<typeof useMergeLoyaltyCardsMutation>;
export type MergeLoyaltyCardsMutationResult = ApolloReactCommon.MutationResult<IMergeLoyaltyCardsMutation>;
export type MergeLoyaltyCardsMutationOptions = ApolloReactCommon.BaseMutationOptions<IMergeLoyaltyCardsMutation, IMergeLoyaltyCardsMutationVariables>;
export const DeleteLoyaltyCardDocument = gql`
    mutation DeleteLoyaltyCard($cardId: String!) @authRequired {
  deleteLoyaltyCard(existingCardId: $cardId) {
    cardId
  }
}
    `;
export type IDeleteLoyaltyCardMutationFn = ApolloReactCommon.MutationFunction<IDeleteLoyaltyCardMutation, IDeleteLoyaltyCardMutationVariables>;

/**
 * __useDeleteLoyaltyCardMutation__
 *
 * To run a mutation, you first call `useDeleteLoyaltyCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoyaltyCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoyaltyCardMutation, { data, loading, error }] = useDeleteLoyaltyCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useDeleteLoyaltyCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IDeleteLoyaltyCardMutation, IDeleteLoyaltyCardMutationVariables>) {
        return ApolloReactHooks.useMutation<IDeleteLoyaltyCardMutation, IDeleteLoyaltyCardMutationVariables>(DeleteLoyaltyCardDocument, baseOptions);
      }
export type DeleteLoyaltyCardMutationHookResult = ReturnType<typeof useDeleteLoyaltyCardMutation>;
export type DeleteLoyaltyCardMutationResult = ApolloReactCommon.MutationResult<IDeleteLoyaltyCardMutation>;
export type DeleteLoyaltyCardMutationOptions = ApolloReactCommon.BaseMutationOptions<IDeleteLoyaltyCardMutation, IDeleteLoyaltyCardMutationVariables>;
export const SetLoyaltyDonationUpchargeDocument = gql`
    mutation SetLoyaltyDonationUpcharge($cardId: String!, $donationUpcharge: Boolean!) @authRequired {
  setLoyaltyDonationUpcharge(cardId: $cardId, donationUpcharge: $donationUpcharge) {
    donationUpcharge
  }
}
    `;
export type ISetLoyaltyDonationUpchargeMutationFn = ApolloReactCommon.MutationFunction<ISetLoyaltyDonationUpchargeMutation, ISetLoyaltyDonationUpchargeMutationVariables>;

/**
 * __useSetLoyaltyDonationUpchargeMutation__
 *
 * To run a mutation, you first call `useSetLoyaltyDonationUpchargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLoyaltyDonationUpchargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLoyaltyDonationUpchargeMutation, { data, loading, error }] = useSetLoyaltyDonationUpchargeMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      donationUpcharge: // value for 'donationUpcharge'
 *   },
 * });
 */
export function useSetLoyaltyDonationUpchargeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISetLoyaltyDonationUpchargeMutation, ISetLoyaltyDonationUpchargeMutationVariables>) {
        return ApolloReactHooks.useMutation<ISetLoyaltyDonationUpchargeMutation, ISetLoyaltyDonationUpchargeMutationVariables>(SetLoyaltyDonationUpchargeDocument, baseOptions);
      }
export type SetLoyaltyDonationUpchargeMutationHookResult = ReturnType<typeof useSetLoyaltyDonationUpchargeMutation>;
export type SetLoyaltyDonationUpchargeMutationResult = ApolloReactCommon.MutationResult<ISetLoyaltyDonationUpchargeMutation>;
export type SetLoyaltyDonationUpchargeMutationOptions = ApolloReactCommon.BaseMutationOptions<ISetLoyaltyDonationUpchargeMutation, ISetLoyaltyDonationUpchargeMutationVariables>;
export const EvaluateUserOffersDocument = gql`
    query evaluateUserOffers($cart: PriceOrderInput, $couponIds: [ID], $evaluateAllCouponIds: Boolean, $locale: Locale, $platform: Platform, $rbiOrderId: ID, $redeemedOn: String!, $serviceMode: ServiceMode, $storeId: String) {
  evaluateUserOffers(cart: $cart, couponIds: $couponIds, evaluateAllCouponIds: $evaluateAllCouponIds, locale: $locale, platform: $platform, rbiOrderId: $rbiOrderId, redeemedOn: $redeemedOn, serviceMode: $serviceMode, storeId: $storeId) {
    offersFeedback {
      ...OfferFeedbackEntryFragment
    }
  }
}
    ${OfferFeedbackEntryFragmentFragmentDoc}`;

/**
 * __useEvaluateUserOffersQuery__
 *
 * To run a query within a React component, call `useEvaluateUserOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluateUserOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluateUserOffersQuery({
 *   variables: {
 *      cart: // value for 'cart'
 *      couponIds: // value for 'couponIds'
 *      evaluateAllCouponIds: // value for 'evaluateAllCouponIds'
 *      locale: // value for 'locale'
 *      platform: // value for 'platform'
 *      rbiOrderId: // value for 'rbiOrderId'
 *      redeemedOn: // value for 'redeemedOn'
 *      serviceMode: // value for 'serviceMode'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useEvaluateUserOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IEvaluateUserOffersQuery, IEvaluateUserOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<IEvaluateUserOffersQuery, IEvaluateUserOffersQueryVariables>(EvaluateUserOffersDocument, baseOptions);
      }
export function useEvaluateUserOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IEvaluateUserOffersQuery, IEvaluateUserOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IEvaluateUserOffersQuery, IEvaluateUserOffersQueryVariables>(EvaluateUserOffersDocument, baseOptions);
        }
export type EvaluateUserOffersQueryHookResult = ReturnType<typeof useEvaluateUserOffersQuery>;
export type EvaluateUserOffersLazyQueryHookResult = ReturnType<typeof useEvaluateUserOffersLazyQuery>;
export type EvaluateUserOffersQueryResult = ApolloReactCommon.QueryResult<IEvaluateUserOffersQuery, IEvaluateUserOffersQueryVariables>;
export const EvaluateAllUserOffersDocument = gql`
    query evaluateAllUserOffers($locale: Locale, $platform: Platform, $redeemedOn: String!, $serviceMode: ServiceMode, $storeId: String) {
  evaluateAllUserOffers(locale: $locale, platform: $platform, redeemedOn: $redeemedOn, serviceMode: $serviceMode, storeId: $storeId) {
    offersFeedback {
      ...OfferFeedbackEntryFragment
    }
  }
}
    ${OfferFeedbackEntryFragmentFragmentDoc}`;

/**
 * __useEvaluateAllUserOffersQuery__
 *
 * To run a query within a React component, call `useEvaluateAllUserOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluateAllUserOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluateAllUserOffersQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      platform: // value for 'platform'
 *      redeemedOn: // value for 'redeemedOn'
 *      serviceMode: // value for 'serviceMode'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useEvaluateAllUserOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IEvaluateAllUserOffersQuery, IEvaluateAllUserOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<IEvaluateAllUserOffersQuery, IEvaluateAllUserOffersQueryVariables>(EvaluateAllUserOffersDocument, baseOptions);
      }
export function useEvaluateAllUserOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IEvaluateAllUserOffersQuery, IEvaluateAllUserOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IEvaluateAllUserOffersQuery, IEvaluateAllUserOffersQueryVariables>(EvaluateAllUserOffersDocument, baseOptions);
        }
export type EvaluateAllUserOffersQueryHookResult = ReturnType<typeof useEvaluateAllUserOffersQuery>;
export type EvaluateAllUserOffersLazyQueryHookResult = ReturnType<typeof useEvaluateAllUserOffersLazyQuery>;
export type EvaluateAllUserOffersQueryResult = ApolloReactCommon.QueryResult<IEvaluateAllUserOffersQuery, IEvaluateAllUserOffersQueryVariables>;
export const ListOffersByUserIdDocument = gql`
    query listOffersByUserId @authRequired {
  listUserCouponTokens {
    count
    tokens {
      couponId
      createdAt
      expiresOn
      tokenId
    }
  }
}
    `;

/**
 * __useListOffersByUserIdQuery__
 *
 * To run a query within a React component, call `useListOffersByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOffersByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOffersByUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOffersByUserIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IListOffersByUserIdQuery, IListOffersByUserIdQueryVariables>) {
        return ApolloReactHooks.useQuery<IListOffersByUserIdQuery, IListOffersByUserIdQueryVariables>(ListOffersByUserIdDocument, baseOptions);
      }
export function useListOffersByUserIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IListOffersByUserIdQuery, IListOffersByUserIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IListOffersByUserIdQuery, IListOffersByUserIdQueryVariables>(ListOffersByUserIdDocument, baseOptions);
        }
export type ListOffersByUserIdQueryHookResult = ReturnType<typeof useListOffersByUserIdQuery>;
export type ListOffersByUserIdLazyQueryHookResult = ReturnType<typeof useListOffersByUserIdLazyQuery>;
export type ListOffersByUserIdQueryResult = ApolloReactCommon.QueryResult<IListOffersByUserIdQuery, IListOffersByUserIdQueryVariables>;
export const RedeemOfferDocument = gql`
    mutation redeemOffer($couponId: ID!) {
  redeemCoupon(couponId: $couponId) @authRequired {
    couponId
    redeemedOn
  }
}
    `;
export type IRedeemOfferMutationFn = ApolloReactCommon.MutationFunction<IRedeemOfferMutation, IRedeemOfferMutationVariables>;

/**
 * __useRedeemOfferMutation__
 *
 * To run a mutation, you first call `useRedeemOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemOfferMutation, { data, loading, error }] = useRedeemOfferMutation({
 *   variables: {
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useRedeemOfferMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IRedeemOfferMutation, IRedeemOfferMutationVariables>) {
        return ApolloReactHooks.useMutation<IRedeemOfferMutation, IRedeemOfferMutationVariables>(RedeemOfferDocument, baseOptions);
      }
export type RedeemOfferMutationHookResult = ReturnType<typeof useRedeemOfferMutation>;
export type RedeemOfferMutationResult = ApolloReactCommon.MutationResult<IRedeemOfferMutation>;
export type RedeemOfferMutationOptions = ApolloReactCommon.BaseMutationOptions<IRedeemOfferMutation, IRedeemOfferMutationVariables>;
export const GetEncryptionDetailsDocument = gql`
    mutation GetEncryptionDetails {
  encryptionDetails {
    fdPublicKey
    fdAccessToken
    fdPublicKeyExpiresInSeconds
    fdApiKey
    algorithm
    fdCustomerId
  }
}
    `;
export type IGetEncryptionDetailsMutationFn = ApolloReactCommon.MutationFunction<IGetEncryptionDetailsMutation, IGetEncryptionDetailsMutationVariables>;

/**
 * __useGetEncryptionDetailsMutation__
 *
 * To run a mutation, you first call `useGetEncryptionDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEncryptionDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEncryptionDetailsMutation, { data, loading, error }] = useGetEncryptionDetailsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetEncryptionDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IGetEncryptionDetailsMutation, IGetEncryptionDetailsMutationVariables>) {
        return ApolloReactHooks.useMutation<IGetEncryptionDetailsMutation, IGetEncryptionDetailsMutationVariables>(GetEncryptionDetailsDocument, baseOptions);
      }
export type GetEncryptionDetailsMutationHookResult = ReturnType<typeof useGetEncryptionDetailsMutation>;
export type GetEncryptionDetailsMutationResult = ApolloReactCommon.MutationResult<IGetEncryptionDetailsMutation>;
export type GetEncryptionDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<IGetEncryptionDetailsMutation, IGetEncryptionDetailsMutationVariables>;
export const AddCreditAccountDocument = gql`
    mutation AddCreditAccount($input: AddCreditAccountInput!) @authRequired {
  addCreditAccount(input: $input) {
    accountIdentifier
    fdAccountId
    chaseProfileId
    credit {
      alias
      billingAddress {
        locality
        postalCode
        region
        streetAddress
        unitNumber
      }
      cardType
      expiryMonth
      expiryYear
      panToken
    }
  }
}
    `;
export type IAddCreditAccountMutationFn = ApolloReactCommon.MutationFunction<IAddCreditAccountMutation, IAddCreditAccountMutationVariables>;

/**
 * __useAddCreditAccountMutation__
 *
 * To run a mutation, you first call `useAddCreditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreditAccountMutation, { data, loading, error }] = useAddCreditAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCreditAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IAddCreditAccountMutation, IAddCreditAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<IAddCreditAccountMutation, IAddCreditAccountMutationVariables>(AddCreditAccountDocument, baseOptions);
      }
export type AddCreditAccountMutationHookResult = ReturnType<typeof useAddCreditAccountMutation>;
export type AddCreditAccountMutationResult = ApolloReactCommon.MutationResult<IAddCreditAccountMutation>;
export type AddCreditAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<IAddCreditAccountMutation, IAddCreditAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($input: DeleteAccountInput!) @authRequired {
  deleteAccount(input: $input)
}
    `;
export type IDeleteAccountMutationFn = ApolloReactCommon.MutationFunction<IDeleteAccountMutation, IDeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IDeleteAccountMutation, IDeleteAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<IDeleteAccountMutation, IDeleteAccountMutationVariables>(DeleteAccountDocument, baseOptions);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = ApolloReactCommon.MutationResult<IDeleteAccountMutation>;
export type DeleteAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<IDeleteAccountMutation, IDeleteAccountMutationVariables>;
export const UserAccountsDocument = gql`
    query UserAccounts($feCountryCode: IsoCountryCode!) @authRequired {
  userAccounts(feCountryCode: $feCountryCode) {
    count
    accounts {
      accountIdentifier
      fdAccountId
      chaseProfileId
      credit {
        alias
        cardType
        expiryYear
        expiryMonth
        panToken
      }
      prepaid {
        alias
        currentBalance
        cardNumber
        expiryMonth
        expiryYear
        feFormattedCurrentBalance
        shuffledCardNumber
      }
    }
    paymentProcessor
  }
}
    `;

/**
 * __useUserAccountsQuery__
 *
 * To run a query within a React component, call `useUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountsQuery({
 *   variables: {
 *      feCountryCode: // value for 'feCountryCode'
 *   },
 * });
 */
export function useUserAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IUserAccountsQuery, IUserAccountsQueryVariables>) {
        return ApolloReactHooks.useQuery<IUserAccountsQuery, IUserAccountsQueryVariables>(UserAccountsDocument, baseOptions);
      }
export function useUserAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IUserAccountsQuery, IUserAccountsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IUserAccountsQuery, IUserAccountsQueryVariables>(UserAccountsDocument, baseOptions);
        }
export type UserAccountsQueryHookResult = ReturnType<typeof useUserAccountsQuery>;
export type UserAccountsLazyQueryHookResult = ReturnType<typeof useUserAccountsLazyQuery>;
export type UserAccountsQueryResult = ApolloReactCommon.QueryResult<IUserAccountsQuery, IUserAccountsQueryVariables>;
export const PluDataDocument = gql`
    query pluData($storeId: String!) {
  pluData(storeId: $storeId) {
    plus
    deliveryPlus
    updatedAt
  }
}
    `;

/**
 * __usePluDataQuery__
 *
 * To run a query within a React component, call `usePluDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluDataQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function usePluDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IPluDataQuery, IPluDataQueryVariables>) {
        return ApolloReactHooks.useQuery<IPluDataQuery, IPluDataQueryVariables>(PluDataDocument, baseOptions);
      }
export function usePluDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IPluDataQuery, IPluDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IPluDataQuery, IPluDataQueryVariables>(PluDataDocument, baseOptions);
        }
export type PluDataQueryHookResult = ReturnType<typeof usePluDataQuery>;
export type PluDataLazyQueryHookResult = ReturnType<typeof usePluDataLazyQuery>;
export type PluDataQueryResult = ApolloReactCommon.QueryResult<IPluDataQuery, IPluDataQueryVariables>;
export const PrepaidsReloadDocument = gql`
    mutation PrepaidsReload($input: PrepaidsReloadInput!) @authRequired {
  prepaidsReload(input: $input) {
    currentBalance
    fdAccountId
    fdCorrelationId
    transactionId
  }
}
    `;
export type IPrepaidsReloadMutationFn = ApolloReactCommon.MutationFunction<IPrepaidsReloadMutation, IPrepaidsReloadMutationVariables>;

/**
 * __usePrepaidsReloadMutation__
 *
 * To run a mutation, you first call `usePrepaidsReloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepaidsReloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepaidsReloadMutation, { data, loading, error }] = usePrepaidsReloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepaidsReloadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPrepaidsReloadMutation, IPrepaidsReloadMutationVariables>) {
        return ApolloReactHooks.useMutation<IPrepaidsReloadMutation, IPrepaidsReloadMutationVariables>(PrepaidsReloadDocument, baseOptions);
      }
export type PrepaidsReloadMutationHookResult = ReturnType<typeof usePrepaidsReloadMutation>;
export type PrepaidsReloadMutationResult = ApolloReactCommon.MutationResult<IPrepaidsReloadMutation>;
export type PrepaidsReloadMutationOptions = ApolloReactCommon.BaseMutationOptions<IPrepaidsReloadMutation, IPrepaidsReloadMutationVariables>;
export const AddPrepaidCardDocument = gql`
    mutation AddPrepaidCard($input: AddGiftAccountInput!) @authRequired {
  addGiftAccount(input: $input) {
    fdAccountId
    prepaid {
      currentBalance
    }
  }
}
    `;
export type IAddPrepaidCardMutationFn = ApolloReactCommon.MutationFunction<IAddPrepaidCardMutation, IAddPrepaidCardMutationVariables>;

/**
 * __useAddPrepaidCardMutation__
 *
 * To run a mutation, you first call `useAddPrepaidCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPrepaidCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPrepaidCardMutation, { data, loading, error }] = useAddPrepaidCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPrepaidCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IAddPrepaidCardMutation, IAddPrepaidCardMutationVariables>) {
        return ApolloReactHooks.useMutation<IAddPrepaidCardMutation, IAddPrepaidCardMutationVariables>(AddPrepaidCardDocument, baseOptions);
      }
export type AddPrepaidCardMutationHookResult = ReturnType<typeof useAddPrepaidCardMutation>;
export type AddPrepaidCardMutationResult = ApolloReactCommon.MutationResult<IAddPrepaidCardMutation>;
export type AddPrepaidCardMutationOptions = ApolloReactCommon.BaseMutationOptions<IAddPrepaidCardMutation, IAddPrepaidCardMutationVariables>;
export const PrepaidTransactionCurrencyCodesDocument = gql`
    query prepaidTransactionCurrencyCodes($cardNumber: String!) @authRequired {
  prepaidsTransactions(cardNumber: $cardNumber) {
    transactions {
      currencyCode {
        number
      }
    }
  }
}
    `;

/**
 * __usePrepaidTransactionCurrencyCodesQuery__
 *
 * To run a query within a React component, call `usePrepaidTransactionCurrencyCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepaidTransactionCurrencyCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrepaidTransactionCurrencyCodesQuery({
 *   variables: {
 *      cardNumber: // value for 'cardNumber'
 *   },
 * });
 */
export function usePrepaidTransactionCurrencyCodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IPrepaidTransactionCurrencyCodesQuery, IPrepaidTransactionCurrencyCodesQueryVariables>) {
        return ApolloReactHooks.useQuery<IPrepaidTransactionCurrencyCodesQuery, IPrepaidTransactionCurrencyCodesQueryVariables>(PrepaidTransactionCurrencyCodesDocument, baseOptions);
      }
export function usePrepaidTransactionCurrencyCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IPrepaidTransactionCurrencyCodesQuery, IPrepaidTransactionCurrencyCodesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IPrepaidTransactionCurrencyCodesQuery, IPrepaidTransactionCurrencyCodesQueryVariables>(PrepaidTransactionCurrencyCodesDocument, baseOptions);
        }
export type PrepaidTransactionCurrencyCodesQueryHookResult = ReturnType<typeof usePrepaidTransactionCurrencyCodesQuery>;
export type PrepaidTransactionCurrencyCodesLazyQueryHookResult = ReturnType<typeof usePrepaidTransactionCurrencyCodesLazyQuery>;
export type PrepaidTransactionCurrencyCodesQueryResult = ApolloReactCommon.QueryResult<IPrepaidTransactionCurrencyCodesQuery, IPrepaidTransactionCurrencyCodesQueryVariables>;
export const RequestMyInfoDocument = gql`
    mutation RequestMyInfo @authRequired {
  requestMyInfo
}
    `;
export type IRequestMyInfoMutationFn = ApolloReactCommon.MutationFunction<IRequestMyInfoMutation, IRequestMyInfoMutationVariables>;

/**
 * __useRequestMyInfoMutation__
 *
 * To run a mutation, you first call `useRequestMyInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMyInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMyInfoMutation, { data, loading, error }] = useRequestMyInfoMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestMyInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IRequestMyInfoMutation, IRequestMyInfoMutationVariables>) {
        return ApolloReactHooks.useMutation<IRequestMyInfoMutation, IRequestMyInfoMutationVariables>(RequestMyInfoDocument, baseOptions);
      }
export type RequestMyInfoMutationHookResult = ReturnType<typeof useRequestMyInfoMutation>;
export type RequestMyInfoMutationResult = ApolloReactCommon.MutationResult<IRequestMyInfoMutation>;
export type RequestMyInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<IRequestMyInfoMutation, IRequestMyInfoMutationVariables>;
export const GetRestaurantsDocument = gql`
    query GetRestaurants($input: RestaurantsInput) {
  restaurants(input: $input) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    nodes {
      ...RestaurantNodeFragment
    }
  }
}
    ${RestaurantNodeFragmentFragmentDoc}`;

/**
 * __useGetRestaurantsQuery__
 *
 * To run a query within a React component, call `useGetRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRestaurantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, baseOptions);
      }
export function useGetRestaurantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, baseOptions);
        }
export type GetRestaurantsQueryHookResult = ReturnType<typeof useGetRestaurantsQuery>;
export type GetRestaurantsLazyQueryHookResult = ReturnType<typeof useGetRestaurantsLazyQuery>;
export type GetRestaurantsQueryResult = ApolloReactCommon.QueryResult<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>;
export const DeliveryRestaurantDocument = gql`
    query DeliveryRestaurant($dropoff: DeliveryWaypointInput!, $searchRadius: Float!) {
  deliveryRestaurant(dropoff: $dropoff, searchRadius: $searchRadius) {
    storeStatus
    quote
    nextEarliestOpen
    restaurant {
      ...RestaurantNodeFragment
    }
  }
}
    ${RestaurantNodeFragmentFragmentDoc}`;

/**
 * __useDeliveryRestaurantQuery__
 *
 * To run a query within a React component, call `useDeliveryRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryRestaurantQuery({
 *   variables: {
 *      dropoff: // value for 'dropoff'
 *      searchRadius: // value for 'searchRadius'
 *   },
 * });
 */
export function useDeliveryRestaurantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>) {
        return ApolloReactHooks.useQuery<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>(DeliveryRestaurantDocument, baseOptions);
      }
export function useDeliveryRestaurantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>(DeliveryRestaurantDocument, baseOptions);
        }
export type DeliveryRestaurantQueryHookResult = ReturnType<typeof useDeliveryRestaurantQuery>;
export type DeliveryRestaurantLazyQueryHookResult = ReturnType<typeof useDeliveryRestaurantLazyQuery>;
export type DeliveryRestaurantQueryResult = ApolloReactCommon.QueryResult<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>;
export const RevealLoyaltyRollUpTheRimTimelineEventRollDocument = gql`
    mutation RevealLoyaltyRollUpTheRimTimelineEventRoll($referenceId: String!, $developmentPrize: String) @authRequired {
  revealLoyaltyRollUpTheRimTimelineEventRoll(referenceId: $referenceId, developmentPrize: $developmentPrize) {
    id
    type
    code
  }
}
    `;
export type IRevealLoyaltyRollUpTheRimTimelineEventRollMutationFn = ApolloReactCommon.MutationFunction<IRevealLoyaltyRollUpTheRimTimelineEventRollMutation, IRevealLoyaltyRollUpTheRimTimelineEventRollMutationVariables>;

/**
 * __useRevealLoyaltyRollUpTheRimTimelineEventRollMutation__
 *
 * To run a mutation, you first call `useRevealLoyaltyRollUpTheRimTimelineEventRollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevealLoyaltyRollUpTheRimTimelineEventRollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revealLoyaltyRollUpTheRimTimelineEventRollMutation, { data, loading, error }] = useRevealLoyaltyRollUpTheRimTimelineEventRollMutation({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      developmentPrize: // value for 'developmentPrize'
 *   },
 * });
 */
export function useRevealLoyaltyRollUpTheRimTimelineEventRollMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IRevealLoyaltyRollUpTheRimTimelineEventRollMutation, IRevealLoyaltyRollUpTheRimTimelineEventRollMutationVariables>) {
        return ApolloReactHooks.useMutation<IRevealLoyaltyRollUpTheRimTimelineEventRollMutation, IRevealLoyaltyRollUpTheRimTimelineEventRollMutationVariables>(RevealLoyaltyRollUpTheRimTimelineEventRollDocument, baseOptions);
      }
export type RevealLoyaltyRollUpTheRimTimelineEventRollMutationHookResult = ReturnType<typeof useRevealLoyaltyRollUpTheRimTimelineEventRollMutation>;
export type RevealLoyaltyRollUpTheRimTimelineEventRollMutationResult = ApolloReactCommon.MutationResult<IRevealLoyaltyRollUpTheRimTimelineEventRollMutation>;
export type RevealLoyaltyRollUpTheRimTimelineEventRollMutationOptions = ApolloReactCommon.BaseMutationOptions<IRevealLoyaltyRollUpTheRimTimelineEventRollMutation, IRevealLoyaltyRollUpTheRimTimelineEventRollMutationVariables>;
export const GetLoyaltyRollUpTheRimPrizesStatsDocument = gql`
    query GetLoyaltyRollUpTheRimPrizesStats($eventId: String) {
  getLoyaltyRollUpTheRimPrizesStats(eventId: $eventId) {
    total
    awarded
    details {
      total
      awarded
      prizeId
    }
  }
}
    `;

/**
 * __useGetLoyaltyRollUpTheRimPrizesStatsQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyRollUpTheRimPrizesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyRollUpTheRimPrizesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyRollUpTheRimPrizesStatsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetLoyaltyRollUpTheRimPrizesStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyRollUpTheRimPrizesStatsQuery, IGetLoyaltyRollUpTheRimPrizesStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyRollUpTheRimPrizesStatsQuery, IGetLoyaltyRollUpTheRimPrizesStatsQueryVariables>(GetLoyaltyRollUpTheRimPrizesStatsDocument, baseOptions);
      }
export function useGetLoyaltyRollUpTheRimPrizesStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyRollUpTheRimPrizesStatsQuery, IGetLoyaltyRollUpTheRimPrizesStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyRollUpTheRimPrizesStatsQuery, IGetLoyaltyRollUpTheRimPrizesStatsQueryVariables>(GetLoyaltyRollUpTheRimPrizesStatsDocument, baseOptions);
        }
export type GetLoyaltyRollUpTheRimPrizesStatsQueryHookResult = ReturnType<typeof useGetLoyaltyRollUpTheRimPrizesStatsQuery>;
export type GetLoyaltyRollUpTheRimPrizesStatsLazyQueryHookResult = ReturnType<typeof useGetLoyaltyRollUpTheRimPrizesStatsLazyQuery>;
export type GetLoyaltyRollUpTheRimPrizesStatsQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyRollUpTheRimPrizesStatsQuery, IGetLoyaltyRollUpTheRimPrizesStatsQueryVariables>;
export const GetLoyaltyRollUpTheRimTimelineEventSummaryDocument = gql`
    query GetLoyaltyRollUpTheRimTimelineEventSummary($eventId: String) @authRequired {
  getLoyaltyRollUpTheRimTimelineEventSummary(eventId: $eventId) {
    count
    events {
      count
      eventId
    }
    resumeAfter
  }
}
    `;

/**
 * __useGetLoyaltyRollUpTheRimTimelineEventSummaryQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyRollUpTheRimTimelineEventSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyRollUpTheRimTimelineEventSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyRollUpTheRimTimelineEventSummaryQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetLoyaltyRollUpTheRimTimelineEventSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery, IGetLoyaltyRollUpTheRimTimelineEventSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery, IGetLoyaltyRollUpTheRimTimelineEventSummaryQueryVariables>(GetLoyaltyRollUpTheRimTimelineEventSummaryDocument, baseOptions);
      }
export function useGetLoyaltyRollUpTheRimTimelineEventSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery, IGetLoyaltyRollUpTheRimTimelineEventSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery, IGetLoyaltyRollUpTheRimTimelineEventSummaryQueryVariables>(GetLoyaltyRollUpTheRimTimelineEventSummaryDocument, baseOptions);
        }
export type GetLoyaltyRollUpTheRimTimelineEventSummaryQueryHookResult = ReturnType<typeof useGetLoyaltyRollUpTheRimTimelineEventSummaryQuery>;
export type GetLoyaltyRollUpTheRimTimelineEventSummaryLazyQueryHookResult = ReturnType<typeof useGetLoyaltyRollUpTheRimTimelineEventSummaryLazyQuery>;
export type GetLoyaltyRollUpTheRimTimelineEventSummaryQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery, IGetLoyaltyRollUpTheRimTimelineEventSummaryQueryVariables>;
export const GetLoyaltyRollUpTheRimTimelineEventSharedRollTokensDocument = gql`
    query GetLoyaltyRollUpTheRimTimelineEventSharedRollTokens @authRequired {
  getLoyaltyRollUpTheRimTimelineEventSharedRollTokens {
    count
    tokens {
      count
      token
    }
  }
}
    `;

/**
 * __useGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery, IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery, IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQueryVariables>(GetLoyaltyRollUpTheRimTimelineEventSharedRollTokensDocument, baseOptions);
      }
export function useGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery, IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery, IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQueryVariables>(GetLoyaltyRollUpTheRimTimelineEventSharedRollTokensDocument, baseOptions);
        }
export type GetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQueryHookResult = ReturnType<typeof useGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery>;
export type GetLoyaltyRollUpTheRimTimelineEventSharedRollTokensLazyQueryHookResult = ReturnType<typeof useGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensLazyQuery>;
export type GetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQuery, IGetLoyaltyRollUpTheRimTimelineEventSharedRollTokensQueryVariables>;
export const AcceptLoyaltyRollUpTheRimTimelineEventSharedRollsDocument = gql`
    mutation AcceptLoyaltyRollUpTheRimTimelineEventSharedRolls($sharedRollsToken: String!) @authRequired {
  acceptLoyaltyRollUpTheRimTimelineEventSharedRolls(token: $sharedRollsToken) {
    count
    rolls {
      barcode
      createdAt
      eventId
      referenceId
    }
  }
}
    `;
export type IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationFn = ApolloReactCommon.MutationFunction<IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation, IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationVariables>;

/**
 * __useAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation__
 *
 * To run a mutation, you first call `useAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation, { data, loading, error }] = useAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation({
 *   variables: {
 *      sharedRollsToken: // value for 'sharedRollsToken'
 *   },
 * });
 */
export function useAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation, IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationVariables>) {
        return ApolloReactHooks.useMutation<IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation, IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationVariables>(AcceptLoyaltyRollUpTheRimTimelineEventSharedRollsDocument, baseOptions);
      }
export type AcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationHookResult = ReturnType<typeof useAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation>;
export type AcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationResult = ApolloReactCommon.MutationResult<IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation>;
export type AcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationOptions = ApolloReactCommon.BaseMutationOptions<IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutation, IAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsMutationVariables>;
export const ClaimLoyaltyRollUpTheRimPrizeDocument = gql`
    mutation ClaimLoyaltyRollUpTheRimPrize($email: String!, $giftCardValueCents: Int, $isMajorPrize: Boolean!, $isTimHortonsGiftCard: Boolean!, $language: String!, $name: String!, $referenceId: String!) @authRequired {
  claimLoyaltyRollUpTheRimPrize(email: $email, giftCardValueCents: $giftCardValueCents, isMajorPrize: $isMajorPrize, isTimHortonsGiftCard: $isTimHortonsGiftCard, language: $language, name: $name, referenceId: $referenceId)
}
    `;
export type IClaimLoyaltyRollUpTheRimPrizeMutationFn = ApolloReactCommon.MutationFunction<IClaimLoyaltyRollUpTheRimPrizeMutation, IClaimLoyaltyRollUpTheRimPrizeMutationVariables>;

/**
 * __useClaimLoyaltyRollUpTheRimPrizeMutation__
 *
 * To run a mutation, you first call `useClaimLoyaltyRollUpTheRimPrizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimLoyaltyRollUpTheRimPrizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimLoyaltyRollUpTheRimPrizeMutation, { data, loading, error }] = useClaimLoyaltyRollUpTheRimPrizeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      giftCardValueCents: // value for 'giftCardValueCents'
 *      isMajorPrize: // value for 'isMajorPrize'
 *      isTimHortonsGiftCard: // value for 'isTimHortonsGiftCard'
 *      language: // value for 'language'
 *      name: // value for 'name'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useClaimLoyaltyRollUpTheRimPrizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IClaimLoyaltyRollUpTheRimPrizeMutation, IClaimLoyaltyRollUpTheRimPrizeMutationVariables>) {
        return ApolloReactHooks.useMutation<IClaimLoyaltyRollUpTheRimPrizeMutation, IClaimLoyaltyRollUpTheRimPrizeMutationVariables>(ClaimLoyaltyRollUpTheRimPrizeDocument, baseOptions);
      }
export type ClaimLoyaltyRollUpTheRimPrizeMutationHookResult = ReturnType<typeof useClaimLoyaltyRollUpTheRimPrizeMutation>;
export type ClaimLoyaltyRollUpTheRimPrizeMutationResult = ApolloReactCommon.MutationResult<IClaimLoyaltyRollUpTheRimPrizeMutation>;
export type ClaimLoyaltyRollUpTheRimPrizeMutationOptions = ApolloReactCommon.BaseMutationOptions<IClaimLoyaltyRollUpTheRimPrizeMutation, IClaimLoyaltyRollUpTheRimPrizeMutationVariables>;
export const ShareLoyaltyRollUpTheRimTimelineEventRollsDocument = gql`
    mutation ShareLoyaltyRollUpTheRimTimelineEventRolls($quantity: Int!) @authRequired {
  shareLoyaltyRollUpTheRimTimelineEventRolls(quantity: $quantity) {
    token
  }
}
    `;
export type IShareLoyaltyRollUpTheRimTimelineEventRollsMutationFn = ApolloReactCommon.MutationFunction<IShareLoyaltyRollUpTheRimTimelineEventRollsMutation, IShareLoyaltyRollUpTheRimTimelineEventRollsMutationVariables>;

/**
 * __useShareLoyaltyRollUpTheRimTimelineEventRollsMutation__
 *
 * To run a mutation, you first call `useShareLoyaltyRollUpTheRimTimelineEventRollsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareLoyaltyRollUpTheRimTimelineEventRollsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareLoyaltyRollUpTheRimTimelineEventRollsMutation, { data, loading, error }] = useShareLoyaltyRollUpTheRimTimelineEventRollsMutation({
 *   variables: {
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useShareLoyaltyRollUpTheRimTimelineEventRollsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IShareLoyaltyRollUpTheRimTimelineEventRollsMutation, IShareLoyaltyRollUpTheRimTimelineEventRollsMutationVariables>) {
        return ApolloReactHooks.useMutation<IShareLoyaltyRollUpTheRimTimelineEventRollsMutation, IShareLoyaltyRollUpTheRimTimelineEventRollsMutationVariables>(ShareLoyaltyRollUpTheRimTimelineEventRollsDocument, baseOptions);
      }
export type ShareLoyaltyRollUpTheRimTimelineEventRollsMutationHookResult = ReturnType<typeof useShareLoyaltyRollUpTheRimTimelineEventRollsMutation>;
export type ShareLoyaltyRollUpTheRimTimelineEventRollsMutationResult = ApolloReactCommon.MutationResult<IShareLoyaltyRollUpTheRimTimelineEventRollsMutation>;
export type ShareLoyaltyRollUpTheRimTimelineEventRollsMutationOptions = ApolloReactCommon.BaseMutationOptions<IShareLoyaltyRollUpTheRimTimelineEventRollsMutation, IShareLoyaltyRollUpTheRimTimelineEventRollsMutationVariables>;
export const ReportMissingOrderDocument = gql`
    mutation ReportMissingOrder($input: UserReportsMissingOrderInput!) @authRequired {
  userReportsMissingOrder(input: $input) {
    refund {
      approvedAmount
      transactionDateTime
    }
    ticket
  }
}
    `;
export type IReportMissingOrderMutationFn = ApolloReactCommon.MutationFunction<IReportMissingOrderMutation, IReportMissingOrderMutationVariables>;

/**
 * __useReportMissingOrderMutation__
 *
 * To run a mutation, you first call `useReportMissingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportMissingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportMissingOrderMutation, { data, loading, error }] = useReportMissingOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportMissingOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IReportMissingOrderMutation, IReportMissingOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<IReportMissingOrderMutation, IReportMissingOrderMutationVariables>(ReportMissingOrderDocument, baseOptions);
      }
export type ReportMissingOrderMutationHookResult = ReturnType<typeof useReportMissingOrderMutation>;
export type ReportMissingOrderMutationResult = ApolloReactCommon.MutationResult<IReportMissingOrderMutation>;
export type ReportMissingOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<IReportMissingOrderMutation, IReportMissingOrderMutationVariables>;
export const GetUniqueStoresDocument = gql`
    query GetUniqueStores($orderStatuses: [RbiOrderStatus!]) @authRequired {
  uniqueStores(orderStatuses: $orderStatuses) {
    orders {
      cart {
        storeId
      }
    }
  }
}
    `;

/**
 * __useGetUniqueStoresQuery__
 *
 * To run a query within a React component, call `useGetUniqueStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueStoresQuery({
 *   variables: {
 *      orderStatuses: // value for 'orderStatuses'
 *   },
 * });
 */
export function useGetUniqueStoresQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUniqueStoresQuery, IGetUniqueStoresQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUniqueStoresQuery, IGetUniqueStoresQueryVariables>(GetUniqueStoresDocument, baseOptions);
      }
export function useGetUniqueStoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUniqueStoresQuery, IGetUniqueStoresQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUniqueStoresQuery, IGetUniqueStoresQueryVariables>(GetUniqueStoresDocument, baseOptions);
        }
export type GetUniqueStoresQueryHookResult = ReturnType<typeof useGetUniqueStoresQuery>;
export type GetUniqueStoresLazyQueryHookResult = ReturnType<typeof useGetUniqueStoresLazyQuery>;
export type GetUniqueStoresQueryResult = ApolloReactCommon.QueryResult<IGetUniqueStoresQuery, IGetUniqueStoresQueryVariables>;
export const UpsertKiosksDocument = gql`
    mutation upsertKiosks($storeKiosks: StoreInput!) @authRequired {
  updateStore(input: $storeKiosks) {
    storeId
    kiosks {
      serialNumber
    }
  }
}
    `;
export type IUpsertKiosksMutationFn = ApolloReactCommon.MutationFunction<IUpsertKiosksMutation, IUpsertKiosksMutationVariables>;

/**
 * __useUpsertKiosksMutation__
 *
 * To run a mutation, you first call `useUpsertKiosksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertKiosksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertKiosksMutation, { data, loading, error }] = useUpsertKiosksMutation({
 *   variables: {
 *      storeKiosks: // value for 'storeKiosks'
 *   },
 * });
 */
export function useUpsertKiosksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpsertKiosksMutation, IUpsertKiosksMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpsertKiosksMutation, IUpsertKiosksMutationVariables>(UpsertKiosksDocument, baseOptions);
      }
export type UpsertKiosksMutationHookResult = ReturnType<typeof useUpsertKiosksMutation>;
export type UpsertKiosksMutationResult = ApolloReactCommon.MutationResult<IUpsertKiosksMutation>;
export type UpsertKiosksMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpsertKiosksMutation, IUpsertKiosksMutationVariables>;
export const GetUserOrdersDocument = gql`
    query GetUserOrders($userId: ID, $limit: Int, $resumeAfter: String, $orderStatuses: [RbiOrderStatus!], $createdAfter: String, $shouldFilterByRegion: Boolean) @authRequired {
  userOrders(userId: $userId, limit: $limit, resumeAfter: $resumeAfter, orderStatuses: $orderStatuses, createdAfter: $createdAfter, shouldFilterByRegion: $shouldFilterByRegion) {
    count
    resumeAfter
    orders {
      ...UserOrderFragment
    }
  }
}
    ${UserOrderFragmentFragmentDoc}`;

/**
 * __useGetUserOrdersQuery__
 *
 * To run a query within a React component, call `useGetUserOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      resumeAfter: // value for 'resumeAfter'
 *      orderStatuses: // value for 'orderStatuses'
 *      createdAfter: // value for 'createdAfter'
 *      shouldFilterByRegion: // value for 'shouldFilterByRegion'
 *   },
 * });
 */
export function useGetUserOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>(GetUserOrdersDocument, baseOptions);
      }
export function useGetUserOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>(GetUserOrdersDocument, baseOptions);
        }
export type GetUserOrdersQueryHookResult = ReturnType<typeof useGetUserOrdersQuery>;
export type GetUserOrdersLazyQueryHookResult = ReturnType<typeof useGetUserOrdersLazyQuery>;
export type GetUserOrdersQueryResult = ApolloReactCommon.QueryResult<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>;
export const GetUserOrderDocument = gql`
    query GetUserOrder($id: ID!) @authRequired {
  order(rbiOrderId: $id) {
    ...UserOrderFragment
  }
}
    ${UserOrderFragmentFragmentDoc}`;

/**
 * __useGetUserOrderQuery__
 *
 * To run a query within a React component, call `useGetUserOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserOrderQuery, IGetUserOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserOrderQuery, IGetUserOrderQueryVariables>(GetUserOrderDocument, baseOptions);
      }
export function useGetUserOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserOrderQuery, IGetUserOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserOrderQuery, IGetUserOrderQueryVariables>(GetUserOrderDocument, baseOptions);
        }
export type GetUserOrderQueryHookResult = ReturnType<typeof useGetUserOrderQuery>;
export type GetUserOrderLazyQueryHookResult = ReturnType<typeof useGetUserOrderLazyQuery>;
export type GetUserOrderQueryResult = ApolloReactCommon.QueryResult<IGetUserOrderQuery, IGetUserOrderQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($input: UpdateUserDetailsInput!) @authRequired {
  updateMe(details: $input) {
    details {
      ...UserDetailsFragment
    }
  }
}
    ${UserDetailsFragmentFragmentDoc}`;
export type IUpdateMeMutationFn = ApolloReactCommon.MutationFunction<IUpdateMeMutation, IUpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateMeMutation, IUpdateMeMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateMeMutation, IUpdateMeMutationVariables>(UpdateMeDocument, baseOptions);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = ApolloReactCommon.MutationResult<IUpdateMeMutation>;
export type UpdateMeMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateMeMutation, IUpdateMeMutationVariables>;
export const SignInJwtDocument = gql`
    mutation SignInJWT($input: SignInUserInput!) {
  signInJWT(userInfo: $input)
}
    `;
export type ISignInJwtMutationFn = ApolloReactCommon.MutationFunction<ISignInJwtMutation, ISignInJwtMutationVariables>;

/**
 * __useSignInJwtMutation__
 *
 * To run a mutation, you first call `useSignInJwtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInJwtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInJwtMutation, { data, loading, error }] = useSignInJwtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInJwtMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISignInJwtMutation, ISignInJwtMutationVariables>) {
        return ApolloReactHooks.useMutation<ISignInJwtMutation, ISignInJwtMutationVariables>(SignInJwtDocument, baseOptions);
      }
export type SignInJwtMutationHookResult = ReturnType<typeof useSignInJwtMutation>;
export type SignInJwtMutationResult = ApolloReactCommon.MutationResult<ISignInJwtMutation>;
export type SignInJwtMutationOptions = ApolloReactCommon.BaseMutationOptions<ISignInJwtMutation, ISignInJwtMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpUserInput!) {
  signUp(userInfo: $input)
}
    `;
export type ISignUpMutationFn = ApolloReactCommon.MutationFunction<ISignUpMutation, ISignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISignUpMutation, ISignUpMutationVariables>) {
        return ApolloReactHooks.useMutation<ISignUpMutation, ISignUpMutationVariables>(SignUpDocument, baseOptions);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = ApolloReactCommon.MutationResult<ISignUpMutation>;
export type SignUpMutationOptions = ApolloReactCommon.BaseMutationOptions<ISignUpMutation, ISignUpMutationVariables>;
export const CreateLoyaltyUserDocument = gql`
    mutation CreateLoyaltyUser($cognitoId: String!) {
  createLoyaltyUser(cognitoId: $cognitoId) {
    loyaltyId
  }
}
    `;
export type ICreateLoyaltyUserMutationFn = ApolloReactCommon.MutationFunction<ICreateLoyaltyUserMutation, ICreateLoyaltyUserMutationVariables>;

/**
 * __useCreateLoyaltyUserMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyUserMutation, { data, loading, error }] = useCreateLoyaltyUserMutation({
 *   variables: {
 *      cognitoId: // value for 'cognitoId'
 *   },
 * });
 */
export function useCreateLoyaltyUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateLoyaltyUserMutation, ICreateLoyaltyUserMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateLoyaltyUserMutation, ICreateLoyaltyUserMutationVariables>(CreateLoyaltyUserDocument, baseOptions);
      }
export type CreateLoyaltyUserMutationHookResult = ReturnType<typeof useCreateLoyaltyUserMutation>;
export type CreateLoyaltyUserMutationResult = ApolloReactCommon.MutationResult<ICreateLoyaltyUserMutation>;
export type CreateLoyaltyUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateLoyaltyUserMutation, ICreateLoyaltyUserMutationVariables>;
export const ValidateAuthJwtDocument = gql`
    mutation ValidateAuthJwt($input: validateAuthJwtInput!) {
  validateAuthJwt(authInput: $input) {
    challengeCode
    sessionId
  }
}
    `;
export type IValidateAuthJwtMutationFn = ApolloReactCommon.MutationFunction<IValidateAuthJwtMutation, IValidateAuthJwtMutationVariables>;

/**
 * __useValidateAuthJwtMutation__
 *
 * To run a mutation, you first call `useValidateAuthJwtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAuthJwtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAuthJwtMutation, { data, loading, error }] = useValidateAuthJwtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateAuthJwtMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IValidateAuthJwtMutation, IValidateAuthJwtMutationVariables>) {
        return ApolloReactHooks.useMutation<IValidateAuthJwtMutation, IValidateAuthJwtMutationVariables>(ValidateAuthJwtDocument, baseOptions);
      }
export type ValidateAuthJwtMutationHookResult = ReturnType<typeof useValidateAuthJwtMutation>;
export type ValidateAuthJwtMutationResult = ApolloReactCommon.MutationResult<IValidateAuthJwtMutation>;
export type ValidateAuthJwtMutationOptions = ApolloReactCommon.BaseMutationOptions<IValidateAuthJwtMutation, IValidateAuthJwtMutationVariables>;
export const CreateOtpDocument = gql`
    mutation CreateOTP($input: CreateOTPInput!) {
  createOTP(input: $input) {
    maxValidateAttempts
    ttl
  }
}
    `;
export type ICreateOtpMutationFn = ApolloReactCommon.MutationFunction<ICreateOtpMutation, ICreateOtpMutationVariables>;

/**
 * __useCreateOtpMutation__
 *
 * To run a mutation, you first call `useCreateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOtpMutation, { data, loading, error }] = useCreateOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateOtpMutation, ICreateOtpMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateOtpMutation, ICreateOtpMutationVariables>(CreateOtpDocument, baseOptions);
      }
export type CreateOtpMutationHookResult = ReturnType<typeof useCreateOtpMutation>;
export type CreateOtpMutationResult = ApolloReactCommon.MutationResult<ICreateOtpMutation>;
export type CreateOtpMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateOtpMutation, ICreateOtpMutationVariables>;
export const ResendCurrentLoginOtpDocument = gql`
    mutation ResendCurrentLoginOTP($input: ResendOTPInput!) {
  resendCurrentLoginOTP(input: $input) {
    maxValidateAttempts
    ttl
  }
}
    `;
export type IResendCurrentLoginOtpMutationFn = ApolloReactCommon.MutationFunction<IResendCurrentLoginOtpMutation, IResendCurrentLoginOtpMutationVariables>;

/**
 * __useResendCurrentLoginOtpMutation__
 *
 * To run a mutation, you first call `useResendCurrentLoginOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCurrentLoginOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCurrentLoginOtpMutation, { data, loading, error }] = useResendCurrentLoginOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendCurrentLoginOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IResendCurrentLoginOtpMutation, IResendCurrentLoginOtpMutationVariables>) {
        return ApolloReactHooks.useMutation<IResendCurrentLoginOtpMutation, IResendCurrentLoginOtpMutationVariables>(ResendCurrentLoginOtpDocument, baseOptions);
      }
export type ResendCurrentLoginOtpMutationHookResult = ReturnType<typeof useResendCurrentLoginOtpMutation>;
export type ResendCurrentLoginOtpMutationResult = ApolloReactCommon.MutationResult<IResendCurrentLoginOtpMutation>;
export type ResendCurrentLoginOtpMutationOptions = ApolloReactCommon.BaseMutationOptions<IResendCurrentLoginOtpMutation, IResendCurrentLoginOtpMutationVariables>;
export const ValidateOtpDocument = gql`
    mutation ValidateOTP($input: ExchangeOTPCodeForCredentialsInput!) {
  exchangeOTPCodeForCognitoCredentials(input: $input) {
    challengeCode
    sessionId
  }
}
    `;
export type IValidateOtpMutationFn = ApolloReactCommon.MutationFunction<IValidateOtpMutation, IValidateOtpMutationVariables>;

/**
 * __useValidateOtpMutation__
 *
 * To run a mutation, you first call `useValidateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOtpMutation, { data, loading, error }] = useValidateOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IValidateOtpMutation, IValidateOtpMutationVariables>) {
        return ApolloReactHooks.useMutation<IValidateOtpMutation, IValidateOtpMutationVariables>(ValidateOtpDocument, baseOptions);
      }
export type ValidateOtpMutationHookResult = ReturnType<typeof useValidateOtpMutation>;
export type ValidateOtpMutationResult = ApolloReactCommon.MutationResult<IValidateOtpMutation>;
export type ValidateOtpMutationOptions = ApolloReactCommon.BaseMutationOptions<IValidateOtpMutation, IValidateOtpMutationVariables>;
export const SignUpCompleteDocument = gql`
    query SignUpComplete($jwt: String!) {
  signUpComplete(jwt: $jwt)
}
    `;

/**
 * __useSignUpCompleteQuery__
 *
 * To run a query within a React component, call `useSignUpCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpCompleteQuery({
 *   variables: {
 *      jwt: // value for 'jwt'
 *   },
 * });
 */
export function useSignUpCompleteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>) {
        return ApolloReactHooks.useQuery<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>(SignUpCompleteDocument, baseOptions);
      }
export function useSignUpCompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>(SignUpCompleteDocument, baseOptions);
        }
export type SignUpCompleteQueryHookResult = ReturnType<typeof useSignUpCompleteQuery>;
export type SignUpCompleteLazyQueryHookResult = ReturnType<typeof useSignUpCompleteLazyQuery>;
export type SignUpCompleteQueryResult = ApolloReactCommon.QueryResult<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation ResendVerificationEmail($input: resendVerificationEmailInput!) @authRequired {
  resendVerificationEmail(input: $input)
}
    `;
export type IResendVerificationEmailMutationFn = ApolloReactCommon.MutationFunction<IResendVerificationEmailMutation, IResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IResendVerificationEmailMutation, IResendVerificationEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<IResendVerificationEmailMutation, IResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, baseOptions);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = ApolloReactCommon.MutationResult<IResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<IResendVerificationEmailMutation, IResendVerificationEmailMutationVariables>;
export const CreateLoginForVendorDocument = gql`
    mutation CreateLoginForVendor($vendor: String!) @authRequired {
  createLoginForVendor(vendor: $vendor)
}
    `;
export type ICreateLoginForVendorMutationFn = ApolloReactCommon.MutationFunction<ICreateLoginForVendorMutation, ICreateLoginForVendorMutationVariables>;

/**
 * __useCreateLoginForVendorMutation__
 *
 * To run a mutation, you first call `useCreateLoginForVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoginForVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoginForVendorMutation, { data, loading, error }] = useCreateLoginForVendorMutation({
 *   variables: {
 *      vendor: // value for 'vendor'
 *   },
 * });
 */
export function useCreateLoginForVendorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateLoginForVendorMutation, ICreateLoginForVendorMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateLoginForVendorMutation, ICreateLoginForVendorMutationVariables>(CreateLoginForVendorDocument, baseOptions);
      }
export type CreateLoginForVendorMutationHookResult = ReturnType<typeof useCreateLoginForVendorMutation>;
export type CreateLoginForVendorMutationResult = ApolloReactCommon.MutationResult<ICreateLoginForVendorMutation>;
export type CreateLoginForVendorMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateLoginForVendorMutation, ICreateLoginForVendorMutationVariables>;
export const UserGeoDocument = gql`
    query UserGeo {
  userGeo {
    country
  }
}
    `;

/**
 * __useUserGeoQuery__
 *
 * To run a query within a React component, call `useUserGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGeoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGeoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IUserGeoQuery, IUserGeoQueryVariables>) {
        return ApolloReactHooks.useQuery<IUserGeoQuery, IUserGeoQueryVariables>(UserGeoDocument, baseOptions);
      }
export function useUserGeoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IUserGeoQuery, IUserGeoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IUserGeoQuery, IUserGeoQueryVariables>(UserGeoDocument, baseOptions);
        }
export type UserGeoQueryHookResult = ReturnType<typeof useUserGeoQuery>;
export type UserGeoLazyQueryHookResult = ReturnType<typeof useUserGeoLazyQuery>;
export type UserGeoQueryResult = ApolloReactCommon.QueryResult<IUserGeoQuery, IUserGeoQueryVariables>;
export const GetLoyaltyApplePassDocument = gql`
    query GetLoyaltyApplePass($cardId: String!) @authRequired {
  getLoyaltyCardApplePass(cardId: $cardId) {
    encodedPass
  }
}
    `;

/**
 * __useGetLoyaltyApplePassQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyApplePassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyApplePassQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyApplePassQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetLoyaltyApplePassQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetLoyaltyApplePassQuery, IGetLoyaltyApplePassQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetLoyaltyApplePassQuery, IGetLoyaltyApplePassQueryVariables>(GetLoyaltyApplePassDocument, baseOptions);
      }
export function useGetLoyaltyApplePassLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetLoyaltyApplePassQuery, IGetLoyaltyApplePassQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetLoyaltyApplePassQuery, IGetLoyaltyApplePassQueryVariables>(GetLoyaltyApplePassDocument, baseOptions);
        }
export type GetLoyaltyApplePassQueryHookResult = ReturnType<typeof useGetLoyaltyApplePassQuery>;
export type GetLoyaltyApplePassLazyQueryHookResult = ReturnType<typeof useGetLoyaltyApplePassLazyQuery>;
export type GetLoyaltyApplePassQueryResult = ApolloReactCommon.QueryResult<IGetLoyaltyApplePassQuery, IGetLoyaltyApplePassQueryVariables>;
export const CreateWllSessionDocument = gql`
    mutation CreateWllSession @authRequired {
  createWllSession {
    session
    wllUrl
    webUrl
  }
}
    `;
export type ICreateWllSessionMutationFn = ApolloReactCommon.MutationFunction<ICreateWllSessionMutation, ICreateWllSessionMutationVariables>;

/**
 * __useCreateWllSessionMutation__
 *
 * To run a mutation, you first call `useCreateWllSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWllSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWllSessionMutation, { data, loading, error }] = useCreateWllSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateWllSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateWllSessionMutation, ICreateWllSessionMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateWllSessionMutation, ICreateWllSessionMutationVariables>(CreateWllSessionDocument, baseOptions);
      }
export type CreateWllSessionMutationHookResult = ReturnType<typeof useCreateWllSessionMutation>;
export type CreateWllSessionMutationResult = ApolloReactCommon.MutationResult<ICreateWllSessionMutation>;
export type CreateWllSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateWllSessionMutation, ICreateWllSessionMutationVariables>;
export const PrepaidsMergeDocument = gql`
    mutation PrepaidsMerge($input: PrepaidsMergeInput!) {
  prepaidsMerge(input: $input) {
    currentBalance
    fdAccountId
  }
}
    `;
export type IPrepaidsMergeMutationFn = ApolloReactCommon.MutationFunction<IPrepaidsMergeMutation, IPrepaidsMergeMutationVariables>;

/**
 * __usePrepaidsMergeMutation__
 *
 * To run a mutation, you first call `usePrepaidsMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepaidsMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepaidsMergeMutation, { data, loading, error }] = usePrepaidsMergeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepaidsMergeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPrepaidsMergeMutation, IPrepaidsMergeMutationVariables>) {
        return ApolloReactHooks.useMutation<IPrepaidsMergeMutation, IPrepaidsMergeMutationVariables>(PrepaidsMergeDocument, baseOptions);
      }
export type PrepaidsMergeMutationHookResult = ReturnType<typeof usePrepaidsMergeMutation>;
export type PrepaidsMergeMutationResult = ApolloReactCommon.MutationResult<IPrepaidsMergeMutation>;
export type PrepaidsMergeMutationOptions = ApolloReactCommon.BaseMutationOptions<IPrepaidsMergeMutation, IPrepaidsMergeMutationVariables>;
export const ListCouponsDocument = gql`
    query listCoupons($expiresAfter: String, $expiresBefore: String, $includeRedeemed: Boolean, $limit: Int, $resumeAfter: String, $sortAscending: Boolean) {
  listCoupons(expiresAfter: $expiresAfter, expiresBefore: $expiresBefore, includeRedeemed: $includeRedeemed, limit: $limit, resumeAfter: $resumeAfter, sortAscending: $sortAscending) {
    count
    coupons {
      couponId
      createdAt
      expiresOn
      redeemedOn
      updatedAt
      userId
    }
    resumeAfter
  }
}
    `;

/**
 * __useListCouponsQuery__
 *
 * To run a query within a React component, call `useListCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCouponsQuery({
 *   variables: {
 *      expiresAfter: // value for 'expiresAfter'
 *      expiresBefore: // value for 'expiresBefore'
 *      includeRedeemed: // value for 'includeRedeemed'
 *      limit: // value for 'limit'
 *      resumeAfter: // value for 'resumeAfter'
 *      sortAscending: // value for 'sortAscending'
 *   },
 * });
 */
export function useListCouponsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IListCouponsQuery, IListCouponsQueryVariables>) {
        return ApolloReactHooks.useQuery<IListCouponsQuery, IListCouponsQueryVariables>(ListCouponsDocument, baseOptions);
      }
export function useListCouponsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IListCouponsQuery, IListCouponsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IListCouponsQuery, IListCouponsQueryVariables>(ListCouponsDocument, baseOptions);
        }
export type ListCouponsQueryHookResult = ReturnType<typeof useListCouponsQuery>;
export type ListCouponsLazyQueryHookResult = ReturnType<typeof useListCouponsLazyQuery>;
export type ListCouponsQueryResult = ApolloReactCommon.QueryResult<IListCouponsQuery, IListCouponsQueryVariables>;
export const IsOfferRedeemableDocument = gql`
    query isOfferRedeemable($couponId: ID!, $cart: PriceOrderInput, $rbiOrderId: ID, $redeemedOn: String!, $ruleSet: String) {
  isCouponRedeemable(cart: $cart, couponId: $couponId, rbiOrderId: $rbiOrderId, redeemedOn: $redeemedOn, ruleSet: $ruleSet) {
    isRedeemable
    evaluationFeedback {
      code
      condition
      message
      ruleSetType
    }
  }
}
    `;

/**
 * __useIsOfferRedeemableQuery__
 *
 * To run a query within a React component, call `useIsOfferRedeemableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOfferRedeemableQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOfferRedeemableQuery({
 *   variables: {
 *      couponId: // value for 'couponId'
 *      cart: // value for 'cart'
 *      rbiOrderId: // value for 'rbiOrderId'
 *      redeemedOn: // value for 'redeemedOn'
 *      ruleSet: // value for 'ruleSet'
 *   },
 * });
 */
export function useIsOfferRedeemableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IIsOfferRedeemableQuery, IIsOfferRedeemableQueryVariables>) {
        return ApolloReactHooks.useQuery<IIsOfferRedeemableQuery, IIsOfferRedeemableQueryVariables>(IsOfferRedeemableDocument, baseOptions);
      }
export function useIsOfferRedeemableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IIsOfferRedeemableQuery, IIsOfferRedeemableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IIsOfferRedeemableQuery, IIsOfferRedeemableQueryVariables>(IsOfferRedeemableDocument, baseOptions);
        }
export type IsOfferRedeemableQueryHookResult = ReturnType<typeof useIsOfferRedeemableQuery>;
export type IsOfferRedeemableLazyQueryHookResult = ReturnType<typeof useIsOfferRedeemableLazyQuery>;
export type IsOfferRedeemableQueryResult = ApolloReactCommon.QueryResult<IIsOfferRedeemableQuery, IIsOfferRedeemableQueryVariables>;
export const ActivateLoyaltyOfferDocument = gql`
    mutation activateLoyaltyOffer($tokenId: String!) @authRequired {
  activateLoyaltyOffer(tokenId: $tokenId)
}
    `;
export type IActivateLoyaltyOfferMutationFn = ApolloReactCommon.MutationFunction<IActivateLoyaltyOfferMutation, IActivateLoyaltyOfferMutationVariables>;

/**
 * __useActivateLoyaltyOfferMutation__
 *
 * To run a mutation, you first call `useActivateLoyaltyOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateLoyaltyOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateLoyaltyOfferMutation, { data, loading, error }] = useActivateLoyaltyOfferMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useActivateLoyaltyOfferMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IActivateLoyaltyOfferMutation, IActivateLoyaltyOfferMutationVariables>) {
        return ApolloReactHooks.useMutation<IActivateLoyaltyOfferMutation, IActivateLoyaltyOfferMutationVariables>(ActivateLoyaltyOfferDocument, baseOptions);
      }
export type ActivateLoyaltyOfferMutationHookResult = ReturnType<typeof useActivateLoyaltyOfferMutation>;
export type ActivateLoyaltyOfferMutationResult = ApolloReactCommon.MutationResult<IActivateLoyaltyOfferMutation>;
export type ActivateLoyaltyOfferMutationOptions = ApolloReactCommon.BaseMutationOptions<IActivateLoyaltyOfferMutation, IActivateLoyaltyOfferMutationVariables>;
export const PriceOrderDocument = gql`
    mutation PriceOrder($input: PriceOrderInput!, $delivery: PriceDeliveryInput) @authRequired {
  priceOrder(input: $input, delivery: $delivery) {
    rbiOrderId
    status
  }
}
    `;
export type IPriceOrderMutationFn = ApolloReactCommon.MutationFunction<IPriceOrderMutation, IPriceOrderMutationVariables>;

/**
 * __usePriceOrderMutation__
 *
 * To run a mutation, you first call `usePriceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceOrderMutation, { data, loading, error }] = usePriceOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function usePriceOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPriceOrderMutation, IPriceOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<IPriceOrderMutation, IPriceOrderMutationVariables>(PriceOrderDocument, baseOptions);
      }
export type PriceOrderMutationHookResult = ReturnType<typeof usePriceOrderMutation>;
export type PriceOrderMutationResult = ApolloReactCommon.MutationResult<IPriceOrderMutation>;
export type PriceOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<IPriceOrderMutation, IPriceOrderMutationVariables>;
export const GetOrderDocument = gql`
    query GetOrder($rbiOrderId: ID!) @authRequired {
  order(rbiOrderId: $rbiOrderId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      rbiOrderId: // value for 'rbiOrderId'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetOrderQuery, IGetOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetOrderQuery, IGetOrderQueryVariables>(GetOrderDocument, baseOptions);
      }
export function useGetOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetOrderQuery, IGetOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetOrderQuery, IGetOrderQueryVariables>(GetOrderDocument, baseOptions);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = ApolloReactCommon.QueryResult<IGetOrderQuery, IGetOrderQueryVariables>;
export const GetStoreOrderDocument = gql`
    query GetStoreOrder($storeOrderJwt: String!) {
  cateringOrder(cateringJwt: $storeOrderJwt) {
    ...OrderFragment
    catering {
      pickupTime
      notes
      declineReason
    }
    cart {
      userDetails {
        phoneNumber
        email
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useGetStoreOrderQuery__
 *
 * To run a query within a React component, call `useGetStoreOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreOrderQuery({
 *   variables: {
 *      storeOrderJwt: // value for 'storeOrderJwt'
 *   },
 * });
 */
export function useGetStoreOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetStoreOrderQuery, IGetStoreOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetStoreOrderQuery, IGetStoreOrderQueryVariables>(GetStoreOrderDocument, baseOptions);
      }
export function useGetStoreOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetStoreOrderQuery, IGetStoreOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetStoreOrderQuery, IGetStoreOrderQueryVariables>(GetStoreOrderDocument, baseOptions);
        }
export type GetStoreOrderQueryHookResult = ReturnType<typeof useGetStoreOrderQuery>;
export type GetStoreOrderLazyQueryHookResult = ReturnType<typeof useGetStoreOrderLazyQuery>;
export type GetStoreOrderQueryResult = ApolloReactCommon.QueryResult<IGetStoreOrderQuery, IGetStoreOrderQueryVariables>;
export const ConfirmCateringOrderDocument = gql`
    mutation ConfirmCateringOrder($input: ConfirmCateringOrderInput!) {
  confirmCateringOrder(input: $input) {
    status
  }
}
    `;
export type IConfirmCateringOrderMutationFn = ApolloReactCommon.MutationFunction<IConfirmCateringOrderMutation, IConfirmCateringOrderMutationVariables>;

/**
 * __useConfirmCateringOrderMutation__
 *
 * To run a mutation, you first call `useConfirmCateringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCateringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCateringOrderMutation, { data, loading, error }] = useConfirmCateringOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmCateringOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IConfirmCateringOrderMutation, IConfirmCateringOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<IConfirmCateringOrderMutation, IConfirmCateringOrderMutationVariables>(ConfirmCateringOrderDocument, baseOptions);
      }
export type ConfirmCateringOrderMutationHookResult = ReturnType<typeof useConfirmCateringOrderMutation>;
export type ConfirmCateringOrderMutationResult = ApolloReactCommon.MutationResult<IConfirmCateringOrderMutation>;
export type ConfirmCateringOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<IConfirmCateringOrderMutation, IConfirmCateringOrderMutationVariables>;
export const CommitOrderDocument = gql`
    mutation CommitOrder($input: CommitOrderInput!, $delivery: CommitDeliveryInput, $skipCoolingPeriod: Boolean) @authRequired {
  commitOrder(input: $input, delivery: $delivery, skipCoolingPeriod: $skipCoolingPeriod) {
    rbiOrderId
    status
  }
}
    `;
export type ICommitOrderMutationFn = ApolloReactCommon.MutationFunction<ICommitOrderMutation, ICommitOrderMutationVariables>;

/**
 * __useCommitOrderMutation__
 *
 * To run a mutation, you first call `useCommitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitOrderMutation, { data, loading, error }] = useCommitOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delivery: // value for 'delivery'
 *      skipCoolingPeriod: // value for 'skipCoolingPeriod'
 *   },
 * });
 */
export function useCommitOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICommitOrderMutation, ICommitOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<ICommitOrderMutation, ICommitOrderMutationVariables>(CommitOrderDocument, baseOptions);
      }
export type CommitOrderMutationHookResult = ReturnType<typeof useCommitOrderMutation>;
export type CommitOrderMutationResult = ApolloReactCommon.MutationResult<ICommitOrderMutation>;
export type CommitOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ICommitOrderMutation, ICommitOrderMutationVariables>;
export const DeliveryOrderStatusDocument = gql`
    query DeliveryOrderStatus($rbiOrderId: ID!) {
  order(rbiOrderId: $rbiOrderId) {
    delivery {
      status
      shareUuid
      dropoff {
        arrivalTime
        beforeTime
      }
      driver {
        name
        phoneNumber
        profileImageUrl
      }
      task {
        uuid
      }
    }
  }
}
    `;

/**
 * __useDeliveryOrderStatusQuery__
 *
 * To run a query within a React component, call `useDeliveryOrderStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryOrderStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryOrderStatusQuery({
 *   variables: {
 *      rbiOrderId: // value for 'rbiOrderId'
 *   },
 * });
 */
export function useDeliveryOrderStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IDeliveryOrderStatusQuery, IDeliveryOrderStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<IDeliveryOrderStatusQuery, IDeliveryOrderStatusQueryVariables>(DeliveryOrderStatusDocument, baseOptions);
      }
export function useDeliveryOrderStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IDeliveryOrderStatusQuery, IDeliveryOrderStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IDeliveryOrderStatusQuery, IDeliveryOrderStatusQueryVariables>(DeliveryOrderStatusDocument, baseOptions);
        }
export type DeliveryOrderStatusQueryHookResult = ReturnType<typeof useDeliveryOrderStatusQuery>;
export type DeliveryOrderStatusLazyQueryHookResult = ReturnType<typeof useDeliveryOrderStatusLazyQuery>;
export type DeliveryOrderStatusQueryResult = ApolloReactCommon.QueryResult<IDeliveryOrderStatusQuery, IDeliveryOrderStatusQueryVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderInput!) @authRequired {
  updateOrder(input: $input) {
    rbiOrderId
    fireOrderIn
  }
}
    `;
export type IUpdateOrderMutationFn = ApolloReactCommon.MutationFunction<IUpdateOrderMutation, IUpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateOrderMutation, IUpdateOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateOrderMutation, IUpdateOrderMutationVariables>(UpdateOrderDocument, baseOptions);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = ApolloReactCommon.MutationResult<IUpdateOrderMutation>;
export type UpdateOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateOrderMutation, IUpdateOrderMutationVariables>;
export const PlaceCateringOrderDocument = gql`
    mutation PlaceCateringOrder($input: PlaceCateringOrderInput!) @authRequired {
  placeCateringOrder(input: $input) {
    rbiOrderId
    status
  }
}
    `;
export type IPlaceCateringOrderMutationFn = ApolloReactCommon.MutationFunction<IPlaceCateringOrderMutation, IPlaceCateringOrderMutationVariables>;

/**
 * __usePlaceCateringOrderMutation__
 *
 * To run a mutation, you first call `usePlaceCateringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceCateringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeCateringOrderMutation, { data, loading, error }] = usePlaceCateringOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaceCateringOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPlaceCateringOrderMutation, IPlaceCateringOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<IPlaceCateringOrderMutation, IPlaceCateringOrderMutationVariables>(PlaceCateringOrderDocument, baseOptions);
      }
export type PlaceCateringOrderMutationHookResult = ReturnType<typeof usePlaceCateringOrderMutation>;
export type PlaceCateringOrderMutationResult = ApolloReactCommon.MutationResult<IPlaceCateringOrderMutation>;
export type PlaceCateringOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<IPlaceCateringOrderMutation, IPlaceCateringOrderMutationVariables>;
export const GetPrepaidsBalanceDocument = gql`
    mutation GetPrepaidsBalance($cardNumber: String!, $feCountryCode: IsoCountryCode!) @authRequired {
  prepaidsBalance(cardNumber: $cardNumber, feCountryCode: $feCountryCode) {
    currentBalance
  }
}
    `;
export type IGetPrepaidsBalanceMutationFn = ApolloReactCommon.MutationFunction<IGetPrepaidsBalanceMutation, IGetPrepaidsBalanceMutationVariables>;

/**
 * __useGetPrepaidsBalanceMutation__
 *
 * To run a mutation, you first call `useGetPrepaidsBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPrepaidsBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPrepaidsBalanceMutation, { data, loading, error }] = useGetPrepaidsBalanceMutation({
 *   variables: {
 *      cardNumber: // value for 'cardNumber'
 *      feCountryCode: // value for 'feCountryCode'
 *   },
 * });
 */
export function useGetPrepaidsBalanceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IGetPrepaidsBalanceMutation, IGetPrepaidsBalanceMutationVariables>) {
        return ApolloReactHooks.useMutation<IGetPrepaidsBalanceMutation, IGetPrepaidsBalanceMutationVariables>(GetPrepaidsBalanceDocument, baseOptions);
      }
export type GetPrepaidsBalanceMutationHookResult = ReturnType<typeof useGetPrepaidsBalanceMutation>;
export type GetPrepaidsBalanceMutationResult = ApolloReactCommon.MutationResult<IGetPrepaidsBalanceMutation>;
export type GetPrepaidsBalanceMutationOptions = ApolloReactCommon.BaseMutationOptions<IGetPrepaidsBalanceMutation, IGetPrepaidsBalanceMutationVariables>;
export const MergePrepaidsDocument = gql`
    mutation MergePrepaids($input: PrepaidsMergeInput!) @authRequired {
  prepaidsMerge(input: $input) {
    currentBalance
  }
}
    `;
export type IMergePrepaidsMutationFn = ApolloReactCommon.MutationFunction<IMergePrepaidsMutation, IMergePrepaidsMutationVariables>;

/**
 * __useMergePrepaidsMutation__
 *
 * To run a mutation, you first call `useMergePrepaidsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergePrepaidsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergePrepaidsMutation, { data, loading, error }] = useMergePrepaidsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergePrepaidsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IMergePrepaidsMutation, IMergePrepaidsMutationVariables>) {
        return ApolloReactHooks.useMutation<IMergePrepaidsMutation, IMergePrepaidsMutationVariables>(MergePrepaidsDocument, baseOptions);
      }
export type MergePrepaidsMutationHookResult = ReturnType<typeof useMergePrepaidsMutation>;
export type MergePrepaidsMutationResult = ApolloReactCommon.MutationResult<IMergePrepaidsMutation>;
export type MergePrepaidsMutationOptions = ApolloReactCommon.BaseMutationOptions<IMergePrepaidsMutation, IMergePrepaidsMutationVariables>;
export const GetMeDocument = gql`
    query GetMe($numUniquePurchasedItems: Int, $customInput: MeInput) @authRequired {
  me(numUniquePurchasedItems: $numUniquePurchasedItems, customInput: $customInput) {
    thLegacyCognitoId
    cognitoId
    details {
      ...DetailsFragment
    }
    loyaltyId
    uniquePurchasedItems {
      name
      image
      lineId
      sanityId
      quantity
      type
      price
      url
      pickerSelections
      vendorConfigs {
        ...VendorConfigsFragment
      }
      children {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
                children {
                  ...CartEntryFragment
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DetailsFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}
${CartEntryFragmentFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *      numUniquePurchasedItems: // value for 'numUniquePurchasedItems'
 *      customInput: // value for 'customInput'
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetMeQuery, IGetMeQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetMeQuery, IGetMeQueryVariables>(GetMeDocument, baseOptions);
      }
export function useGetMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetMeQuery, IGetMeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetMeQuery, IGetMeQueryVariables>(GetMeDocument, baseOptions);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = ApolloReactCommon.QueryResult<IGetMeQuery, IGetMeQueryVariables>;
export const KioskSignInUserDocument = gql`
    mutation kioskSignInUser($input: SignInUserInput!) {
  kioskSignIn(userInfo: $input) {
    decryptedCode
    sessionId
  }
}
    `;
export type IKioskSignInUserMutationFn = ApolloReactCommon.MutationFunction<IKioskSignInUserMutation, IKioskSignInUserMutationVariables>;

/**
 * __useKioskSignInUserMutation__
 *
 * To run a mutation, you first call `useKioskSignInUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKioskSignInUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kioskSignInUserMutation, { data, loading, error }] = useKioskSignInUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKioskSignInUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IKioskSignInUserMutation, IKioskSignInUserMutationVariables>) {
        return ApolloReactHooks.useMutation<IKioskSignInUserMutation, IKioskSignInUserMutationVariables>(KioskSignInUserDocument, baseOptions);
      }
export type KioskSignInUserMutationHookResult = ReturnType<typeof useKioskSignInUserMutation>;
export type KioskSignInUserMutationResult = ApolloReactCommon.MutationResult<IKioskSignInUserMutation>;
export type KioskSignInUserMutationOptions = ApolloReactCommon.BaseMutationOptions<IKioskSignInUserMutation, IKioskSignInUserMutationVariables>;
import { disableFragmentWarnings } from 'graphql-tag';
disableFragmentWarnings();
